/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
(function (
  bodyScrollLock,
  themeAddresses,
  themeCurrency,
  Flickity,
  FlickityFade,
  Rellax,
  MicroModal,
  themeImages
) {
  "use strict";

  function floatLabels(e) {
    e.querySelectorAll(".form-field").forEach((e) => {
      const t = e.querySelector("label"),
        s = e.querySelector("input, textarea");
      t &&
        s &&
        (s.addEventListener("keyup", (e) => {
          "" !== e.target.value
            ? t.classList.add("label--float")
            : t.classList.remove("label--float");
        }),
        s.value && s.value.length && t.classList.add("label--float"));
    });
  }
  (window.theme = window.theme || {}),
    (window.theme.sizes = {
      mobile: 480,
      small: 750,
      large: 990,
      widescreen: 1400,
    }),
    (window.theme.keyboardKeys = {
      TAB: "Tab",
      ENTER: "Enter",
      ESCAPE: "Escape",
      SPACE: "Space",
      LEFTARROW: "ArrowLeft",
      RIGHTARROW: "ArrowRight",
    }),
    (window.theme.focusable =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  let screenOrientation = getScreenOrientation();

  function readHeights() {
    const e = {};
    return (
      (e.windowHeight = Math.min(window.screen.height, window.innerHeight)),
      (e.announcementHeight = getHeight(
        '[data-section-type*="announcement"] [data-bar-top]'
      )),
      (e.footerHeight = getHeight('[data-section-type*="footer"]')),
      (e.menuHeight = getHeight("[data-header-height]")),
      (e.headerHeight = e.menuHeight + e.announcementHeight),
      (e.collectionNavHeight = getHeight("[data-collection-nav]")),
      (e.logoHeight = getFooterLogoWithPadding()),
      e
    );
  }

  function setVarsOnResize() {
    document.addEventListener("theme:resize", resizeVars), setVars();
  }

  function setVars() {
    const {
        windowHeight: e,
        announcementHeight: t,
        headerHeight: s,
        logoHeight: i,
        menuHeight: o,
        footerHeight: r,
        collectionNavHeight: n,
      } = readHeights(),
      a = document.querySelector(
        "[data-newsletter-holder].newsletter--top-left"
      );
    document.documentElement.style.setProperty("--full-screen", `${e}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        e * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        e * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", e / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", e / 3 + "px"),
      document.documentElement.style.setProperty("--menu-height", `${o}px`),
      document.documentElement.style.setProperty(
        "--announcement-height",
        `${t}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${s}px`),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${n}px`
      ),
      document.documentElement.style.setProperty("--footer-height", `${r}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        e - s - i / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        e - s - r + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          `${
            document.querySelector(
              "[data-tracking-consent].popup-cookies--bottom"
            ).offsetHeight
          }px`
        ),
      document.documentElement.style.setProperty(
        "--newsletter-small-height",
        a ? `${a.offsetHeight}px` : "0px"
      ),
      document.documentElement.style.setProperty(
        "--scrollbar-width",
        `${getScrollbarWidth()}px`
      );
  }

  function resizeVars() {
    const {
        windowHeight: e,
        announcementHeight: t,
        headerHeight: s,
        logoHeight: i,
        menuHeight: o,
        footerHeight: r,
        collectionNavHeight: n,
      } = readHeights(),
      a = document.querySelector(
        "[data-newsletter-holder].newsletter--top-left"
      ),
      l = getScreenOrientation();
    l !== screenOrientation &&
      (document.documentElement.style.setProperty("--full-screen", `${e}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        e * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        e * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", e / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", e / 3 + "px"),
      (screenOrientation = l)),
      document.documentElement.style.setProperty("--menu-height", `${o}px`),
      document.documentElement.style.setProperty(
        "--announcement-height",
        `${t}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${s}px`),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${n}px`
      ),
      document.documentElement.style.setProperty("--footer-height", `${r}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        e - s - i / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        e - s - r + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          `${
            document.querySelector(
              "[data-tracking-consent].popup-cookies--bottom"
            ).offsetHeight
          }px`
        ),
      document.documentElement.style.setProperty(
        "--newsletter-small-height",
        a ? `${a.offsetHeight}px` : "0px"
      );
  }

  function getScreenOrientation() {
    return window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : window.matchMedia("(orientation: landscape)").matches
      ? "landscape"
      : void 0;
  }

  function getHeight(e) {
    const t = document.querySelector(e);
    return t ? t.offsetHeight : 0;
  }

  function getFooterLogoWithPadding() {
    const e = getHeight("[data-footer-logo]");
    return e > 0 ? e + 20 : 0;
  }

  function getScrollbarWidth() {
    const e = document.createElement("div");
    (e.style.visibility = "hidden"),
      (e.style.overflow = "scroll"),
      (e.style.msOverflowStyle = "scrollbar"),
      document.body.appendChild(e);
    const t = document.createElement("div");
    e.appendChild(t);
    const s = e.offsetWidth - t.offsetWidth;
    return e.parentNode.removeChild(e), s;
  }
  window.initialWindowHeight = Math.min(
    window.screen.height,
    window.innerHeight
  );
  let isCompleted = !1,
    docComplete = !1;

  function preloadImages() {
    (document.onreadystatechange = () => {
      "complete" === document.readyState &&
        ((docComplete = !0), initImagesPreloader());
    }),
      requestIdleCallback(initImagesPreloader);
  }

  function initImagesPreloader() {
    setTimeout(() => {
      if (isCompleted) return;
      if (!docComplete) return void initImagesPreloader();
      const e = document.querySelectorAll('img[loading="lazy"]');
      e.length &&
        e.forEach((e) => {
          e.setAttribute("loading", "eager");
        }),
        (isCompleted = !0);
    }, 3e3);
  }

  function singles(e, t) {
    let s = 64,
      i = 0;
    t.forEach((e) => {
      if (e.offsetHeight > i) {
        const t =
          parseInt(window.getComputedStyle(e).marginTop) +
          parseInt(window.getComputedStyle(e).marginBottom);
        t > s && (s = t), (i = e.offsetHeight);
      }
    });
    const o = e.querySelectorAll("[data-overflow-background]");
    [e, ...o].forEach((e) => {
      e.style.setProperty(
        "min-height",
        `calc(${i + s}px + var(--header-padding))`
      );
    });
  }

  function doubles(e) {
    if (
      (window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth) < window.theme.sizes.small
    ) {
      return void e.querySelectorAll("[data-overflow-frame]").forEach((e) => {
        const t = e.querySelectorAll("[data-overflow-content]");
        singles(e, t);
      });
    }
    const t = 2 * parseInt(getComputedStyle(e).getPropertyValue("--outer"));
    let s = 0,
      i = 0;
    const o = e.querySelectorAll("[data-overflow-frame]");
    o &&
      (i =
        parseInt(window.getComputedStyle(o[0]).borderTopWidth) +
        parseInt(window.getComputedStyle(o[0]).borderBottomWidth));
    e.querySelectorAll("[data-overflow-content]").forEach((e) => {
      e.offsetHeight > s && (s = e.offsetHeight);
    });
    const r = e.querySelectorAll("[data-overflow-background]");
    [...o, ...r].forEach((e) => {
      e.style.setProperty("min-height", `${s + t}px`);
    }),
      e.style.setProperty("min-height", `${s + t + i}px`);
  }

  function preventOverflow(e) {
    const t = e.querySelectorAll(".js-overflow-container");
    t &&
      t.forEach((e) => {
        const t = e.querySelectorAll(".js-overflow-content");
        singles(e, t),
          document.addEventListener("theme:resize", () => {
            singles(e, t);
          });
      });
    const s = e.querySelectorAll("[data-overflow-wrapper]");
    s &&
      s.forEach((e) => {
        doubles(e),
          document.addEventListener("theme:resize", () => {
            doubles(e);
          });
      });
  }

  function debounce(e, t) {
    let s;
    return function () {
      if (e) {
        const i = () => e.apply(this, arguments);
        clearTimeout(s), (s = setTimeout(i, t));
      }
    };
  }
  let lastWindowWidth = window.innerWidth,
    lastWindowHeight = window.innerHeight;

  function dispatch$1() {
    document.dispatchEvent(
      new CustomEvent("theme:resize", {
        bubbles: !0,
      })
    ),
      lastWindowWidth !== window.innerWidth &&
        (document.dispatchEvent(
          new CustomEvent("theme:resize:width", {
            bubbles: !0,
          })
        ),
        (lastWindowWidth = window.innerWidth)),
      lastWindowHeight !== window.innerHeight &&
        (document.dispatchEvent(
          new CustomEvent("theme:resize:height", {
            bubbles: !0,
          })
        ),
        (lastWindowHeight = window.innerHeight));
  }

  function resizeListener() {
    window.addEventListener(
      "resize",
      debounce(function () {
        dispatch$1();
      }, 50)
    );
  }
  let prev = window.pageYOffset,
    up = null,
    down = null,
    wasUp = null,
    wasDown = null,
    scrollLockTimeout = 0,
    scrollPosition = 0,
    targetElement = null;

  function dispatch() {
    const e = window.pageYOffset;
    e > prev
      ? ((down = !0), (up = !1))
      : e < prev
      ? ((down = !1), (up = !0))
      : ((up = null), (down = null)),
      (prev = e),
      document.dispatchEvent(
        new CustomEvent("theme:scroll", {
          detail: {
            up: up,
            down: down,
            position: e,
          },
          bubbles: !1,
        })
      ),
      up &&
        !wasUp &&
        document.dispatchEvent(
          new CustomEvent("theme:scroll:up", {
            detail: {
              position: e,
            },
            bubbles: !1,
          })
        ),
      down &&
        !wasDown &&
        document.dispatchEvent(
          new CustomEvent("theme:scroll:down", {
            detail: {
              position: e,
            },
            bubbles: !1,
          })
        ),
      (wasDown = down),
      (wasUp = up);
  }

  function lock(e) {
    (targetElement = e.detail),
      bodyScrollLock.disableBodyScroll(targetElement, {
        allowTouchMove: (e) => {
          for (; e && e !== document.body; ) {
            if (
              null !== e.getAttribute("body-scroll-lock-ignore") ||
              null !== e.getAttribute("data-popout-list") ||
              "TEXTAREA" === e.tagName
            )
              return !0;
            e = e.parentElement;
          }
        },
      }),
      document.documentElement.hasAttribute("data-scroll-locked") ||
        ((scrollPosition = window.scrollY),
        document.documentElement.style.setProperty("scroll-behavior", "auto"),
        requestAnimationFrame(() => {
          document.documentElement.setAttribute("data-scroll-locked", ""),
            document.body.style.setProperty(
              "--scroll-top-position",
              `-${scrollPosition}px`
            ),
            document.documentElement.style.removeProperty("scroll-behavior");
        }));
  }

  function unlock() {
    if (
      ((scrollLockTimeout = setTimeout(() => {
        document.body.removeAttribute("data-drawer-closing");
      }, 20)),
      document.body.hasAttribute("data-drawer-closing"))
    )
      return (
        document.body.removeAttribute("data-drawer-closing"),
        void (scrollLockTimeout && clearTimeout(scrollLockTimeout))
      );
    document.body.setAttribute("data-drawer-closing", ""),
      bodyScrollLock.clearAllBodyScrollLocks(),
      document.documentElement.removeAttribute("data-scroll-locked"),
      document.documentElement.style.setProperty("scroll-behavior", "auto"),
      window.scrollTo({
        top: scrollPosition,
        behavior: "auto",
      }),
      document.documentElement.style.removeProperty("scroll-behavior");
  }

  function scrollListener() {
    let e;
    window.addEventListener(
      "scroll",
      function () {
        e && window.cancelAnimationFrame(e),
          (e = window.requestAnimationFrame(function () {
            dispatch();
          }));
      },
      {
        passive: !0,
      }
    ),
      window.addEventListener("theme:scroll:lock", lock),
      window.addEventListener("theme:scroll:unlock", unlock);
  }
  const wrap = (e, t = "", s) => {
    const i = s || document.createElement("div");
    return (
      i.classList.add(t), e.parentNode.insertBefore(i, e), i.appendChild(e)
    );
  };

  function wrapElements(e) {
    e.querySelectorAll(".rte table").forEach((e) => {
      wrap(e, "rte__table-wrapper");
    });
    e.querySelectorAll(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
    ).forEach((e) => {
      wrap(e, "rte__video-wrapper");
    });
  }

  function isTouchDevice() {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  }

  function isTouch() {
    isTouchDevice()
      ? ((document.documentElement.className =
          document.documentElement.className.replace(
            "no-touch",
            "supports-touch"
          )),
        (window.theme.touch = !0))
      : (window.theme.touch = !1);
  }

  function ariaToggle(e) {
    const t = e.querySelectorAll("[data-aria-toggle]");
    t.length &&
      t.forEach((e) => {
        e.addEventListener("click", function (e) {
          e.preventDefault();
          const t = e.currentTarget;
          t.setAttribute(
            "aria-expanded",
            "false" == t.getAttribute("aria-expanded") ? "true" : "false"
          );
          const s = t.getAttribute("aria-controls"),
            i = document.querySelector(`#${s}`),
            o = () => {
              i.classList.remove("expanding"),
                i.removeEventListener("transitionend", o);
            },
            r = () => {
              i.classList.add("expanding"),
                i.removeEventListener("transitionstart", r);
            };
          i.addEventListener("transitionstart", r),
            i.addEventListener("transitionend", o),
            i.classList.toggle("expanded");
        });
      });
  }

  function loading() {
    document.body.classList.add("is-loaded");
  }
  const classes$J = {
      loading: "is-loading",
    },
    selectors$W = {
      img: "img.is-loading",
    };

  function loadedImagesEventHook() {
    document.addEventListener(
      "load",
      (e) => {
        "IMG" == e.target.tagName &&
          e.target.classList.contains(classes$J.loading) &&
          (e.target.classList.remove(classes$J.loading),
          e.target.parentNode.classList.remove(classes$J.loading));
      },
      !0
    );
  }

  function removeLoadingClassFromLoadedImages(e) {
    e.querySelectorAll(selectors$W.img).forEach((e) => {
      e.complete &&
        (e.classList.remove(classes$J.loading),
        e.parentNode.classList.remove(classes$J.loading));
    });
  }
  const selectors$V = {
      aos: "[data-aos]:not(.aos-animate)",
      aosAnchor: "[data-aos-anchor]",
    },
    classes$I = {
      aosAnimate: "aos-animate",
    },
    observerConfig = {
      attributes: !1,
      childList: !0,
      subtree: !0,
    },
    mutationCallback = (e) => {
      for (const t of e)
        if ("childList" === t.type) {
          const e = t.target,
            s = e.querySelectorAll(selectors$V.aos),
            i = e.querySelectorAll(selectors$V.aosAnchor);
          s.length &&
            s.forEach((e) => {
              aosItemObserver.observe(e);
            }),
            i.length && initAnchorObservers(i);
        }
    },
    aosItemObserver = new IntersectionObserver(
      (e, t) => {
        e.forEach((e) => {
          e.isIntersecting &&
            (e.target.classList.add(classes$I.aosAnimate),
            t.unobserve(e.target));
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
      }
    ),
    aosAnchorObserver = new IntersectionObserver(
      (e, t) => {
        e.forEach((e) => {
          if (e.intersectionRatio > 0.1) {
            const s = e.target.querySelectorAll(selectors$V.aos);
            s.length &&
              s.forEach((e) => {
                e.classList.add(classes$I.aosAnimate);
              }),
              t.unobserve(e.target);
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: [0.1, 0.25, 0.5, 0.75, 1],
      }
    );

  function bodyMutationObserver() {
    new MutationObserver(mutationCallback).observe(
      document.body,
      observerConfig
    );
  }

  function elementsIntersectionObserver() {
    const e = document.querySelectorAll(selectors$V.aos);
    e.length &&
      e.forEach((e) => {
        aosItemObserver.observe(e);
      });
  }
  try {
    function anchorsIntersectionObserver() {
      const e = document.querySelectorAll(selectors$V.aosAnchor);
      e.length && initAnchorObservers(e);
    }
  } catch (er) {
    console.log(er);
  }
  try {
    function initAnchorObservers(e) {
      let t = [];
      e.length &&
        e.forEach((e) => {
          const s = e.dataset.aosAnchor;
          if (-1 === t.indexOf(s)) {
            const e = document.querySelector(s);
            aosAnchorObserver.observe(e), t.push(s);
          }
        });
    }

    function initAnimations() {
      elementsIntersectionObserver(),
        anchorsIntersectionObserver(),
        bodyMutationObserver();
    }

    (window.requestIdleCallback =
      window.requestIdleCallback ||
      function (e) {
        var t = Date.now();
        return setTimeout(function () {
          e({
            didTimeout: !1,
            timeRemaining: function () {
              return Math.max(0, 50 - (Date.now() - t));
            },
          });
        }, 1);
      }),
      (window.cancelIdleCallback =
        window.cancelIdleCallback ||
        function (e) {
          clearTimeout(e);
        }),
      window.theme.settings.enableAnimations && initAnimations(),
      resizeListener(),
      scrollListener(),
      isTouch(),
      setVars(),
      loadedImagesEventHook(),
      window.addEventListener("DOMContentLoaded", () => {
        setVarsOnResize(),
          ariaToggle(document),
          floatLabels(document),
          preventOverflow(document),
          wrapElements(document),
          removeLoadingClassFromLoadedImages(document),
          loading(),
          window.fastNetworkAndCPU && preloadImages();
      }),
      document.addEventListener("shopify:section:load", (e) => {
        const t = e.target;
        floatLabels(t),
          preventOverflow(t),
          wrapElements(t),
          ariaToggle(document),
          setVarsOnResize();
      }),
      (function () {
        function e(e) {
          var t = window.innerWidth || document.documentElement.clientWidth,
            s = window.innerHeight || document.documentElement.clientHeight,
            i = e.getBoundingClientRect();
          return i.top >= 0 && i.bottom <= s && i.left >= 0 && i.right <= t;
        }

        function t(e) {
          var t = window.innerWidth || document.documentElement.clientWidth,
            s = window.innerHeight || document.documentElement.clientHeight,
            i = e.getBoundingClientRect(),
            o = (i.left >= 0 && i.left <= t) || (i.right >= 0 && i.right <= t),
            r = (i.top >= 0 && i.top <= s) || (i.bottom >= 0 && i.bottom <= s);
          return o && r;
        }
        window.visibilityHelper = {
          isElementTotallyVisible: e,
          isElementPartiallyVisible: t,
          inViewportPartially: function (e, s) {
            function i() {
              var i = t(e);
              i != o && ((o = i), "function" == typeof s && s(i, e));
            }
            var o = t(e);
            window.addEventListener("load", i),
              window.addEventListener("resize", i),
              window.addEventListener("scroll", i);
          },
          inViewportTotally: function (t, s) {
            function i() {
              var i = e(t);
              i != o && ((o = i), "function" == typeof s && s(i, t));
            }
            var o = e(t);
            window.addEventListener("load", i),
              window.addEventListener("resize", i),
              window.addEventListener("scroll", i);
          },
        };
      })();
  } catch (er) {
    console.log(er);
  }
  const showElement = (e, t = !1, s = "block") => {
    e && (t ? e.style.removeProperty("display") : (e.style.display = s));
  };
  Shopify.Products = (function () {
    const e = {
      howManyToShow: 4,
      howManyToStoreInMemory: 10,
      wrapperId: "recently-viewed-products",
      section: null,
      onComplete: null,
    };
    let t = [],
      s = null,
      i = null;
    const o = {
        configuration: {
          expires: 90,
          path: "/",
          domain: window.location.hostname,
        },
        name: "shopify_recently_viewed",
        write: function (e) {
          const t = e.join(" ");
          document.cookie = `${this.name}=${t}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
        },
        read: function () {
          let e = [],
            t = null;
          const s = document.querySelector("#template-product");
          if (
            (-1 !== document.cookie.indexOf("; ") &&
              document.cookie
                .split("; ")
                .find((e) => e.startsWith(this.name)) &&
              (t = document.cookie
                .split("; ")
                .find((e) => e.startsWith(this.name))
                .split("=")[1]),
            null !== t && (e = t.split(" ")),
            s)
          ) {
            const t = s.getAttribute("data-product-handle");
            if (-1 != e.indexOf(t)) {
              const s = e.indexOf(t);
              e.splice(s, 1);
            }
          }
          return e;
        },
        destroy: function () {
          document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
        },
        remove: function (e) {
          const t = this.read(),
            s = t.indexOf(e);
          -1 !== s && (t.splice(s, 1), this.write(t));
        },
      },
      r = (t, s, n, a) => {
        s.length && t < e.howManyToShow
          ? fetch(
              `${window.theme.routes.root}products/${s[0]}?section_id=api-product-grid-item`
            )
              .then((e) => e.text())
              .then((e) => {
                const i = 150 * t,
                  o = 100 * t + 800,
                  l = 50 * t + 800,
                  c = n.id ? `#${n.id}` : "",
                  d = document.createElement("div");
                let h = e.includes("||itemIndex||")
                  ? e.replaceAll("||itemIndex||", t)
                  : e;
                (h = h.includes("||itemAosDelay||")
                  ? h.replaceAll("||itemAosDelay||", i)
                  : h),
                  (h = h.includes("||itemAosImageDuration||")
                    ? h.replaceAll("||itemAosImageDuration||", o)
                    : h),
                  (h = h.includes("||itemAosTextDuration||")
                    ? h.replaceAll("||itemAosTextDuration||", l)
                    : h),
                  (h = h.includes("||itemAnimationAnchor||")
                    ? h.replaceAll("||itemAnimationAnchor||", c)
                    : h),
                  (d.innerHTML = h),
                  (n.innerHTML +=
                    d.querySelector("[data-api-content]").innerHTML),
                  s.shift(),
                  t++,
                  r(t, s, n, a);
              })
              .catch(() => {
                o.remove(s[0]), s.shift(), r(t, s, n, a);
              })
          : ((t, s) => {
              showElement(t, !0);
              const r = o.read().length;
              if (
                Shopify.recentlyViewed &&
                i &&
                r &&
                r < i &&
                t.children.length
              ) {
                let e = [],
                  s = [],
                  i = 0;
                for (const t in Shopify.recentlyViewed) {
                  i += 1;
                  const r = Shopify.recentlyViewed[t].split(" "),
                    n = parseInt(t.split("_")[1]);
                  (e = [...e, ...r]),
                    (o.read().length === n ||
                      (i === Object.keys(Shopify.recentlyViewed).length &&
                        !s.length)) &&
                      (s = [...s, ...r]);
                }
                for (let i = 0; i < t.children.length; i++) {
                  const o = t.children[i];
                  e.length && o.classList.remove(...e),
                    s.length && o.classList.add(...s);
                }
              }
              if (e.onComplete)
                try {
                  e.onComplete(t, s);
                } catch (e) {
                  console.log(e);
                }
            })(n, a);
      };
    return {
      showRecentlyViewed: function (n) {
        const a = n || {};
        Object.assign(e, a),
          (t = o.read()),
          (s = document.querySelector(`#${e.wrapperId}`)),
          (i = e.howManyToShow),
          (e.howManyToShow = Math.min(t.length, e.howManyToShow)),
          e.howManyToShow && s && r(0, t, s, e.section);
      },
      getConfig: function () {
        return e;
      },
      clearList: function () {
        o.destroy();
      },
      recordRecentlyViewed: function (t) {
        const s = t || {};
        Object.assign(e, s);
        let i = o.read();
        if (-1 !== window.location.pathname.indexOf("/products/")) {
          let t = decodeURIComponent(window.location.pathname)
            .match(
              /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
            )[0]
            .split("/products/")[1];
          e.handle && (t = e.handle);
          const s = i.indexOf(t);
          -1 === s
            ? (i.unshift(t), (i = i.splice(0, e.howManyToStoreInMemory)))
            : (i.splice(s, 1), i.unshift(t)),
            o.write(i);
        }
      },
      hasProducts: o.read().length > 0,
    };
  })();
  const getUrlString = (e, t = [], s = !1) => {
      const i = Object.keys(e)
        .map((i) => {
          let o = e[i];
          if (
            "[object Object]" === Object.prototype.toString.call(o) ||
            Array.isArray(o)
          )
            return (
              Array.isArray(e) ? t.push("") : t.push(i),
              getUrlString(o, t, Array.isArray(o))
            );
          {
            let e = i;
            if (t.length > 0) {
              e = (s ? t : [...t, i]).reduce(
                (e, t) => ("" === e ? t : `${e}[${t}]`),
                ""
              );
            }
            return s ? `${e}[]=${o}` : `${e}=${o}`;
          }
        })
        .join("&");
      return t.pop(), i;
    },
    hideElement = (e) => {
      e && (e.style.display = "none");
    },
    fadeIn = (e, t, s = null) => {
      (e.style.opacity = 0), (e.style.display = t || "block");
      let i = !0;
      !(function t() {
        let o = parseFloat(e.style.opacity);
        (o += 0.1) > 1 || ((e.style.opacity = o), requestAnimationFrame(t)),
          1 === parseInt(o) && i && "function" == typeof s && ((i = !1), s());
      })();
    };

  function isVisible(e) {
    var t = window.getComputedStyle(e);
    return "none" !== t.display && "hidden" !== t.visibility;
  }

  function forceFocus(e, t) {
    t = t || {};
    var s = e.tabIndex;
    (e.tabIndex = -1),
      (e.dataset.tabIndex = s),
      e.focus(),
      void 0 !== t.className && e.classList.add(t.className),
      e.addEventListener("blur", function i(o) {
        o.target.removeEventListener(o.type, i),
          (e.tabIndex = s),
          delete e.dataset.tabIndex,
          void 0 !== t.className && e.classList.remove(t.className);
      });
  }

  function focusHash(e) {
    e = e || {};
    var t = window.location.hash,
      s = document.getElementById(t.slice(1));
    if (s && e.ignore && s.matches(e.ignore)) return !1;
    t && s && forceFocus(s, e);
  }

  function bindInPageLinks(e) {
    return (
      (e = e || {}),
      Array.prototype.slice
        .call(document.querySelectorAll('a[href^="#"]'))
        .filter(function (t) {
          if ("#" === t.hash || "" === t.hash) return !1;
          if (e.ignore && t.matches(e.ignore)) return !1;
          if (((s = t.hash.substr(1)), null === document.getElementById(s)))
            return !1;
          var s,
            i = document.querySelector(t.hash);
          return (
            !!i &&
            (t.addEventListener("click", function () {
              forceFocus(i, e);
            }),
            !0)
          );
        })
    );
  }

  function focusable(e) {
    return Array.prototype.slice
      .call(
        e.querySelectorAll(
          "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
        )
      )
      .filter(function (e) {
        return !(
          !(e.offsetWidth || e.offsetHeight || e.getClientRects().length) ||
          !isVisible(e)
        );
      });
  }
  void 0 === Shopify.Cart && (Shopify.Cart = {}),
    (Shopify.Cart.ShippingCalculator = (function () {
      const _config = {
          submitButton: theme.strings.shippingCalcSubmitButton,
          submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
          templateId: "shipping-calculator-response-template",
          wrapperId: "wrapper-response",
          customerIsLoggedIn: !1,
        },
        _render = function (e) {
          const t = document.querySelector(`#${_config.templateId}`),
            s = document.querySelector(`#${_config.wrapperId}`);
          if (t && s) {
            s.innerHTML = "";
            let i = "",
              o = "",
              r = "error center",
              n = t.innerHTML;
            const a = /[^[\]]+(?=])/g;
            if (e.rates && e.rates.length) {
              let t = a.exec(n)[0];
              e.rates.forEach((e) => {
                let s = t;
                (s = s.replace(/\|\|rateName\|\|/, e.name)),
                  (s = s.replace(
                    /\|\|ratePrice\|\|/,
                    Shopify.Cart.ShippingCalculator.formatRate(e.price)
                  )),
                  (i += s);
              });
            }
            if (e.success) {
              r = "success center";
              const s = document.createElement("div");
              s.innerHTML = t.innerHTML;
              const i = s.querySelector("[data-template-no-shipping]");
              e.rates.length < 1 &&
                i &&
                (o = i.getAttribute("data-template-no-shipping"));
            } else o = e.errorFeedback;
            (n = n.replace(a, "").replace("[]", "")),
              (n = n.replace(/\|\|ratesList\|\|/g, i)),
              (n = n.replace(/\|\|successClass\|\|/g, r)),
              (n = n.replace(/\|\|ratesText\|\|/g, o)),
              (s.innerHTML += n);
          }
        },
        _enableButtons = function () {
          const e = document.querySelector(".get-rates");
          e.removeAttribute("disabled"),
            e.classList.remove("disabled"),
            (e.value = _config.submitButton);
        },
        _disableButtons = function () {
          const e = document.querySelector(".get-rates");
          e.setAttribute("disabled", "disabled"),
            e.classList.add("disabled"),
            (e.value = _config.submitButtonDisabled);
        },
        _getCartShippingRatesForDestination = function (e) {
          const t = encodeURI(
              getUrlString({
                shipping_address: e,
              })
            ),
            s = `${window.theme.routes.cart}/shipping_rates.json?${t}`,
            i = new XMLHttpRequest();
          i.open("GET", s, !0),
            (i.onload = function () {
              if (this.status >= 200 && this.status < 400) {
                const t = JSON.parse(this.response).shipping_rates;
                _onCartShippingRatesUpdate(t, e);
              } else _onError(this);
            }),
            (i.onerror = function () {
              _onError(this);
            }),
            i.send();
        },
        _fullMessagesFromErrors = function (e) {
          const t = [];
          for (const s in e) for (const i of e[s]) t.push(s + " " + i);
          return t;
        },
        _onError = function (XMLHttpRequest) {
          hideElement(document.querySelector("#estimated-shipping"));
          const shippingChild = document.querySelector(
            "#estimated-shipping em"
          );
          if (shippingChild)
            for (; shippingChild.firstChild; )
              shippingChild.removeChild(shippingChild.firstChild);
          _enableButtons();
          let feedback = "";
          const data = eval("(" + XMLHttpRequest.responseText + ")");
          (feedback = data.message
            ? data.message + "(" + data.status + "): " + data.description
            : "Error : " + _fullMessagesFromErrors(data).join("; ")),
            "Error : country is not supported." === feedback &&
              (feedback = "We do not ship to this destination."),
            _render({
              rates: [],
              errorFeedback: feedback,
              success: !1,
            }),
            showElement(document.querySelector(`#${_config.wrapperId}`));
        },
        _onCartShippingRatesUpdate = function (e, t) {
          _enableButtons();
          let s = "";
          t.zip && (s += t.zip + ", "),
            t.province && (s += t.province + ", "),
            (s += t.country);
          const i = document.querySelector("#estimated-shipping em");
          e.length &&
            i &&
            (i.textContent =
              "0.00" == e[0].price
                ? window.theme.strings.free
                : themeCurrency.formatMoney(e[0].price, theme.moneyFormat)),
            _render({
              rates: e,
              address: s,
              success: !0,
            });
          const o = document.querySelectorAll(
            `#${_config.wrapperId}, #estimated-shipping`
          );
          o.length &&
            o.forEach((e) => {
              fadeIn(e);
            });
        },
        _init = function () {
          const e = document.querySelector(".get-rates"),
            t = document.querySelector("#address_container"),
            s = document.querySelector("#address_country"),
            i = document.querySelector("#address_province"),
            o = document.querySelector("html");
          let r = "en";
          if (
            (o.hasAttribute("lang") &&
              "" !== o.getAttribute("lang") &&
              (r = o.getAttribute("lang")),
            t &&
              themeAddresses.AddressForm(t, r, {
                shippingCountriesOnly: !0,
              }),
            s &&
              s.hasAttribute("data-default") &&
              i &&
              i.hasAttribute("data-default") &&
              s.addEventListener("change", function () {
                s.removeAttribute("data-default"),
                  i.removeAttribute("data-default");
              }),
            e &&
              (e.addEventListener("click", function (e) {
                _disableButtons();
                const t = document.querySelector(`#${_config.wrapperId}`);
                for (; t.firstChild; ) t.removeChild(t.firstChild);
                hideElement(t);
                const o = {};
                let r = s.value,
                  n = i.value;
                const a = s.getAttribute("data-default-fullname");
                "" === r && a && "" !== a && (r = a);
                const l = i.getAttribute("data-default-fullname");
                "" === n && l && "" !== l && (n = l),
                  (o.zip = document.querySelector("#address_zip").value || ""),
                  (o.country = r || ""),
                  (o.province = n || ""),
                  _getCartShippingRatesForDestination(o);
              }),
              _config.customerIsLoggedIn &&
                e.classList.contains("get-rates--trigger")))
          ) {
            const t = document.querySelector("#address_zip");
            t && t.value && e.dispatchEvent(new Event("click"));
          }
        };
      return {
        show: function (e) {
          (e = e || {}),
            Object.assign(_config, e),
            document.addEventListener("DOMContentLoaded", function () {
              _init();
            });
        },
        getConfig: function () {
          return _config;
        },
        formatRate: function (e) {
          return "0.00" === e
            ? window.theme.strings.free
            : themeCurrency.formatMoney(e, theme.moneyFormat);
        },
      };
    })());
  var trapFocusHandlers = {};

  function trapFocus(e, t) {
    t = t || {};
    var s = focusable(e),
      i = t.elementToFocus || e,
      o = s[0],
      r = s[s.length - 1];
    removeTrapFocus(),
      (trapFocusHandlers.focusin = function (t) {
        e !== t.target &&
          !e.contains(t.target) &&
          o &&
          o === t.target &&
          o.focus(),
          (t.target !== e && t.target !== r && t.target !== o) ||
            document.addEventListener("keydown", trapFocusHandlers.keydown);
      }),
      (trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
      }),
      (trapFocusHandlers.keydown = function (t) {
        t.code === window.theme.keyboardKeys.TAB &&
          (t.target !== r || t.shiftKey || (t.preventDefault(), o.focus()),
          (t.target !== e && t.target !== o) ||
            !t.shiftKey ||
            (t.preventDefault(), r.focus()));
      }),
      document.addEventListener("focusout", trapFocusHandlers.focusout),
      document.addEventListener("focusin", trapFocusHandlers.focusin),
      forceFocus(i, t);
  }

  function removeTrapFocus() {
    document.removeEventListener("focusin", trapFocusHandlers.focusin),
      document.removeEventListener("focusout", trapFocusHandlers.focusout),
      document.removeEventListener("keydown", trapFocusHandlers.keydown);
  }

  function accessibleLinks(e, t) {
    if ("string" != typeof e) throw new TypeError(e + " is not a String.");
    if (0 !== (e = document.querySelectorAll(e)).length) {
      (t = t || {}).messages = t.messages || {};
      var s,
        i,
        o,
        r = {
          newWindow: t.messages.newWindow || "Opens in a new window.",
          external: t.messages.external || "Opens external website.",
          newWindowExternal:
            t.messages.newWindowExternal ||
            "Opens external website in a new window.",
        },
        n = t.prefix || "a11y",
        a = {
          newWindow: n + "-new-window-message",
          external: n + "-external-message",
          newWindowExternal: n + "-new-window-external-message",
        };
      e.forEach(function (e) {
        var t = e.getAttribute("target"),
          s = e.getAttribute("rel"),
          i = (function (e) {
            return e.hostname !== window.location.hostname;
          })(e),
          o = "_blank" === t,
          r = null === s || -1 === s.indexOf("noopener");
        if (o && r) {
          var n = null === s ? "noopener" : s + " noopener";
          e.setAttribute("rel", n);
        }
        i && o
          ? e.setAttribute("aria-describedby", a.newWindowExternal)
          : i
          ? e.setAttribute("aria-describedby", a.external)
          : o && e.setAttribute("aria-describedby", a.newWindow);
      }),
        (s = r),
        (i = document.createElement("ul")),
        (o = Object.keys(s).reduce(function (e, t) {
          return e + "<li id=" + a[t] + ">" + s[t] + "</li>";
        }, "")),
        i.setAttribute("hidden", !0),
        (i.innerHTML = o),
        document.body.appendChild(i);
    }
  }
  var a11y = Object.freeze({
    __proto__: null,
    forceFocus: forceFocus,
    focusHash: focusHash,
    bindInPageLinks: bindInPageLinks,
    focusable: focusable,
    trapFocus: trapFocus,
    removeTrapFocus: removeTrapFocus,
    accessibleLinks: accessibleLinks,
  });

  function FetchError(e) {
    (this.status = e.status || null),
      (this.headers = e.headers || null),
      (this.json = e.json || null),
      (this.body = e.body || null);
  }
  FetchError.prototype = Error.prototype;
  const selectors$U = {
    quantityHolder: "[data-quantity-holder]",
    quantityField: "[data-quantity-field]",
    quantityButton: "[data-quantity-button]",
    quantityMinusButton: "[data-quantity-minus]",
    quantityPlusButton: "[data-quantity-plus]",
    quantityReadOnly: "read-only",
    isDisabled: "is-disabled",
  };
  let QuantityCounter = class {
    init() {
      (this.settings = selectors$U),
        (this.quantity = this.holder.querySelector(
          this.settings.quantityHolder
        )),
        this.quantity &&
          ((this.field = this.quantity.querySelector(
            this.settings.quantityField
          )),
          (this.buttons = this.quantity.querySelectorAll(
            this.settings.quantityButton
          )),
          (this.increaseButton = this.quantity.querySelector(
            this.settings.quantityPlusButton
          )),
          (this.quantityValue = Number(this.field.value || 0)),
          (this.cartItemID = this.field.getAttribute("data-id")),
          (this.maxValue =
            Number(this.field.getAttribute("max")) > 0
              ? Number(this.field.getAttribute("max"))
              : null),
          (this.minValue =
            Number(this.field.getAttribute("min")) > 0
              ? Number(this.field.getAttribute("min"))
              : 0),
          (this.disableIncrease = this.disableIncrease.bind(this)),
          (this.emptyField = !1),
          (this.updateQuantity = this.updateQuantity.bind(this)),
          (this.decrease = this.decrease.bind(this)),
          (this.increase = this.increase.bind(this)),
          this.disableIncrease(),
          this.quantity.classList.contains(this.settings.quantityReadOnly) ||
            (this.changeValueOnClick(), this.changeValueOnInput()));
    }
    changeValueOnClick() {
      const e = this;
      this.buttons.forEach((t) => {
        t.addEventListener("click", (t) => {
          t.preventDefault();
          const s = t.target,
            i =
              s.matches(e.settings.quantityMinusButton) ||
              s.closest(e.settings.quantityMinusButton),
            o =
              s.matches(e.settings.quantityPlusButton) ||
              s.closest(e.settings.quantityPlusButton);
          i && e.decrease(), o && e.increase(), e.updateQuantity();
        });
      });
    }
    changeValueOnInput() {
      this.field.addEventListener("change", () => {
        (this.quantityValue = this.field.value),
          "" === this.field.value && (this.emptyField = !0),
          this.updateQuantity();
      });
    }
    updateQuantity() {
      this.maxValue < this.quantityValue &&
        null !== this.maxValue &&
        (this.quantityValue = this.maxValue),
        this.minValue > this.quantityValue &&
          (this.quantityValue = this.minValue),
        (this.field.value = this.quantityValue),
        this.disableIncrease(),
        this.quantityUpdateCart && this.updateCart();
    }
    decrease() {
      this.quantityValue > this.minValue
        ? this.quantityValue--
        : (this.quantityValue = 0);
    }
    increase() {
      this.quantityValue++;
    }
    disableIncrease() {
      this.increaseButton.classList.toggle(
        this.settings.isDisabled,
        this.quantityValue >= this.maxValue && null !== this.maxValue
      );
    }
    updateCart() {
      const e = new CustomEvent("theme:cart:update", {
        bubbles: !0,
        detail: {
          id: this.cartItemID,
          quantity: this.quantityValue,
          valueIsEmpty: this.emptyField,
        },
      });
      this.holder.dispatchEvent(e);
    }
    constructor(e, t = !1) {
      (this.holder = e), (this.quantityUpdateCart = t);
    }
  };
  const classes$H = {
      animated: "is-animated",
      active: "is-active",
      added: "is-added",
      disabled: "is-disabled",
      error: "has-error",
      headerStuck: "js__header__stuck",
      hidden: "is-hidden",
      hiding: "is-hiding",
      loading: "is-loading",
      open: "is-open",
      removed: "is-removed",
      success: "is-success",
      visible: "is-visible",
      focused: "is-focused",
      expanded: "is-expanded",
      updated: "is-updated",
    },
    selectors$T = {
      apiContent: "[data-api-content]",
      apiLineItems: "[data-api-line-items]",
      apiUpsellItems: "[data-api-upsell-items]",
      animation: "[data-animation]",
      additionalCheckoutButtons: ".additional-checkout-buttons",
      burgerButton: "[data-drawer-toggle]",
      buttonAddToCart: "[data-add-to-cart]",
      buttonQuickAddMobile: "[data-quick-add-btn-mobile]",
      buttonHolder: "[data-foot-holder]",
      buttonSkipUpsellProduct: "[data-skip-upsell-product]",
      cartBarAdd: "[data-add-to-cart-bar]",
      cartCloseError: "[data-cart-error-close]",
      cartDiscountsHolder: "[data-cart-discounts-holder]",
      cartDrawer: "[data-cart-drawer]",
      cartDrawerBody: "[data-cart-drawer-body]",
      cartEmpty: "[data-cart-empty]",
      cartErrors: "[data-cart-errors]",
      cartItemRemove: "[data-item-remove]",
      cartOriginalTotal: "[data-cart-original-total]",
      cartOriginaTotalPrice: "[data-cart-original-total-price]",
      cartPage: "[data-cart-page]",
      cartProgress: "[data-cart-progress]",
      cartProgressBar: "[data-progress-bar]",
      cartToggleElement: "[data-cart-toggle]",
      cartTotal: "[data-cart-total]",
      cartTotalDiscountsTemplate: "[data-cart-total-discount-template]",
      cartTotalDiscountTitle: "[data-cart-discount-title]",
      cartTotalDiscountAmount: "[data-cart-discount-price]",
      cartWidget: "[data-cart-widget]",
      cartWidgetContent: "[data-cart-widget-content]",
      expandButton: "[data-expand-button]",
      errorMessage: "[data-error-message]",
      formCloseError: "[data-close-error]",
      formErrorsContainer: "[data-cart-errors-container]",
      freeShipping: "[data-free-shipping]",
      freeShippingGraph: "[data-progress-graph]",
      freeShippingProgress: "[data-progress-bar]",
      headerWrapper: "[data-header-wrapper]",
      item: "[data-item]",
      itemsHolder: "[data-items-holder]",
      leftToSpend: "[data-left-to-spend]",
      navDrawer: "[data-drawer]",
      outerSection: "[data-section-id]",
      upsellProductsHolder: "[data-upsell-products]",
      quickAddHolder: "[data-quick-add-holder]",
      quickAddModal: "[data-quick-add-modal]",
      qtyInput: "[data-quantity-field]",
    },
    attributes$d = {
      disabled: "disabled",
      quickAddHolder: "data-quick-add-holder",
      quickAddVariant: "data-quick-add-variant",
      freeShipping: "data-free-shipping",
      freeShippingLimit: "data-free-shipping-limit",
    },
    settings$3 = {
      cartDrawerEnabled: window.theme.settings.cartDrawerEnabled,
      times: {
        timeoutAnimationComplete: 500,
        timeoutButtonReset: 1e3,
      },
    };
  let CartDrawer = class {
    init() {
      (this.html = document.documentElement),
        (this.body = document.body),
        (this.cartPage = document.querySelector(selectors$T.cartPage)),
        (this.cartDrawer = document.querySelector(selectors$T.cartDrawer)),
        (this.cartDrawerBody = document.querySelector(
          selectors$T.cartDrawerBody
        )),
        (this.cartEmpty = document.querySelector(selectors$T.cartEmpty)),
        (this.buttonHolder = document.querySelector(selectors$T.buttonHolder)),
        (this.itemsHolder = document.querySelector(selectors$T.itemsHolder)),
        (this.items = document.querySelectorAll(selectors$T.item)),
        (this.cartTotal = document.querySelector(selectors$T.cartTotal)),
        (this.freeShipping = document.querySelectorAll(
          selectors$T.freeShipping
        )),
        (this.cartOriginalTotal = document.querySelector(
          selectors$T.cartOriginalTotal
        )),
        (this.cartOriginaTotalPrice = document.querySelector(
          selectors$T.cartOriginaTotalPrice
        )),
        (this.cartDiscountHolder = document.querySelector(
          selectors$T.cartDiscountsHolder
        )),
        (this.expandButton = document.querySelectorAll(
          selectors$T.expandButton
        )),
        (this.cartTotalDiscountTemplate = document.querySelector(
          selectors$T.cartTotalDiscountsTemplate
        ).innerHTML),
        (this.cartErrorHolder = document.querySelector(selectors$T.cartErrors)),
        (this.cartCloseErrorMessage = document.querySelector(
          selectors$T.cartCloseError
        )),
        (this.headerWrapper = document.querySelector(
          selectors$T.headerWrapper
        )),
        (this.accessibility = a11y),
        (this.navDrawer = document.querySelector(selectors$T.navDrawer)),
        (this.upsellProductsHolder = document.querySelector(
          selectors$T.upsellProductsHolder
        )),
        (this.cart = this.cartDrawer || this.cartPage),
        (this.form = null),
        (this.build = this.build.bind(this)),
        (this.addToCart = this.addToCart.bind(this)),
        (this.updateCart = this.updateCart.bind(this)),
        (this.addToCartCallback = this.addToCartCallback.bind(this)),
        (this.productAddCallback = this.productAddCallback.bind(this)),
        (this.openCartDrawer = this.openCartDrawer.bind(this)),
        (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
        (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
        (this.openCartDrawerOnProductAdded =
          this.openCartDrawerOnProductAdded.bind(this)),
        (this.animateItems = this.animateItems.bind(this)),
        (this.requestItemsAnimationFrame =
          this.requestItemsAnimationFrame.bind(this)),
        (this.updateProgress = this.updateProgress.bind(this)),
        (this.cartAnimationTimeout = 0),
        (this.skipUpsellProductsArray = []),
        this.skipUpsellProductEvent(),
        this.checkSkippedUpsellProductsFromStorage(),
        this.toggleCartUpsellWidgetVisibility(),
        (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
        (this.toggleClassesOnContainers =
          this.toggleClassesOnContainers.bind(this)),
        (this.subtotal = window.theme.subtotal),
        (this.totalItems = this.items.length),
        (this.cartDrawerIsOpen = !1),
        (this.cartDiscounts = 0),
        (this.cartDrawerEnabled = settings$3.cartDrawerEnabled),
        (this.cartUpdateFailed = !1),
        this.eventToggleCart(),
        this.expandEvents(),
        this.cartEvents(),
        this.cartEventAdd(),
        this.cartEventRemoveError(),
        this.initQuantity(),
        this.estimateShippingCalculator(),
        (this.circumference = 28 * Math.PI),
        (this.cartFreeShippingLimit = 0),
        this.freeShippingMessageHandle(this.subtotal),
        this.updateProgress(),
        document.addEventListener("theme:cart:add", this.addToCartCallback),
        document.addEventListener(
          "theme:cart:loaded",
          this.requestItemsAnimationFrame
        ),
        document.addEventListener("theme:quick-add:open", this.closeCartDrawer),
        document.addEventListener("theme:product:add", this.productAddCallback),
        document.addEventListener(
          "theme:product:add-error",
          this.productAddCallback
        ),
        document.addEventListener(
          "theme:product:added",
          this.openCartDrawerOnProductAdded
        ),
        document.addEventListener(
          "theme:announcement:init",
          this.updateProgress
        );
    }
    initQuantity() {
      (this.items = document.querySelectorAll(selectors$T.item)),
        this.items.forEach((e) => {
          new QuantityCounter(e, !0).init(), this.cartUpdateEvent(e);
        });
    }
    expandEvents() {
      const e = document.querySelectorAll(selectors$T.cartWidget);
      this.expandButton.forEach((t) => {
        t.addEventListener("click", (s) => {
          s.preventDefault();
          const i = document.querySelector(t.getAttribute("href"));
          t.classList.toggle(classes$H.active),
            i.classList.toggle(classes$H.expanded),
            e.length > 1 &&
              e.forEach((e) => {
                if (e !== i.parentElement) {
                  const t = e.querySelector(selectors$T.expandButton);
                  t.classList.remove(classes$H.active),
                    t.nextElementSibling.classList.remove(classes$H.expanded);
                }
              });
        });
      });
    }
    cartUpdateEvent(e) {
      e.addEventListener("theme:cart:update", (t) => {
        this.updateCart(
          {
            id: t.detail.id,
            quantity: t.detail.quantity,
          },
          e,
          t.detail.valueIsEmpty
        );
      });
    }
    addToCartCallback(e) {
      if (!e.detail.data) return;
      const t = e.detail,
        s = e.detail.button,
        i = JSON.stringify({
          items: [e.detail.data],
        });
      this.addToCart(i, t, s);
    }
    cartEvents() {
      document.querySelectorAll(selectors$T.cartItemRemove).forEach((e) => {
        const t = e.closest(selectors$T.item);
        e.addEventListener("click", (s) => {
          s.preventDefault(),
            e.classList.contains(classes$H.disabled) ||
              this.updateCart(
                {
                  id: e.dataset.id,
                  quantity: 0,
                },
                t
              );
        });
      }),
        this.cartCloseErrorMessage &&
          this.cartCloseErrorMessage.addEventListener("click", (e) => {
            e.preventDefault(),
              this.cartErrorHolder.classList.remove(classes$H.expanded);
          });
    }
    cartEventAdd() {
      document.addEventListener("click", (e) => {
        const t = e.target;
        if (
          t.matches(selectors$T.buttonAddToCart) ||
          (t.closest(selectors$T.buttonAddToCart) && t)
        ) {
          let s = "",
            i = t.matches(selectors$T.buttonAddToCart)
              ? t
              : t.closest(selectors$T.buttonAddToCart);
          let boxcolor = $("#box-color").val();
          let card = $(".card_wrap input:checked").val();
          let to = $("#to").val();
          let from = $("#from").val();
          let messagebox = $(".message-box").val();

          if (i.hasAttribute(attributes$d.quickAddVariant))
            s = JSON.stringify({
              items: [
                {
                  id: Number(i.getAttribute(attributes$d.quickAddVariant)),
                  quantity: 1,
                  properties: {
                    card: card,
                    "Box Color": boxcolor,
                    To: to,
                    From: from,
                    "Message Box": messagebox,
                  },
                },
              ],
            });
          else {
            if (((this.form = t.closest("form")), !this.form.checkValidity()))
              return void this.form.reportValidity();
            s = new FormData(this.form);
          }

          if (null !== this.form && this.form.querySelector('[type="file"]'))
            return;
          if (
            (e.preventDefault(),
            t.hasAttribute("disabled") || t.parentNode.hasAttribute("disabled"))
          )
            return;
          this.addToCart(s, null, i),
            document.dispatchEvent(
              new CustomEvent("theme:cart:add", {
                bubbles: !0,
                detail: {
                  selector: t,
                },
              })
            );
        }
      });
    }
    cartEventRemoveError() {
      document.addEventListener("click", (e) => {
        const t = e.target;
        if (
          t.matches(selectors$T.formCloseError) ||
          t.closest(selectors$T.formCloseError)
        ) {
          e.preventDefault();
          const s = t.closest(selectors$T.formErrorsContainer);
          s && s.classList.remove(classes$H.visible);
        }
      });
    }
    estimateShippingCalculator() {
      Shopify.Cart.ShippingCalculator.show({
        submitButton: theme.strings.shippingCalcSubmitButton,
        submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
        customerIsLoggedIn: theme.settings.customerLoggedIn,
        moneyFormat: theme.moneyWithCurrencyFormat,
      });
    }
    getCart() {
      fetch(theme.routes.root + "cart.js")
        .then(this.cartErrorsHandler)
        .then((e) => e.json())
        .then(
          (e) => (
            (this.newTotalItems = e.items.length),
            (this.subtotal = e.total_price),
            (this.itemCount = e.item_count),
            (this.cartDiscounts = e.total_discount),
            this.buildTotalPrice(e),
            document.dispatchEvent(
              new CustomEvent("theme:cart:change", {
                bubbles: !0,
                detail: {
                  cart: e,
                },
              })
            ),
            fetch(theme.routes.cart + "?section_id=api-cart-items")
          )
        )
        .then((e) => e.text())
        .then((e) => {
          const t = document.createElement("div");
          t.innerHTML = e;
          const s = t.querySelector(selectors$T.apiContent);
          this.build(s);
        })
        .catch((e) => console.log(e));
    }
    addToCart(e, t = null, s = null) {
      this.cart && this.cart.classList.add(classes$H.loading);
      const i = t ? t.element : null;
      let o = null;
      this.cartDrawerEnabled &&
        (s && (s.classList.add(classes$H.loading), (s.disabled = !0)),
        i &&
          (i.classList.add(classes$H.visible),
          (o = i.querySelector(selectors$T.buttonQuickAddMobile))));
      let r = e,
        n = {
          "Content-Type": "application/json",
        };
      "string" != typeof e &&
        ((r = new URLSearchParams(e).toString()),
        (n = {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/x-www-form-urlencoded",
        })),
        fetch(theme.routes.root + "cart/add.js", {
          method: "POST",
          headers: n,
          body: r,
        })
          .then((e) => e.json())
          .then((e) => {
            if (e.status)
              return (
                this.addToCartError(e, i, s),
                s && (s.classList.remove(classes$H.loading), (s.disabled = !1)),
                void (
                  o &&
                  (o.classList.remove(classes$H.loading), (o.disabled = !1))
                )
              );
            this.cartDrawerEnabled
              ? (s &&
                  (s.classList.remove(classes$H.hidden, classes$H.loading),
                  s.classList.add(classes$H.added),
                  s.dispatchEvent(
                    new CustomEvent("theme:product:add", {
                      detail: {
                        response: e,
                        button: s,
                      },
                      bubbles: !0,
                    })
                  )),
                o &&
                  (o.classList.remove(classes$H.hidden, classes$H.loading),
                  o.classList.add(classes$H.added)),
                this.getCart())
              : (window.location = theme.routes.cart);
          })
          .catch((e) => {
            this.addToCartError(e, i, s), this.enableCartButtons();
          });
    }
    updateCart(e = {}, t = null, s = !1) {
      this.cart.classList.add(classes$H.loading);
      let i = null,
        o = null,
        r = null,
        n = e.quantity;
      null !== t &&
        (n
          ? t.classList.add(classes$H.loading)
          : t.classList.add(classes$H.removed)),
        this.disableCartButtons(),
        fetch(theme.routes.root + "cart.js")
          .then(this.cartErrorsHandler)
          .then((e) => e.json())
          .then((t) => {
            const s = t.items.findIndex((t) => t.key === e.id);
            (o = t.item_count), (r = t.items[s].title);
            const i = {
              line: `${s + 1}`,
              quantity: n,
            };
            return fetch(theme.routes.root + "cart/change.js", {
              method: "post",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(i),
            });
          })
          .then(this.cartErrorsHandler)
          .then((e) => e.json())
          .then((e) => {
            (i = e.item_count),
              s && (n = 1),
              0 !== n &&
                ((this.cartUpdateFailed = i === o), this.updateErrorText(r)),
              this.getCart();
          })
          .catch((e) => {
            console.log(e), this.enableCartButtons();
          });
    }
    disableCartButtons() {
      const e = this.cart.querySelectorAll("input"),
        t = this.cart.querySelectorAll(`button, ${selectors$T.cartItemRemove}`);
      e.length &&
        e.forEach((e) => {
          e.classList.add(classes$H.disabled), e.blur(), (e.disabled = !0);
        }),
        t.length &&
          t.forEach((e) => {
            e.setAttribute(attributes$d.disabled, !0);
          });
    }
    enableCartButtons() {
      const e = this.cart.querySelectorAll("input"),
        t = this.cart.querySelectorAll(`button, ${selectors$T.cartItemRemove}`);
      e.length &&
        e.forEach((e) => {
          e.classList.remove(classes$H.disabled), (e.disabled = !1);
        }),
        t.length &&
          t.forEach((e) => {
            e.removeAttribute(attributes$d.disabled);
          }),
        this.cart.classList.remove(classes$H.loading);
    }
    updateErrorText(e) {
      this.cartErrorHolder.querySelector(selectors$T.errorMessage).innerText =
        e;
    }
    toggleErrorMessage() {
      this.cartErrorHolder &&
        (this.cartUpdateFailed
          ? this.cartErrorHolder.classList.add(classes$H.expanded)
          : this.cartErrorHolder.classList.remove(classes$H.expanded),
        (this.cartUpdateFailed = !1));
    }
    cartErrorsHandler(e) {
      return e.ok
        ? e
        : e.json().then(function (t) {
            throw new FetchError({
              status: e.statusText,
              headers: e.headers,
              json: t,
            });
          });
    }
    addToCartError(e, t, s) {
      if (
        (this.cartDrawerEnabled &&
          s &&
          null !== s.closest(selectors$T.cartDrawer) &&
          !s.closest(selectors$T.cartDrawer) &&
          this.closeCartDrawer(),
        null !== s)
      ) {
        const t =
          s.closest(selectors$T.outerSection) ||
          s.closest(selectors$T.quickAddHolder) ||
          s.closest(selectors$T.quickAddModal);
        let i =
          null == t ? void 0 : t.querySelector(selectors$T.formErrorsContainer);
        const o = s.closest(selectors$T.quickAddHolder);
        o &&
          o.querySelector(selectors$T.formErrorsContainer) &&
          (i = o.querySelector(selectors$T.formErrorsContainer)),
          i &&
            ((i.innerHTML = `<div class="errors">${e.message}: ${e.description}<span class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></span></div>`),
            i.classList.add(classes$H.visible)),
          s.dispatchEvent(
            new CustomEvent("theme:product:add-error", {
              detail: {
                response: e,
              },
              bubbles: !0,
            })
          );
      }
      t &&
        t.dispatchEvent(
          new CustomEvent("theme:cart:error", {
            bubbles: !0,
            detail: {
              message: e.message,
              description: e.description,
              holder: t,
            },
          })
        ),
        this.cart.classList.remove(classes$H.loading);
    }
    productAddCallback(e) {
      if (theme.settings.cartDrawerEnabled) {
        let t = [],
          s = null,
          i = null;
        const o = "theme:product:add-error" == e.type,
          r = e.target,
          n = document.querySelector(selectors$T.cartBarAdd);
        t.push(r),
          (s = r.closest(selectors$T.quickAddHolder)),
          s &&
            ((i = s.querySelector(selectors$T.buttonQuickAddMobile)),
            i && t.push(i)),
          n && t.push(n),
          t.forEach((e) => {
            e.classList.remove(classes$H.loading),
              o || e.classList.add(classes$H.added);
          }),
          setTimeout(() => {
            t.forEach((e) => {
              e.classList.remove(classes$H.added), (e.disabled = !1);
            }),
              s && s.classList.remove(classes$H.visible);
          }, settings$3.times.timeoutButtonReset);
      }
    }
    openCartDrawerOnProductAdded() {
      this.cartDrawer && !this.cartDrawerIsOpen && this.openCartDrawer();
    }
    openCartDrawer() {
      this.cartDrawer &&
        ((this.cartDrawerIsOpen = !0),
        document.dispatchEvent(
          new CustomEvent("theme:cart:open", {
            bubbles: !0,
          })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.cartDrawer,
          })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.cartDrawerBody,
          })
        ),
        this.cartDrawer.classList.add(classes$H.open),
        this.observeAdditionalCheckoutButtons(),
        this.requestItemsAnimationFrame(),
        this.trapFocusAfterAnimationsComplete());
    }
    trapFocusAfterAnimationsComplete() {
      this.cartAnimationTimeout && clearTimeout(this.cartAnimationTimeout),
        (this.cartAnimationTimeout = setTimeout(() => {
          this.accessibility.trapFocus(this.cartDrawer, {
            elementToFocus: this.cartDrawer.querySelector(
              selectors$T.cartToggleElement
            ),
          });
        }, settings$3.times.timeoutAnimationComplete));
    }
    closeCartDrawer() {
      if (
        this.cartDrawer &&
        this.cartDrawer.classList.contains(classes$H.open)
      ) {
        if (
          ((this.cartDrawerIsOpen = !1),
          document.dispatchEvent(
            new CustomEvent("theme:cart:close", {
              bubbles: !0,
            })
          ),
          this.resetAnimatedItems(),
          this.itemsHolder.classList.remove(classes$H.updated),
          this.cartEmpty.classList.remove(classes$H.updated),
          this.cartErrorHolder.classList.remove(classes$H.expanded),
          this.cartDrawer
            .querySelectorAll(selectors$T.animation)
            .forEach((e) => {
              const t = () => {
                e.classList.remove(classes$H.hiding),
                  e.removeEventListener("animationend", t);
              };
              e.classList.add(classes$H.hiding),
                e.addEventListener("animationend", t);
            }),
          this.cartDrawer.classList.remove(classes$H.open),
          this.accessibility.removeTrapFocus(),
          this.body.classList.contains(classes$H.focused))
        ) {
          const e = this.headerWrapper.querySelectorAll(
            `${selectors$T.cartToggleElement}`
          );
          e.length &&
            e.forEach((e) => {
              if (isVisible(e))
                return (
                  setTimeout(() => {
                    e.focus();
                  }, 200),
                  !0
                );
            });
        }
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", {
            bubbles: !0,
          })
        );
      }
    }
    toggleCartDrawer() {
      this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
    }
    eventToggleCart() {
      document.addEventListener("click", (e) => {
        const t = e.target,
          s = !(
            t.matches(selectors$T.cartToggleElement) ||
            t.closest(selectors$T.cartToggleElement)
          ),
          i = !(
            t.matches(selectors$T.cartDrawer) ||
            t.closest(selectors$T.cartDrawer)
          ),
          o = !(
            t.matches(selectors$T.buttonSkipUpsellProduct) ||
            t.closest(selectors$T.buttonSkipUpsellProduct)
          );
        t.matches(selectors$T.cartToggleElement) ||
        t.closest(selectors$T.cartToggleElement)
          ? (e.preventDefault(), this.toggleCartDrawer())
          : this.cartDrawerIsOpen && s && i && o && this.closeCartDrawer();
      }),
        this.cartDrawer &&
          this.cartDrawer.addEventListener("keyup", (e) => {
            e.code === window.theme.keyboardKeys.ESCAPE &&
              this.closeCartDrawer();
          });
    }
    toggleClassesOnContainers() {
      const e = this.hasItemsInCart();
      this.cartEmpty.classList.toggle(classes$H.hidden, e),
        this.buttonHolder.classList.toggle(classes$H.hidden, !e),
        this.itemsHolder.classList.toggle(classes$H.hidden, !e);
    }
    build(e) {
      const t = e.querySelector(selectors$T.apiLineItems),
        s = e.querySelector(selectors$T.apiUpsellItems);
      Boolean(null === t && null === s)
        ? ((this.itemsHolder.innerHTML = e),
          (this.upsellProductsHolder.innerHTML = ""))
        : ((this.itemsHolder.innerHTML = t.innerHTML),
          (this.upsellProductsHolder.innerHTML = s.innerHTML),
          this.skipUpsellProductEvent(),
          this.checkSkippedUpsellProductsFromStorage(),
          this.toggleCartUpsellWidgetVisibility()),
        (this.cartTotal.innerHTML =
          0 === this.subtotal
            ? window.theme.strings.free
            : themeCurrency.formatMoney(
                this.subtotal,
                theme.moneyWithCurrencyFormat
              )),
        this.cart.classList.remove(classes$H.loading),
        this.totalItems !== this.newTotalItems &&
          ((this.totalItems = this.newTotalItems),
          this.toggleClassesOnContainers()),
        this.cartDrawerIsOpen &&
          this.itemsHolder.classList.add(classes$H.updated),
        this.hasItemsInCart() ||
          this.cartEmpty
            .querySelectorAll(selectors$T.animation)
            .forEach((e) => {
              e.classList.remove(classes$H.animated);
            }),
        this.freeShippingMessageHandle(this.subtotal),
        this.cartEvents(),
        this.initQuantity(),
        this.toggleErrorMessage(),
        this.enableCartButtons(),
        this.updateProgress(),
        document.dispatchEvent(
          new CustomEvent("theme:cart:loaded", {
            bubbles: !0,
          })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:product:added", {
            bubbles: !0,
          })
        );
    }
    hasItemsInCart() {
      return this.totalItems > 0;
    }
    buildTotalPrice(e) {
      if (
        (e.original_total_price > e.total_price &&
        e.cart_level_discount_applications.length > 0
          ? (this.cartOriginalTotal.classList.remove(classes$H.hidden),
            (this.cartOriginaTotalPrice.innerHTML =
              0 === e.original_total_price
                ? window.theme.strings.free
                : themeCurrency.formatMoney(
                    e.original_total_price,
                    theme.moneyFormat
                  )))
          : this.cartOriginalTotal.classList.add(classes$H.hidden),
        e.cart_level_discount_applications.length > 0)
      ) {
        const t = this.buildCartTotalDiscounts(
          e.cart_level_discount_applications
        );
        this.cartDiscountHolder.classList.remove(classes$H.hidden),
          (this.cartDiscountHolder.innerHTML = t);
      } else this.cartDiscountHolder.classList.add(classes$H.hidden);
    }
    buildCartTotalDiscounts(e) {
      let t = "";
      return (
        e.forEach((e) => {
          const s = document.createElement("div");
          (s.innerHTML = this.cartTotalDiscountTemplate),
            (s.querySelector(selectors$T.cartTotalDiscountTitle).innerHTML =
              e.title),
            (s.querySelector(selectors$T.cartTotalDiscountAmount).innerHTML =
              themeCurrency.formatMoney(
                e.total_allocated_amount,
                theme.moneyFormat
              )),
            (t += s.innerHTML);
        }),
        t
      );
    }
    freeShippingMessageHandle(e) {
      this.freeShipping.length &&
        ((this.cartFreeShippingLimit =
          100 *
          Number(
            this.freeShipping[0].getAttribute(attributes$d.freeShippingLimit)
          ) *
          window.Shopify.currency.rate),
        this.freeShipping.forEach((t) => {
          const s =
            t.hasAttribute(attributes$d.freeShipping) &&
            "true" === t.getAttribute(attributes$d.freeShipping) &&
            0 !== e;
          t.classList.toggle(
            classes$H.success,
            s && e >= this.cartFreeShippingLimit
          );
        }));
    }
    updateProgress() {
      if (
        ((this.freeShipping = document.querySelectorAll(
          selectors$T.freeShipping
        )),
        !this.freeShipping.length)
      )
        return;
      const e = Math.min(
          (this.subtotal / this.cartFreeShippingLimit) * 100,
          100
        ),
        t = this.circumference - ((e / 100) * this.circumference) / 2,
        s = themeCurrency.formatMoney(
          this.cartFreeShippingLimit - this.subtotal,
          theme.moneyFormat
        );
      this.freeShipping.forEach((i) => {
        const o = i.querySelector(selectors$T.freeShippingProgress),
          r = i.querySelector(selectors$T.freeShippingGraph),
          n = i.querySelector(selectors$T.leftToSpend);
        n && (n.innerHTML = s.replace(".00", "").replace(",00", "")),
          o && (o.value = e),
          r && r.style.setProperty("--stroke-dashoffset", `${t}`);
      });
    }
    skipUpsellProductEvent() {
      if (null === this.upsellProductsHolder) return;
      const e = this.upsellProductsHolder.querySelectorAll(
        selectors$T.buttonSkipUpsellProduct
      );
      e.length &&
        e.forEach((e) => {
          e.addEventListener("click", (t) => {
            t.preventDefault();
            const s = e
              .closest(selectors$T.quickAddHolder)
              .getAttribute(attributes$d.quickAddHolder);
            this.skipUpsellProductsArray.includes(s) ||
              this.skipUpsellProductsArray.push(s),
              window.sessionStorage.setItem(
                "skip_upsell_products",
                this.skipUpsellProductsArray
              ),
              this.removeUpsellProduct(s),
              this.toggleCartUpsellWidgetVisibility();
          });
        });
    }
    checkSkippedUpsellProductsFromStorage() {
      const e = window.sessionStorage.getItem("skip_upsell_products");
      if (!e) return;
      e.split(",").forEach((e) => {
        this.skipUpsellProductsArray.includes(e) ||
          this.skipUpsellProductsArray.push(e),
          this.removeUpsellProduct(e);
      });
    }
    removeUpsellProduct(e) {
      if (!this.upsellProductsHolder) return;
      const t = this.upsellProductsHolder.querySelector(
        `[${attributes$d.quickAddHolder}="${e}"]`
      );
      t && t.parentNode.remove();
    }
    toggleCartUpsellWidgetVisibility() {
      if (!this.upsellProductsHolder) return;
      const e = this.upsellProductsHolder.querySelectorAll(
          selectors$T.quickAddHolder
        ),
        t = this.upsellProductsHolder.closest(selectors$T.cartWidget);
      if (!t) return;
      const s = t.querySelector(selectors$T.expandButton),
        i = t.querySelector(selectors$T.cartWidgetContent);
      t.classList.toggle(classes$H.hidden, !e.length),
        this.cartDrawer &&
          this.cartDrawerIsOpen &&
          t.classList.toggle(classes$H.animated, e.length),
        s && s.classList.toggle(classes$H.active, e.length),
        i && i.classList.toggle(classes$H.expanded, e.length);
    }
    observeAdditionalCheckoutButtons() {
      const e = this.cartDrawer.querySelector(
        selectors$T.additionalCheckoutButtons
      );
      if (e) {
        const t = new MutationObserver(() => {
          this.accessibility.removeTrapFocus(),
            this.accessibility.trapFocus(this.cartDrawer, {
              elementToFocus: this.cartDrawer.querySelector(
                selectors$T.cartToggleElement
              ),
            }),
            t.disconnect();
        });
        t.observe(e, {
          subtree: !0,
          childList: !0,
        });
      }
    }
    resetAnimatedItems() {
      this.cart.querySelectorAll(selectors$T.animation).forEach((e) => {
        e.classList.remove(classes$H.animated),
          e.classList.remove(classes$H.hiding);
      });
    }
    requestItemsAnimationFrame() {
      requestAnimationFrame(this.animateItems);
    }
    animateItems() {
      this.cart.querySelectorAll(selectors$T.animation).forEach((e) => {
        e.classList.add(classes$H.animated);
      });
    }
    constructor() {
      window.location.pathname.endsWith("/password") || this.init();
    }
  };
  window.cart = new CartDrawer();
  const slideUp = (e, t = 500) => {
      (e.style.transitionProperty = "height, margin, padding"),
        (e.style.transitionDuration = t + "ms"),
        (e.style.boxSizing = "border-box"),
        (e.style.height = e.offsetHeight + "px"),
        e.offsetHeight,
        (e.style.overflow = "hidden"),
        (e.style.height = 0),
        (e.style.paddingTop = 0),
        (e.style.paddingBottom = 0),
        (e.style.marginTop = 0),
        (e.style.marginBottom = 0),
        window.setTimeout(() => {
          (e.style.display = "none"),
            e.style.removeProperty("height"),
            e.style.removeProperty("padding-top"),
            e.style.removeProperty("padding-bottom"),
            e.style.removeProperty("margin-top"),
            e.style.removeProperty("margin-bottom"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property");
        }, t);
    },
    classes$G = {
      focus: "is-focused",
      open: "is-open",
      accordionToggle: "accordion-toggle",
      tabLink: "tab-link",
    },
    selectors$S = {
      inPageLink: "[data-skip-content]",
      linkesWithOnlyHash: 'a[href="#"]',
      triggerFocusElement: "[data-focus-element]",
      accordionContent: ".accordion-content",
      accordionToggle: "data-accordion-toggle",
    };
  let Accessibility = class {
    init() {
      (this.a11y = a11y),
        (this.html = document.documentElement),
        (this.body = document.body),
        (this.inPageLink = document.querySelector(selectors$S.inPageLink)),
        (this.linkesWithOnlyHash = document.querySelectorAll(
          selectors$S.linkesWithOnlyHash
        )),
        (this.lastFocused = null),
        (this.isFocused = !1),
        this.a11y.focusHash(),
        this.a11y.bindInPageLinks(),
        this.clickEvents(),
        this.focusEvents(),
        this.focusEventsOff(),
        this.closeExpandedElements();
    }
    clickEvents() {
      this.inPageLink &&
        this.inPageLink.addEventListener("click", (e) => {
          e.preventDefault();
        }),
        this.linkesWithOnlyHash &&
          this.linkesWithOnlyHash.forEach((e) => {
            e.addEventListener("click", (e) => {
              e.preventDefault();
            });
          });
    }
    focusEvents() {
      document.addEventListener("keyup", (e) => {
        e.code === window.theme.keyboardKeys.TAB &&
          (this.body.classList.add(classes$G.focus), (this.isFocused = !0));
      }),
        document.addEventListener("keyup", (e) => {
          if (!this.isFocused) return;
          const t = e.target,
            s =
              e.code === window.theme.keyboardKeys.ENTER ||
              e.code === window.theme.keyboardKeys.SPACE,
            i =
              t.matches(selectors$S.triggerFocusElement) ||
              t.closest(selectors$S.triggerFocusElement),
            o =
              t.classList.contains(classes$G.accordionToggle) ||
              t.parentNode.classList.contains(classes$G.accordionToggle) ||
              t.hasAttribute(selectors$S.accordionToggle) ||
              t.parentNode.hasAttribute(selectors$S.accordionToggle),
            r =
              t.classList.contains(classes$G.tabLink) ||
              t.parentNode.classList.contains(classes$G.tabLink);
          s &&
            i &&
            (null === this.lastFocused && (this.lastFocused = t),
            o && t.click(),
            r && t.click());
        }),
        document.addEventListener("theme:cart:add", (e) => {
          this.lastFocused = e.detail.selector;
        });
    }
    focusEventsOff() {
      document.addEventListener("mousedown", () => {
        this.body.classList.remove(classes$G.focus), (this.isFocused = !1);
      });
    }
    closeExpandedElements() {
      document.addEventListener("keyup", (e) => {
        if (e.code !== window.theme.keyboardKeys.ESCAPE) return;
        const t = document.querySelectorAll(selectors$S.accordionContent);
        if (t.length)
          for (let e = 0; e < t.length; e++) {
            if ("block" !== t[e].style.display) continue;
            t[e].previousElementSibling.classList.remove(classes$G.open),
              slideUp(t[e]);
          }
        null !== this.lastFocused &&
          setTimeout(() => {
            this.lastFocused.focus(), (this.lastFocused = null);
          }, 600);
      });
    }
    constructor() {
      this.init();
    }
  };
  (window.accessibility = new Accessibility()),
    (theme.ProductModel = (function () {
      let e = {},
        t = {},
        s = {};
      const i = "[data-product-single-media-wrapper]",
        o = "[data-product-slideshow]",
        r = "[data-shopify-xr]",
        n = "data-media-id",
        a = "data-shopify-model3d-id",
        l = "#ModelJson-",
        c = "media--hidden",
        d = "[data-deferred-media]",
        h = "[data-deferred-media-button]",
        u = "is-loading";

      function p(e, i) {
        if (e.querySelector(d).getAttribute("loaded")) return;
        e.classList.add(u);
        const n = document.createElement("div");
        n.appendChild(
          e.querySelector("template").content.firstElementChild.cloneNode(!0)
        );
        const a = n.querySelector("model-viewer"),
          l = e.querySelector(d);
        l.appendChild(a).focus(), l.setAttribute("loaded", !0);
        const c = e.dataset.mediaId,
          h = a.dataset.modelId,
          p = e.closest(o).parentElement.querySelector(r);
        (s[i] = {
          element: p,
          defaultId: h,
        }),
          (t[c] = {
            modelId: h,
            mediaId: c,
            sectionId: i,
            container: e,
            element: a,
          }),
          window.Shopify.loadFeatures([
            {
              name: "shopify-xr",
              version: "1.0",
              onLoad: m,
            },
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: g,
            },
          ]);
      }

      function m(t) {
        if (t) console.warn(t);
        else if (window.ShopifyXR) {
          for (const t in e)
            if (e.hasOwnProperty(t)) {
              const s = e[t];
              if (s.loaded) continue;
              const i = document.querySelector(`${l}${t}`);
              i &&
                (window.ShopifyXR.addModels(JSON.parse(i.innerHTML)),
                (s.loaded = !0));
            }
          window.ShopifyXR.setupXRElements();
        } else
          document.addEventListener("shopify_xr_initialized", function () {
            m();
          });
      }

      function g(e) {
        if (e) console.warn(e);
        else
          for (const e in t)
            if (t.hasOwnProperty(e)) {
              const s = t[e];
              s.modelViewerUi ||
                (s.modelViewerUi = new Shopify.ModelViewerUI(s.element)),
                y(s);
            }
      }

      function y(e) {
        const t = s[e.sectionId];
        e.container.addEventListener("theme:media:visible", function () {
          t.element.setAttribute(a, e.modelId),
            b(e.mediaId),
            window.theme.touch || e.modelViewerUi.play();
        }),
          e.container.addEventListener("theme:media:hidden", function () {
            e.modelViewerUi.pause();
          }),
          e.container.addEventListener("xrLaunch", function () {
            e.modelViewerUi.pause();
          }),
          e.element.addEventListener("load", () => {
            e.container.classList.remove(u), b(e.mediaId);
          }),
          e.element.addEventListener(
            "shopify_model_viewer_ui_toggle_play",
            function () {
              b(e.mediaId);
            }
          );
      }

      function b(e) {
        const t = `[${n}="${e}"]`,
          s = document.querySelector(`${i}${t}`),
          o = document.querySelectorAll(`${i}:not(${t})`);
        s.classList.remove(c),
          o.length &&
            o.forEach((e) => {
              e.dispatchEvent(new CustomEvent("theme:media:hidden")),
                e.classList.add(c);
            });
      }
      return {
        init: function (t, s) {
          e[s] = {
            loaded: !1,
          };
          const i = t.querySelector(h);
          i && i.addEventListener("click", p.bind(this, t, s));
        },
        loadContent: p,
        removeSectionModels: function (s) {
          for (const e in t)
            if (t.hasOwnProperty(e)) {
              t[e].sectionId === s && delete t[e];
            }
          delete e[s], delete theme.mediaInstances[s];
        },
      };
    })());
  const selectors$R = {
    templateAddresses: ".template-addresses",
    addressNewForm: "#AddressNewForm",
    btnNew: ".address-new-toggle",
    btnEdit: ".address-edit-toggle",
    btnDelete: ".address-delete",
    classHide: "hide",
    dataFormId: "data-form-id",
    dataConfirmMessage: "data-confirm-message",
    editAddress: "#EditAddress",
    addressCountryNew: "AddressCountryNew",
    addressProvinceNew: "AddressProvinceNew",
    addressProvinceContainerNew: "AddressProvinceContainerNew",
    addressCountryOption: ".address-country-option",
    addressCountry: "AddressCountry",
    addressProvince: "AddressProvince",
    addressProvinceContainer: "AddressProvinceContainer",
  };
  let Addresses = class {
    init() {
      if (this.addressNewForm) {
        const e = this.section,
          t = this.addressNewForm;
        this.customerAddresses();
        const s = e.querySelectorAll(selectors$R.btnNew);
        s.length &&
          s.forEach((e) => {
            e.addEventListener("click", function () {
              t.classList.toggle(selectors$R.classHide);
            });
          });
        const i = e.querySelectorAll(selectors$R.btnEdit);
        i.length &&
          i.forEach((t) => {
            t.addEventListener("click", function () {
              const t = this.getAttribute(selectors$R.dataFormId);
              e.querySelector(
                `${selectors$R.editAddress}_${t}`
              ).classList.toggle(selectors$R.classHide);
            });
          });
        const o = e.querySelectorAll(selectors$R.btnDelete);
        o.length &&
          o.forEach((e) => {
            e.addEventListener("click", function () {
              const e = this.getAttribute(selectors$R.dataFormId),
                t = this.getAttribute(selectors$R.dataConfirmMessage);
              confirm(t) &&
                Shopify.postLink(window.theme.routes.addresses_url + "/" + e, {
                  parameters: {
                    _method: "delete",
                  },
                });
            });
          });
      }
    }
    customerAddresses() {
      Shopify.CountryProvinceSelector &&
        new Shopify.CountryProvinceSelector(
          selectors$R.addressCountryNew,
          selectors$R.addressProvinceNew,
          {
            hideElement: selectors$R.addressProvinceContainerNew,
          }
        );
      this.section
        .querySelectorAll(selectors$R.addressCountryOption)
        .forEach((e) => {
          const t = e.getAttribute(selectors$R.dataFormId),
            s = `${selectors$R.addressCountry}_${t}`,
            i = `${selectors$R.addressProvince}_${t}`,
            o = `${selectors$R.addressProvinceContainer}_${t}`;
          new Shopify.CountryProvinceSelector(s, i, {
            hideElement: o,
          });
        });
    }
    constructor(e) {
      (this.section = e),
        (this.addressNewForm = this.section.querySelector(
          selectors$R.addressNewForm
        )),
        this.init();
    }
  };
  const template$1 = document.querySelector(selectors$R.templateAddresses);
  template$1 && new Addresses(template$1);
  const selectors$Q = {
    accountTemplateLogged: ".customer-logged-in",
    account: ".account",
    accountSidebarMobile: ".account-sidebar--mobile",
  };
  let Account = class {
    init() {
      this.section.querySelector(selectors$Q.account) &&
        this.accountMobileSidebar();
    }
    accountMobileSidebar() {
      this.section.querySelector(selectors$Q.accountSidebarMobile) &&
        this.section
          .querySelector(selectors$Q.accountSidebarMobile)
          .addEventListener("click", function () {
            const e = this.nextElementSibling;
            e && "UL" === e.tagName && e.classList.toggle("visible");
          });
    }
    constructor(e) {
      (this.section = e), this.init();
    }
  };
  const template = document.querySelector(selectors$Q.accountTemplateLogged);
  template && new Account(template);
  const selectors$P = {
    form: "[data-account-form]",
    showReset: "[data-show-reset]",
    hideReset: "[data-hide-reset]",
    recover: "[data-recover-password]",
    recoverSuccess: "[data-recover-success]",
    login: "[data-login-form]",
    recoverHash: "#recover",
    hideClass: "is-hidden",
  };
  let Login = class {
    init() {
      window.location.hash == selectors$P.recoverHash || this.recoverSuccess
        ? this.showRecoverPasswordForm()
        : this.hideRecoverPasswordForm(),
        this.showButton.addEventListener(
          "click",
          function (e) {
            e.preventDefault(), this.showRecoverPasswordForm();
          }.bind(this),
          !1
        ),
        this.hideButton.addEventListener(
          "click",
          function (e) {
            e.preventDefault(), this.hideRecoverPasswordForm();
          }.bind(this),
          !1
        );
    }
    showRecoverPasswordForm() {
      return (
        this.login.classList.add(selectors$P.hideClass),
        this.recover.classList.remove(selectors$P.hideClass),
        (window.location.hash = selectors$P.recoverHash),
        !1
      );
    }
    hideRecoverPasswordForm() {
      return (
        this.recover.classList.add(selectors$P.hideClass),
        this.login.classList.remove(selectors$P.hideClass),
        (window.location.hash = ""),
        !1
      );
    }
    constructor(e) {
      (this.form = e),
        (this.showButton = e.querySelector(selectors$P.showReset)),
        (this.hideButton = e.querySelector(selectors$P.hideReset)),
        (this.recover = e.querySelector(selectors$P.recover)),
        (this.recoverSuccess = e.querySelector(selectors$P.recoverSuccess)),
        (this.login = e.querySelector(selectors$P.login)),
        this.init();
    }
  };
  const loginForm = document.querySelector(selectors$P.form);
  loginForm && new Login(loginForm),
    (window.Shopify = window.Shopify || {}),
    (window.Shopify.theme = window.Shopify.theme || {}),
    (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
    (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {}),
    (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);
  const registered = window.Shopify.theme.sections.registered,
    instances = window.Shopify.theme.sections.instances,
    selectors$O = {
      id: "data-section-id",
      type: "data-section-type",
    };
  let Registration = class {
      getStack() {
        return this.callStack;
      }
      constructor(e = null, t = []) {
        (this.type = e),
          (this.components = validateComponentsArray(t)),
          (this.callStack = {
            onLoad: [],
            onUnload: [],
            onSelect: [],
            onDeselect: [],
            onBlockSelect: [],
            onBlockDeselect: [],
            onReorder: [],
          }),
          t.forEach((e) => {
            for (const [t, s] of Object.entries(e)) {
              const e = this.callStack[t];
              Array.isArray(e) && "function" == typeof s
                ? e.push(s)
                : (console.warn(
                    `Unregisted function: '${t}' in component: '${this.type}'`
                  ),
                  console.warn(s));
            }
          });
      }
    },
    Section = class {
      callFunctions(e, t = null) {
        this.callStack[e].forEach((e) => {
          const s = {
            id: this.id,
            type: this.type,
            container: this.container,
          };
          t ? e.call(s, t) : e.call(s);
        });
      }
      onLoad() {
        this.callFunctions("onLoad");
      }
      onUnload() {
        this.callFunctions("onUnload");
      }
      onSelect(e) {
        this.callFunctions("onSelect", e);
      }
      onDeselect(e) {
        this.callFunctions("onDeselect", e);
      }
      onBlockSelect(e) {
        this.callFunctions("onBlockSelect", e);
      }
      onBlockDeselect(e) {
        this.callFunctions("onBlockDeselect", e);
      }
      onReorder(e) {
        this.callFunctions("onReorder", e);
      }
      constructor(e, t) {
        (this.container = validateContainerElement(e)),
          (this.id = e.getAttribute(selectors$O.id)),
          (this.type = t.type),
          (this.callStack = t.getStack());
        try {
          this.onLoad();
        } catch (e) {
          console.warn(`Error in section: ${this.id}`),
            console.warn(this),
            console.warn(e);
        }
      }
    };

  function validateContainerElement(e) {
    if (!(e instanceof Element))
      throw new TypeError(
        "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
      );
    if (null === e.getAttribute(selectors$O.id))
      throw new Error(
        "Theme Sections: The section container provided does not have an id assigned to the " +
          selectors$O.id +
          " attribute."
      );
    return e;
  }

  function validateComponentsArray(e) {
    if ((void 0 !== e && "object" != typeof e) || null === e)
      throw new TypeError(
        "Theme Sections: The components object provided is not a valid"
      );
    return e;
  }

  function register(e, t) {
    if ("string" != typeof e)
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    if (void 0 !== registered[e])
      throw new Error(
        'Theme Sections: A section of type "' +
          e +
          '" has already been registered. You cannot register the same section type twice'
      );
    Array.isArray(t) || (t = [t]);
    const s = new Registration(e, t);
    return (registered[e] = s), registered;
  }

  function load(e, t) {
    (e = normalizeType(e)),
      void 0 === t &&
        (t = document.querySelectorAll("[" + selectors$O.type + "]")),
      (t = normalizeContainers(t)),
      e.forEach(function (e) {
        const s = registered[e];
        void 0 !== s &&
          (t = t.filter(function (t) {
            return (
              !isInstance(t) &&
              null !== t.getAttribute(selectors$O.type) &&
              (t.getAttribute(selectors$O.type) !== e ||
                (instances.push(new Section(t, s)), !1))
            );
          }));
      });
  }

  function reorder(e) {
    getInstances(e).forEach(function (e) {
      e.onReorder();
    });
  }

  function unload(e) {
    getInstances(e).forEach(function (e) {
      var t = instances
        .map(function (e) {
          return e.id;
        })
        .indexOf(e.id);
      instances.splice(t, 1), e.onUnload();
    });
  }

  function getInstances(e) {
    var t = [];
    if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) var s = e[0];
    if (e instanceof Element || s instanceof Element)
      normalizeContainers(e).forEach(function (e) {
        t = t.concat(
          instances.filter(function (t) {
            return t.container === e;
          })
        );
      });
    else if ("string" == typeof e || "string" == typeof s) {
      normalizeType(e).forEach(function (e) {
        t = t.concat(
          instances.filter(function (t) {
            return t.type === e;
          })
        );
      });
    }
    return t;
  }

  function getInstanceById(e) {
    for (var t, s = 0; s < instances.length; s++)
      if (instances[s].id === e) {
        t = instances[s];
        break;
      }
    return t;
  }

  function isInstance(e) {
    return getInstances(e).length > 0;
  }

  function normalizeType(e) {
    return (
      "*" === e
        ? (e = Object.keys(registered))
        : "string" == typeof e
        ? (e = [e])
        : e.constructor === Section
        ? (e = [e.prototype.type])
        : Array.isArray(e) &&
          e[0].constructor === Section &&
          (e = e.map(function (e) {
            return e.type;
          })),
      (e = e.map(function (e) {
        return e.toLowerCase();
      }))
    );
  }

  function normalizeContainers(e) {
    return (
      NodeList.prototype.isPrototypeOf(e) && e.length > 0
        ? (e = Array.prototype.slice.call(e))
        : (NodeList.prototype.isPrototypeOf(e) && 0 === e.length) || null === e
        ? (e = [])
        : !Array.isArray(e) && e instanceof Element && (e = [e]),
      e
    );
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (e) {
      var t = e.detail.sectionId,
        s = e.target.querySelector("[" + selectors$O.id + '="' + t + '"]');
      null !== s && load(s.getAttribute(selectors$O.type), s);
    }),
    document.addEventListener("shopify:section:reorder", function (e) {
      var t = e.detail.sectionId,
        s = e.target.querySelector("[" + selectors$O.id + '="' + t + '"]');
      "object" == typeof getInstances(s)[0] && reorder(s);
    }),
    document.addEventListener("shopify:section:unload", function (e) {
      var t = e.detail.sectionId,
        s = e.target.querySelector("[" + selectors$O.id + '="' + t + '"]');
      "object" == typeof getInstances(s)[0] && unload(s);
    }),
    document.addEventListener("shopify:section:select", function (e) {
      var t = getInstanceById(e.detail.sectionId);
      "object" == typeof t && t.onSelect(e);
    }),
    document.addEventListener("shopify:section:deselect", function (e) {
      var t = getInstanceById(e.detail.sectionId);
      "object" == typeof t && t.onDeselect(e);
    }),
    document.addEventListener("shopify:block:select", function (e) {
      var t = getInstanceById(e.detail.sectionId);
      "object" == typeof t && t.onBlockSelect(e);
    }),
    document.addEventListener("shopify:block:deselect", function (e) {
      var t = getInstanceById(e.detail.sectionId);
      "object" == typeof t && t.onBlockDeselect(e);
    }));
  const selectors$N = {
      aos: "[data-aos]",
      collectionImage: ".collection-item__image",
      columnImage: ".column__image__wrapper",
      flickityNextArrow: ".flickity-button.next",
      flickityPrevArrow: ".flickity-button.previous",
      heroContent: ".hero__content",
      heroContentWrapper: ".hero__content__wrapper",
      link: "a:not(.hero__btn)",
      nextArrow: "[data-next-arrow]",
      prevArrow: "[data-prev-arrow]",
      productItemImage: ".product-item__image",
      slide: "[data-slide]",
      slideValue: "data-slide",
      slider: "[data-slider]",
      sliderThumb: "[data-slider-thumb]",
      slideshowSlideImg: ".slide-image-img",
    },
    attributes$c = {
      arrowPositionMiddle: "data-arrow-position-middle",
      aspectRatio: "data-aspectratio",
      equalizeHeight: "data-equalize-height",
      setHeight: "data-set-height",
      slideIndex: "data-slide-index",
      sliderOptions: "data-options",
      slidesDesktop: "data-slides-desktop",
      slidesLargeDesktop: "data-slides-large-desktop",
      slidesMobileDesktop: "data-slides-mobile",
      slidesTabletDesktop: "data-slides-tablet",
      slideTextColor: "data-slide-text-color",
    },
    classes$F = {
      aosAnimate: "aos-animate",
      focused: "is-focused",
      flickityResize: "flickity-resize",
      flickityResizing: "flickity-resizing",
      flickityEnabled: "flickity-enabled",
      heroContentTransparent: "hero__content--transparent",
      initialized: "is-initialized",
      isLoading: "is-loading",
      isSelected: "is-selected",
      sliderArrowsHidden: "flickity-button-hide",
      sliderInitialized: "js-slider--initialized",
    },
    sections$q = {};
  let Slider = class {
    init() {
      this.slideshow.classList.add(classes$F.isLoading),
        this.setMinHeight(),
        (this.sliderOptions = {
          contain: !0,
          wrapAround: !0,
          adaptiveHeight: !0,
          ...this.customOptions,
          on: {
            ready: () => {
              requestAnimationFrame(() => {
                this.slideshow.classList.add(classes$F.initialized),
                  this.slideshow.classList.remove(classes$F.isLoading),
                  this.slideshow.parentNode.dispatchEvent(
                    new CustomEvent("theme:slider:loaded", {
                      bubbles: !0,
                      detail: {
                        slider: this,
                      },
                    })
                  );
              }),
                this.slideActions(),
                this.sliderOptions.prevNextButtons &&
                  (this.initArrows(), this.positionArrows());
            },
            change: () => {
              this.flkty.selectedElement
                .querySelectorAll(selectors$N.aos)
                .forEach((e) => {
                  e.classList.remove(classes$F.aosAnimate),
                    requestAnimationFrame(() => {
                      e.classList.add(classes$F.aosAnimate);
                    });
                });
            },
            resize: () => {
              this.sliderOptions.prevNextButtons && this.positionArrows();
            },
          },
        }),
        this.sliderOptions.fade &&
          (this.flkty = new FlickityFade(this.slideshow, this.sliderOptions)),
        this.sliderOptions.fade ||
          (this.flkty = new Flickity(this.slideshow, this.sliderOptions)),
        this.isHeightEqualized && this.equalizeHeight(),
        this.sliderPrev &&
          this.sliderPrev.addEventListener("click", (e) => {
            e.preventDefault(), this.flkty.previous(!0);
          }),
        this.sliderNext &&
          this.sliderNext.addEventListener("click", (e) => {
            e.preventDefault(), this.flkty.next(!0);
          }),
        this.flkty.on("change", () => this.slideActions(!0)),
        this.addRemoveSlidesForDevices(),
        document.addEventListener(
          "theme:resize",
          this.addRemoveSlidesForDevicesOnResize
        ),
        (this.setMinHeightFlag || this.multipleSlides) &&
          document.addEventListener(
            "theme:resize",
            this.sliderCallbackEventOnResize
          ),
        this.sliderThumbs.length &&
          this.sliderThumbs.forEach((e) => {
            e.addEventListener("click", (t) => {
              t.preventDefault();
              const s = [...e.parentElement.children].indexOf(e);
              this.flkty.select(s);
            });
          }),
        this.container.addEventListener(
          "theme:tab:change",
          this.resetSliderEvent
        );
    }
    resetSlider() {
      this.slideshow &&
        (this.flkty && this.flkty.isActive
          ? this.flkty.select(0, !1, !0)
          : this.slideshow.scrollTo({
              left: 0,
              behavior: "auto",
            }));
    }
    addRemoveSlidesForDevices() {
      if (
        ((this.hasDiffSlidesForMobileDesktop =
          Array.prototype.filter.call(this.slideshowSlides, (e) => {
            if (
              e.classList.contains("desktop") ||
              e.classList.contains("mobile")
            )
              return e;
          }).length > 0),
        !this.hasDiffSlidesForMobileDesktop)
      )
        return;
      let e = null;
      (e =
        (window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth) < theme.sizes.small
          ? `${selectors$N.slide}.mobile, ${selectors$N.slide}:not(.desktop)`
          : `${selectors$N.slide}.desktop, ${selectors$N.slide}:not(.mobile)`),
        (this.flkty.options.cellSelector = e),
        this.flkty.selectCell(0, !1, !0),
        this.flkty.reloadCells(),
        this.flkty.reposition(),
        this.flkty.resize(),
        this.slideActions();
    }
    sliderCallbackEvent() {
      this.setMinHeight(),
        this.multipleSlides &&
          (this.sliderOptions.prevNextButtons && this.initArrows(),
          this.flkty.resize(),
          this.slideshow.classList.contains(classes$F.sliderInitialized) ||
            this.flkty.select(0));
    }
    slideActions(e = !1) {
      const t = this.slideshow.querySelector(`.${classes$F.isSelected}`),
        s = t.getAttribute(attributes$c.slideTextColor),
        i = t.querySelector(selectors$N.link),
        o = this.slideshow.querySelectorAll(
          `${selectors$N.slide} a, ${selectors$N.slide} button`
        );
      if (
        (document.body.classList.contains(classes$F.focused) &&
          i &&
          this.sliderOptions.groupCells &&
          e &&
          i.focus(),
        o.length &&
          o.forEach((e) => {
            const t = e.closest(selectors$N.slide);
            if (t) {
              const s = t.classList.contains(classes$F.isSelected) ? 0 : -1;
              e.setAttribute("tabindex", s);
            }
          }),
        "rgba(0,0,0,0)" !== s &&
          "" !== s &&
          this.slideshow.style.setProperty("--text", s),
        this.setMinHeight(),
        this.sliderThumbs.length &&
          this.sliderThumbs.length === this.slideshowSlides.length &&
          t.hasAttribute(attributes$c.slideIndex))
      ) {
        const e = parseInt(t.getAttribute(attributes$c.slideIndex)),
          s = this.container.querySelector(
            `${selectors$N.sliderThumb}.${classes$F.isSelected}`
          );
        s && s.classList.remove(classes$F.isSelected),
          this.sliderThumbs[e].classList.add(classes$F.isSelected);
      }
    }
    setMinHeight() {
      this.setMinHeightFlag &&
        this.slideshowSlides.forEach((e) => {
          const t = e.querySelector(selectors$N.slideshowSlideImg);
          let s = "";
          t &&
            t.hasAttribute(attributes$c.aspectRatio) &&
            (s = t.getAttribute(attributes$c.aspectRatio));
          let i = 0,
            o = 0;
          const r = e.querySelector(selectors$N.heroContent);
          if (r) {
            (o =
              parseInt(window.getComputedStyle(r).marginTop) +
              parseInt(window.getComputedStyle(r).marginBottom)),
              (i = r.offsetHeight + o);
          }
          const n = parseInt(getComputedStyle(e, null).width.replace("px", ""));
          let a = parseInt(n / s) || 0;
          const l = e.classList.contains(classes$F.isSelected);
          i > a && (a = i);
          const c = `calc(${a}px + var(--header-padding))`;
          e.style.setProperty("min-height", c);
          const d = e.querySelector(selectors$N.heroContentWrapper);
          d && d.style.setProperty("min-height", c),
            l &&
              this.slideshow.parentElement.style.setProperty("min-height", c);
        });
    }
    positionArrows() {
      if (
        this.slideshow.hasAttribute(attributes$c.arrowPositionMiddle) &&
        this.sliderOptions.prevNextButtons
      ) {
        const e =
          this.slideshow.querySelector(selectors$N.collectionImage) ||
          this.slideshow.querySelector(selectors$N.productItemImage) ||
          this.slideshow.querySelector(selectors$N.columnImage);
        if (!e) return;
        (this.slideshow.querySelector(selectors$N.flickityPrevArrow).style.top =
          e.clientHeight / 2 + "px"),
          (this.slideshow.querySelector(
            selectors$N.flickityNextArrow
          ).style.top = e.clientHeight / 2 + "px");
      }
    }
    initArrows() {
      if (!this.multipleSlides) return;
      const e = parseInt(
          this.slideshow.getAttribute(attributes$c.slidesLargeDesktop)
        ),
        t =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth,
        s = this.slideshow.hasAttribute(attributes$c.slidesDesktop)
          ? parseInt(this.slideshow.getAttribute(attributes$c.slidesDesktop))
          : 3,
        i = this.slideshow.hasAttribute(attributes$c.slidesTabletDesktop)
          ? parseInt(
              this.slideshow.getAttribute(attributes$c.slidesTabletDesktop)
            )
          : 2,
        o = this.slideshow.hasAttribute(attributes$c.slidesMobileDesktop)
          ? parseInt(
              this.slideshow.getAttribute(attributes$c.slidesMobileDesktop)
            )
          : 1,
        r = t > 1339 && this.slideshowSlides.length > e,
        n = t <= 1339 && t > 1023 && this.slideshowSlides.length > s,
        a = t <= 1023 && t > 749 && this.slideshowSlides.length > i,
        l = t <= 749 && this.slideshowSlides.length > o,
        c = Boolean(r || n || a || l);
      this.slideshow.classList.toggle(classes$F.sliderArrowsHidden, !c),
        this.slideshow.classList.toggle(classes$F.sliderInitialized, c);
    }
    equalizeHeight() {
      (Flickity.prototype._createResizeClass = function () {
        requestAnimationFrame(() => {
          this.element.classList.add(classes$F.flickityResize);
        });
      }),
        this.flkty._createResizeClass();
      const e = Flickity.prototype.resize;
      Flickity.prototype.resize = function () {
        this.element.classList.remove(classes$F.flickityResize),
          this.element.classList.add(classes$F.flickityResizing),
          e.call(this),
          requestAnimationFrame(() => {
            this.element.classList.add(classes$F.flickityResize),
              this.element.classList.remove(classes$F.flickityResizing);
          });
      };
    }
    onUnload() {
      (this.setMinHeightFlag || this.multipleSlides) &&
        document.removeEventListener(
          "theme:resize",
          this.sliderCallbackEventOnResize
        ),
        this.slideshow &&
          this.flkty &&
          ((this.flkty.options.watchCSS = !1), this.flkty.destroy()),
        this.container.removeEventListener(
          "theme:tab:change",
          this.resetSliderEvent
        ),
        document.removeEventListener(
          "theme:resize",
          this.addRemoveSlidesForDevicesOnResize
        );
    }
    onBlockSelect(e) {
      if (!this.slideshow) return;
      const t = this.slideshow.querySelector(
        `[${selectors$N.slideValue}="${e.detail.blockId}"]`
      );
      if (!t) return;
      let s = parseInt(t.getAttribute(attributes$c.slideIndex));
      this.multipleSlides &&
        !this.slideshow.classList.contains(classes$F.sliderInitialized) &&
        (s = 0),
        this.slideshow.classList.add(classes$F.isSelected),
        this.flkty &&
          this.slideshow.classList.contains(classes$F.flickityEnabled) &&
          (this.flkty.selectCell(s), this.flkty.stopPlayer());
    }
    onBlockDeselect() {
      this.slideshow &&
        (this.slideshow.classList.remove(classes$F.isSelected),
        this.flkty &&
          this.sliderOptions.hasOwnProperty("autoPlay") &&
          this.sliderOptions.autoPlay &&
          this.flkty.playPlayer());
    }
    constructor(e, t = null) {
      (this.container = e),
        (this.slideshow =
          t || this.container.querySelector(selectors$N.slider)),
        this.slideshow &&
          ((this.slideshowSlides = this.slideshow.querySelectorAll(
            selectors$N.slide
          )),
          this.slideshowSlides.length <= 1 ||
            ((this.sliderPrev = this.container.querySelector(
              selectors$N.prevArrow
            )),
            (this.sliderNext = this.container.querySelector(
              selectors$N.nextArrow
            )),
            (this.sliderThumbs = this.container.querySelectorAll(
              selectors$N.sliderThumb
            )),
            (this.multipleSlides = this.slideshow.hasAttribute(
              attributes$c.slidesLargeDesktop
            )),
            (this.isHeightEqualized =
              "true" ===
              this.slideshow.getAttribute(attributes$c.equalizeHeight)),
            (this.setMinHeightFlag =
              "true" === this.slideshow.getAttribute(attributes$c.setHeight)),
            (this.sliderCallbackEventOnResize = () =>
              this.sliderCallbackEvent()),
            (this.addRemoveSlidesForDevicesOnResize = () =>
              this.addRemoveSlidesForDevices()),
            (this.resetSliderEvent = () => this.resetSlider()),
            this.slideshow.hasAttribute(attributes$c.sliderOptions) &&
              (this.customOptions = JSON.parse(
                decodeURIComponent(
                  this.slideshow.getAttribute(attributes$c.sliderOptions)
                )
              )),
            (this.flkty = null),
            this.init()));
    }
  };
  const slider = {
      onLoad() {
        sections$q[this.id] = [];
        this.container.querySelectorAll(selectors$N.slider).forEach((e) => {
          sections$q[this.id].push(new Slider(this.container, e));
        });
      },
      onUnload() {
        sections$q[this.id].forEach((e) => {
          "function" == typeof e.onUnload && e.onUnload();
        });
      },
      onBlockSelect(e) {
        sections$q[this.id].forEach((t) => {
          "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        });
      },
      onBlockDeselect(e) {
        sections$q[this.id].forEach((t) => {
          "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
        });
      },
    },
    throttle = (e, t) => {
      let s, i;
      return function o(...r) {
        const n = Date.now();
        (i = clearTimeout(i)),
          !s || n - s >= t
            ? (e.apply(null, r), (s = n))
            : (i = setTimeout(o.bind(null, ...r), t - (n - s)));
      };
    },
    selectors$M = {
      tooltip: "data-tooltip",
      tooltipStopMouseEnter: "data-tooltip-stop-mouseenter",
    },
    classes$E = {
      tooltipDefault: "tooltip-default",
      visible: "is-visible",
      hiding: "is-hiding",
    };
  let sections$p = {},
    Tooltip = class {
      init() {
        if (!document.querySelector(`.${this.class}`)) {
          const e = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
            t = document.createElement("div");
          (t.className = this.class),
            (t.innerHTML = e),
            document.body.appendChild(t);
        }
        this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
          this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
          this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
          document.addEventListener("theme:tooltip:close", this.removePinEvent);
      }
      addPin(e = !1) {
        const t = document.querySelector(`.${this.class}`);
        if (
          t &&
          ((e &&
            !this.tooltip.hasAttribute(selectors$M.tooltipStopMouseEnter)) ||
            !e)
        ) {
          const e = t.querySelector(`.${this.class}__arrow`),
            s = t.querySelector(`.${this.class}__inner`);
          t.querySelector(`.${this.class}__text`).textContent = this.label;
          const i =
              window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth,
            o = s.offsetWidth,
            r = this.tooltip.getBoundingClientRect(),
            n = r.top,
            a = r.width,
            l = n + r.height + window.scrollY;
          let c = r.left - o / 2 + a / 2;
          const d = c + o - i;
          d > 0 && (c -= d),
            c < 0 && (c = 0),
            (e.style.left = `${r.left + a / 2}px`),
            t.style.setProperty("--tooltip-top", `${l}px`),
            (s.style.transform = `translateX(${c}px)`),
            t.classList.remove(classes$E.hiding),
            t.classList.add(classes$E.visible),
            document.addEventListener("theme:scroll", this.removePinEvent);
        }
      }
      removePin(e, t = !1, s = !1) {
        const i = document.querySelector(`.${this.class}`),
          o = i.classList.contains(classes$E.visible);
        i &&
          ((t &&
            !this.tooltip.hasAttribute(selectors$M.tooltipStopMouseEnter)) ||
            !t) &&
          (o &&
            (s || e.detail.hideTransition) &&
            (i.classList.add(classes$E.hiding),
            this.hideTransitionTimeout &&
              clearTimeout(this.hideTransitionTimeout),
            (this.hideTransitionTimeout = setTimeout(() => {
              i.classList.remove(classes$E.hiding);
            }, this.transitionSpeed))),
          i.classList.remove(classes$E.visible),
          document.removeEventListener("theme:scroll", this.removePinEvent));
      }
      unload() {
        this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
          this.tooltip.removeEventListener(
            "mouseleave",
            this.removePinMouseEvent
          ),
          this.tooltip.removeEventListener(
            "theme:tooltip:init",
            this.addPinEvent
          ),
          document.removeEventListener(
            "theme:tooltip:close",
            this.removePinEvent
          ),
          document.removeEventListener("theme:scroll", this.removePinEvent);
      }
      constructor(e, t = {}) {
        (this.tooltip = e),
          this.tooltip.hasAttribute(selectors$M.tooltip) &&
            ((this.label = this.tooltip.getAttribute(selectors$M.tooltip)),
            (this.class = t.class || classes$E.tooltipDefault),
            (this.transitionSpeed = t.transitionSpeed || 200),
            (this.hideTransitionTimeout = 0),
            (this.addPinEvent = () => this.addPin()),
            (this.addPinMouseEvent = () => this.addPin(!0)),
            (this.removePinEvent = (e) => throttle(this.removePin(e), 50)),
            (this.removePinMouseEvent = (e) => this.removePin(e, !0, !0)),
            this.init());
      }
    };
  const tooltipSection = {
      onLoad() {
        sections$p[this.id] = [];
        this.container
          .querySelectorAll(`[${selectors$M.tooltip}]`)
          .forEach((e) => {
            sections$p[this.id].push(new Tooltip(e));
          });
      },
      onUnload: function () {
        sections$p[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
    },
    slideDown = (e, t = 500, s = "block", i = !0) => {
      let o = window.getComputedStyle(e).display;
      if (i && "none" !== o) return;
      e.style.removeProperty("display"),
        "none" === o && (o = s),
        (e.style.display = o);
      let r = e.offsetHeight;
      (e.style.overflow = "hidden"),
        (e.style.height = 0),
        (e.style.paddingTop = 0),
        (e.style.paddingBottom = 0),
        (e.style.marginTop = 0),
        (e.style.marginBottom = 0),
        e.offsetHeight,
        (e.style.boxSizing = "border-box"),
        (e.style.transitionProperty = "height, margin, padding"),
        (e.style.transitionDuration = t + "ms"),
        (e.style.height = r + "px"),
        e.style.removeProperty("padding-top"),
        e.style.removeProperty("padding-bottom"),
        e.style.removeProperty("margin-top"),
        e.style.removeProperty("margin-bottom"),
        window.setTimeout(() => {
          e.style.removeProperty("height"),
            e.style.removeProperty("overflow"),
            e.style.removeProperty("transition-duration"),
            e.style.removeProperty("transition-property");
        }, t);
    },
    slideToggle = (e, t = 500, s = "block") =>
      "none" === window.getComputedStyle(e).display
        ? slideDown(e, t, s)
        : slideUp(e, t);
  var sections$o = {};
  const parallaxHero = {
      onLoad() {
        sections$o[this.id] = [];
        this.container
          .querySelectorAll("[data-parallax-wrapper]")
          .forEach((e) => {
            const t = e.querySelector("[data-parallax-img]");
            sections$o[this.id].push(
              new Rellax(t, {
                center: !0,
                round: !0,
                frame: e,
              })
            );
          }),
          window.addEventListener("load", () => {
            sections$o[this.id].forEach((e) => {
              "function" == typeof e.refresh && e.refresh();
            });
          });
      },
      onUnload: function () {
        sections$o[this.id].forEach((e) => {
          "function" == typeof e.destroy && e.destroy();
        });
      },
    },
    selectors$L = {
      sidebar: ".sidebar",
      widgetCategories: ".widget--categories",
      widgetLinksEl: ".widget__links",
      widgetLinks: ".widget__links .has-sub-nav > a",
      widgetLinksSub: ".widget__links .submenu > li > a",
      listEl: "li",
      linkEl: "a",
      articleSingle: ".article--single",
      sidebarContents: ".sidebar__contents",
      hasSubNav: ".has-sub-nav",
    },
    classes$D = {
      open: "is-open",
      active: "is-active",
      submenu: "submenu",
    },
    sections$n = {};
  let Article = class {
    init() {
      this.sidebar && this.sidebarNav();
    }
    sidebarNav() {
      this.navStates(),
        this.container.addEventListener("click", (e) => {
          const t = e.target.tagName.toLowerCase() === selectors$L.linkEl,
            s = e.target.closest(
              `${selectors$L.listEl}${selectors$L.hasSubNav}`
            ),
            i = e.target.closest(selectors$L.widgetLinksEl),
            o = t && s && i,
            r = e.target.nextElementSibling;
          !(
            (window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth) < theme.sizes.small
          ) &&
            o &&
            r &&
            (r.parentElement.classList.toggle(classes$D.active),
            r.classList.toggle(classes$D.open),
            r.setAttribute(
              "aria-expanded",
              r.classList.contains(classes$D.open)
            ),
            slideToggle(r),
            e.preventDefault());
        }),
        this.widgetCategories &&
          ((this.widgetCategoriesNext = this.widgetCategories.nextSibling),
          (this.widgetCategoriesParentNode = this.widgetCategories.parentNode),
          this.categories(),
          document.addEventListener("theme:resize", this.resizeEvent));
    }
    navStates() {
      const e = this.container.querySelectorAll(
        `${selectors$L.widgetLinks}, ${selectors$L.widgetLinksSub}`
      );
      e.length &&
        e.forEach((e) => {
          if (e.getAttribute("href") === window.location.pathname) {
            const t = e.closest(selectors$L.hasSubNav);
            if ((e.closest("li").classList.add(classes$D.active), !t)) return;
            t.classList.add(classes$D.active);
            const s = t.querySelector(`.${classes$D.submenu}`);
            s &&
              (s.classList.toggle(classes$D.open),
              s.setAttribute(
                "aria-expanded",
                s.classList.contains(classes$D.open)
              ),
              showElement(s));
          }
        });
    }
    categories() {
      const e =
          (window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth) < theme.sizes.small,
        t = document.querySelector(selectors$L.widgetCategories);
      e
        ? document.querySelector(selectors$L.articleSingle).prepend(t)
        : this.widgetCategoriesParentNode.insertBefore(
            t,
            this.widgetCategoriesNext
          );
    }
    onUnload() {
      this.widgetCategories &&
        document.removeEventListener("theme:resize", this.resizeEvent);
    }
    constructor(e) {
      (this.container = e.container),
        (this.sidebar = this.container.querySelector(selectors$L.sidebar)),
        (this.widgetCategories = this.container.querySelector(
          selectors$L.widgetCategories
        )),
        (this.resizeEvent = () => this.categories()),
        this.init();
    }
  };
  const articleSection = {
    onLoad() {
      sections$n[this.id] = new Article(this);
    },
    onUnload(e) {
      sections$n[this.id].onUnload(e);
    },
  };
  register("article", [articleSection, slider, tooltipSection, parallaxHero]),
    register("blog-section", [slider]),
    register("hero", parallaxHero),
    register("double", slider);
  const selectors$K = {
      popoutWrapper: "[data-popout]",
      popoutList: "[data-popout-list]",
      popoutToggle: "[data-popout-toggle]",
      popoutToggleText: "[data-popout-toggle-text]",
      popoutToggleTextValue: "data-popout-toggle-text",
      popoutInput: "[data-popout-input]",
      popoutOptions: "[data-popout-option]",
      popoutPrevent: "data-popout-prevent",
      popoutQuantity: "data-quantity-field",
      dataValue: "data-value",
      ariaExpanded: "aria-expanded",
      ariaCurrent: "aria-current",
      productGridImage: "[data-product-image]",
      productGrid: "[data-product-grid-item]",
    },
    classes$C = {
      listVisible: "popout-list--visible",
      visible: "is-visible",
      active: "is-active",
      selectPopoutTop: "select-popout--top",
    };
  let sections$m = {},
    Popout = class {
      popupToggleClick(e) {
        console.log('popupToggleClick');
        const t =
          "true" === e.currentTarget.getAttribute(selectors$K.ariaExpanded);
        if (this.productGrid) {
          const e = this.productGrid.querySelector(
            selectors$K.productGridImage
          );
          e && e.classList.toggle(classes$C.visible, !t),
            (this.popoutList.style.maxHeight = `${Math.abs(
              this.popoutToggle.getBoundingClientRect().bottom -
                this.productGrid.getBoundingClientRect().bottom
            )}px`);
        }
        e.currentTarget.setAttribute(selectors$K.ariaExpanded, !t),
          this.popoutList.classList.toggle(classes$C.listVisible),
          this.popupListMaxWidth(),
          this.toggleListPosition();
      }
      popupToggleFocusout(e) {
        this.container.contains(e.relatedTarget) || this._hideList();
      }
      popupListFocusout(e) {
        const t = e.currentTarget.contains(e.relatedTarget);
        this.popoutList.classList.contains(classes$C.listVisible) &&
          !t &&
          this._hideList();
      }
      toggleListPosition() {
        const e = this.popoutList.closest(selectors$K.popoutWrapper),
          t =
            "true" ===
            e
              .querySelector(selectors$K.popoutToggle)
              .getAttribute(selectors$K.ariaExpanded),
          s = window.innerHeight,
          i = this.popoutList.getBoundingClientRect().bottom,
          o = () => {
            e.classList.remove(classes$C.selectPopoutTop),
              this.popoutList.removeEventListener("transitionend", o);
          };
        t
          ? s < i && e.classList.add(classes$C.selectPopoutTop)
          : this.popoutList.addEventListener("transitionend", o);
      }
      popupListMaxWidth() {
        this.popoutList.style.maxWidth = `${parseInt(
          document.body.clientWidth -
            this.popoutList.getBoundingClientRect().left
        )}px`;
      }
      popupOptionsClick(e) {
        if (
          "#" ===
          e.target.closest(selectors$K.popoutOptions).attributes.href.value
        ) {
          e.preventDefault();
          let t = "";
          if (
            (e.currentTarget.getAttribute(selectors$K.dataValue) &&
              (t = e.currentTarget.getAttribute(selectors$K.dataValue)),
            (this.popoutInput.value = t),
            this.popoutPrevent)
          ) {
            const s = e.currentTarget.parentElement,
              i = this.popoutList.querySelector(`.${classes$C.active}`),
              o = this.popoutList.querySelector(`[${selectors$K.ariaCurrent}]`);
            this.popoutInput.dispatchEvent(new Event("change")),
              i &&
                (i.classList.remove(classes$C.active),
                s.classList.add(classes$C.active)),
              this.popoutInput.hasAttribute(selectors$K.popoutQuantity) &&
                !s.nextSibling &&
                this.container.classList.add(classes$C.active),
              o &&
                o.hasAttribute(`${selectors$K.ariaCurrent}`) &&
                (o.removeAttribute(`${selectors$K.ariaCurrent}`),
                e.currentTarget.setAttribute(
                  `${selectors$K.ariaCurrent}`,
                  "true"
                )),
              "" !== t &&
                ((this.popoutToggleText.textContent = t),
                this.popoutToggleText.hasAttribute(
                  selectors$K.popoutToggleTextValue
                ) &&
                  "" !==
                    this.popoutToggleText.getAttribute(
                      selectors$K.popoutToggleTextValue
                    ) &&
                  this.popoutToggleText.setAttribute(
                    selectors$K.popoutToggleTextValue,
                    t
                  )),
              this.popupToggleFocusout(e),
              this.popupListFocusout(e);
          } else this._submitForm(t);
        }
      }
      containerKeyup(e) {
        e.code === window.theme.keyboardKeys.ESCAPE &&
          (this._hideList(), this.popoutToggle.focus());
      }
      bodyClick(e) {
        const t = this.container.contains(e.target);
        this.popoutList.classList.contains(classes$C.listVisible) &&
          !t &&
          this._hideList();
      }
      unload() {
        document.body.removeEventListener("click", this.bodyClickEvent);
      }
      _connectToggle() {
        this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
      }
      _connectOptions() {
        this.popoutOptions.length &&
          this.popoutOptions.forEach((e) => {
            e.addEventListener("click", (e) => this.popupOptionsClick(e));
          });
      }
      _onFocusOut() {
        this.popoutToggle.addEventListener(
          "focusout",
          this.popupToggleFocusoutEvent
        ),
          this.popoutList.addEventListener(
            "focusout",
            this.popupListFocusoutEvent
          ),
          this.container.addEventListener("keyup", this.containerKeyupEvent),
          document.body.addEventListener("click", this.bodyClickEvent);
      }
      _submitForm() {
        const e = this.container.closest("form");
        e && e.submit();
      }
      _hideList() {
        this.popoutList.classList.remove(classes$C.listVisible),
          this.popoutToggle.setAttribute(selectors$K.ariaExpanded, !1),
          this.toggleListPosition();
      }
      constructor(e) {
        (this.container = e),
          (this.popoutList = this.container.querySelector(
            selectors$K.popoutList
          )),
          (this.popoutToggle = this.container.querySelector(
            selectors$K.popoutToggle
          )),
          (this.popoutToggleText = this.container.querySelector(
            selectors$K.popoutToggleText
          )),
          (this.popoutInput = this.container.querySelector(
            selectors$K.popoutInput
          )),
          (this.popoutOptions = this.container.querySelectorAll(
            selectors$K.popoutOptions
          )),
          (this.productGrid = this.popoutList.closest(selectors$K.productGrid)),
          (this.popoutPrevent =
            "true" === this.container.getAttribute(selectors$K.popoutPrevent)),
          (this.popupToggleFocusoutEvent = (e) => this.popupToggleFocusout(e)),
          (this.popupListFocusoutEvent = (e) => this.popupListFocusout(e)),
          (this.popupToggleClickEvent = (e) => this.popupToggleClick(e)),
          (this.containerKeyupEvent = (e) => this.containerKeyup(e)),
          (this.bodyClickEvent = (e) => this.bodyClick(e)),
          this._connectOptions(),
          this._connectToggle(),
          this._onFocusOut(),
          this.popupListMaxWidth();
      }
    };
  const popoutSection = {
      onLoad() {
        sections$m[this.id] = [];
        this.container
          .querySelectorAll(selectors$K.popoutWrapper)
          .forEach((e) => {
            sections$m[this.id].push(new Popout(e));
          });
      },
      onUnload() {
        sections$m[this.id].forEach((e) => {
          "function" == typeof e.unload && e.unload();
        });
      },
    },
    selectors$J = {
      headerSticky: "[data-header-sticky]",
      headerHeight: "[data-header-height]",
    },
    scrollTo = (e) => {
      const t =
        document.querySelector(selectors$J.headerSticky) &&
        document.querySelector(selectors$J.headerHeight)
          ? document
              .querySelector(selectors$J.headerHeight)
              .getBoundingClientRect().height
          : 0;
      window.scrollTo({
        top: e + window.scrollY - t,
        left: 0,
        behavior: "smooth",
      });
    };
  let PopupCookie = class {
    write() {
      ((-1 !== document.cookie.indexOf("; ") &&
        !document.cookie.split("; ").find((e) => e.startsWith(this.name))) ||
        -1 === document.cookie.indexOf("; ")) &&
        (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
    }
    read() {
      if (
        -1 !== document.cookie.indexOf("; ") &&
        document.cookie.split("; ").find((e) => e.startsWith(this.name))
      ) {
        return document.cookie
          .split("; ")
          .find((e) => e.startsWith(this.name))
          .split("=")[1];
      }
      return !1;
    }
    destroy() {
      document.cookie.split("; ").find((e) => e.startsWith(this.name)) &&
        (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
    }
    constructor(e, t, s) {
      (this.configuration = {
        expires: s,
        path: "/",
        domain: window.location.hostname,
      }),
        (this.name = e),
        (this.value = t);
    }
  };
  const selectors$I = {
      newsletterForm: "[data-newsletter-form]",
      newsletterHeading: "[data-newsletter-heading]",
      newsletterPopup: "[data-newsletter]",
    },
    classes$B = {
      success: "has-success",
      error: "not-success",
      hide: "hide",
    },
    attributes$b = {
      cookieNameAttribute: "data-cookie-name",
    },
    sections$l = {};
  let NewsletterCheckForResult = class {
    init() {
      this.newsletter.addEventListener("submit", this.newsletterSubmit),
        this.showMessage();
    }
    newsletterSubmitEvent(e) {
      this.stopSubmit &&
        (e.preventDefault(),
        e.stopImmediatePropagation(),
        this.removeStorage(),
        this.writeStorage(),
        (this.stopSubmit = !1),
        this.newsletter.submit());
    }
    checkForChallengePage() {
      this.isChallengePage = "/challenge" === window.location.pathname;
    }
    writeStorage() {
      void 0 !== this.sessionStorage &&
        this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
    }
    readStorage() {
      this.formID = this.sessionStorage.getItem("newsletter_form_id");
    }
    removeStorage() {
      this.sessionStorage.removeItem("newsletter_form_id");
    }
    showMessage() {
      if ((this.readStorage(), this.newsletter.id === this.formID)) {
        const e = document.getElementById(this.formID),
          t = e.parentElement.querySelector(selectors$I.newsletterHeading),
          s = -1 !== window.location.search.indexOf("?customer_posted=true"),
          i = -1 !== window.location.search.indexOf("accepts_marketing");
        s
          ? (e.classList.remove(classes$B.error),
            e.classList.add(classes$B.success),
            t &&
              (t.classList.add(classes$B.hide),
              e.classList.remove(classes$B.hide)),
            this.popup && this.cookie.write())
          : i &&
            (e.classList.remove(classes$B.success),
            e.classList.add(classes$B.error),
            t &&
              (t.classList.add(classes$B.hide),
              e.classList.remove(classes$B.hide))),
          (s || i) &&
            window.addEventListener("load", () => {
              this.scrollToForm(e);
            });
      }
    }
    scrollToForm(e) {
      const t = e.getBoundingClientRect();
      (t.top >= 0 &&
        t.left >= 0 &&
        t.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        t.right <=
          (window.innerWidth || document.documentElement.clientWidth)) ||
        setTimeout(() => {
          scrollTo(e.getBoundingClientRect().top);
        }, 500);
    }
    unload() {
      this.newsletter.removeEventListener("submit", this.newsletterSubmit);
    }
    constructor(e) {
      (this.sessionStorage = window.sessionStorage),
        (this.newsletter = e),
        (this.popup = this.newsletter.closest(selectors$I.newsletterPopup)),
        this.popup &&
          (this.cookie = new PopupCookie(
            this.popup.getAttribute(attributes$b.cookieNameAttribute),
            "user_has_closed",
            null
          )),
        (this.stopSubmit = !0),
        (this.isChallengePage = !1),
        (this.formID = null),
        this.checkForChallengePage(),
        (this.newsletterSubmit = (e) => this.newsletterSubmitEvent(e)),
        this.isChallengePage || this.init();
    }
  };
  const newsletterCheckForResultSection = {
    onLoad() {
      sections$l[this.id] = [];
      this.container
        .querySelectorAll(selectors$I.newsletterForm)
        .forEach((e) => {
          sections$l[this.id].push(new NewsletterCheckForResult(e));
        });
    },
    onUnload() {
      sections$l[this.id].forEach((e) => {
        "function" == typeof e.unload && e.unload();
      });
    },
  };

  function Listeners() {
    this.entries = [];
  }

  function getVariantFromSerializedArray(e, t) {
    return (
      _validateProductStructure(e),
      getVariantFromOptionArray(e, _createOptionArrayFromOptionCollection(e, t))
    );
  }

  function getVariantFromOptionArray(e, t) {
    return (
      _validateProductStructure(e),
      _validateOptionsArray(t),
      e.variants.filter(function (e) {
        return t.every(function (t, s) {
          return e.options[s] === t;
        });
      })[0] || null
    );
  }

  function _createOptionArrayFromOptionCollection(e, t) {
    _validateProductStructure(e), _validateSerializedArray(t);
    var s = [];
    return (
      t.forEach(function (t) {
        for (var i = 0; i < e.options.length; i++) {
          if (
            (e.options[i].name || e.options[i]).toLowerCase() ===
            t.name.toLowerCase()
          ) {
            s[i] = t.value;
            break;
          }
        }
      }),
      s
    );
  }

  function _validateProductStructure(e) {
    if ("object" != typeof e) throw new TypeError(e + " is not an object.");
    if (0 === Object.keys(e).length && e.constructor === Object)
      throw new Error(e + " is empty.");
  }

  function _validateSerializedArray(e) {
    if (!Array.isArray(e)) throw new TypeError(e + " is not an array.");
    if (0 === e.length) throw new Error(e + " is empty.");
    if (!e[0].hasOwnProperty("name"))
      throw new Error(e[0] + "does not contain name key.");
    if ("string" != typeof e[0].name)
      throw new TypeError(
        "Invalid value type passed for name of option " +
          e[0].name +
          ". Value should be string."
      );
  }

  function _validateOptionsArray(e) {
    if (Array.isArray(e) && "object" == typeof e[0])
      throw new Error(e + "is not a valid array of options.");
  }
  register("footer", [
    popoutSection,
    parallaxHero,
    newsletterCheckForResultSection,
  ]),
    (Listeners.prototype.add = function (e, t, s) {
      this.entries.push({
        element: e,
        event: t,
        fn: s,
      }),
        e.addEventListener(t, s);
    }),
    (Listeners.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (e) {
        return e.element.removeEventListener(e.event, e.fn), !1;
      });
    });
  var selectors$H = {
    idInput: '[name="id"]',
    planInput: '[name="selling_plan"]',
    optionInput: '[name^="options"]',
    quantityInput: '[name="quantity"]',
    propertyInput: '[name^="properties"]',
  };

  function getUrlWithVariant(e, t) {
    return /variant=/.test(e)
      ? e.replace(/(variant=)[^&]+/, "$1" + t)
      : /\?/.test(e)
      ? e.concat("&variant=").concat(t)
      : e.concat("?variant=").concat(t);
  }
  let ProductForm = class {
    destroy() {
      this._listeners.removeAll();
    }
    options() {
      return this._serializeInputValues(this.optionInputs, function (e) {
        return (e.name = /(?:^(options\[))(.*?)(?:\])/.exec(e.name)[2]), e;
      });
    }
    variant() {
      const e = this.options();
      return e.length
        ? getVariantFromSerializedArray(this.product, e)
        : this.product.variants[0];
    }
    plan(e) {
      let t = {
        allocation: null,
        group: null,
        detail: null,
      };
      const s = this.element.querySelector(`${selectors$H.planInput}:checked`);
      if (!s) return null;
      const i = s.value,
        o = i && "" !== i ? i : null;
      return (
        o &&
          e &&
          (t.allocation = e.selling_plan_allocations.find(function (e) {
            return e.selling_plan_id.toString() === o.toString();
          })),
        t.allocation &&
          (t.group = this.product.selling_plan_groups.find(function (e) {
            return (
              e.id.toString() === t.allocation.selling_plan_group_id.toString()
            );
          })),
        t.group &&
          (t.detail = t.group.selling_plans.find(function (e) {
            return e.id.toString() === o.toString();
          })),
        t && t.allocation && t.detail && t.allocation ? t : null
      );
    }
    properties() {
      return this._serializeInputValues(this.propertyInputs, function (e) {
        return (e.name = /(?:^(properties\[))(.*?)(?:\])/.exec(e.name)[2]), e;
      });
    }
    quantity() {
      return this.quantityInputs[0]
        ? Number.parseInt(this.quantityInputs[0].value, 10)
        : 1;
    }
    getFormState() {
      const e = this.variant();
      return {
        options: this.options(),
        variant: e,
        properties: this.properties(),
        quantity: this.quantity(),
        plan: this.plan(e),
      };
    }
    _setIdInputValue(e) {
      e && e.id
        ? (this.variantElement.value = e.id.toString())
        : (this.variantElement.value = ""),
        this.variantElement.dispatchEvent(new Event("change"));
    }
    _onSubmit(e, t) {
      (t.dataset = this.getFormState()), e.onFormSubmit && e.onFormSubmit(t);
    }
    _onOptionChange(e) {
      this._setIdInputValue(e.dataset.variant);
    }
    _onFormEvent(e) {
      return void 0 === e
        ? Function.prototype.bind()
        : function (t) {
            (t.dataset = this.getFormState()),
              this._setIdInputValue(t.dataset.variant),
              e(t);
          }.bind(this);
    }
    _initInputs(e, t) {
      return Array.prototype.slice.call(this.element.querySelectorAll(e)).map(
        function (e) {
          return this._listeners.add(e, "change", this._onFormEvent(t)), e;
        }.bind(this)
      );
    }
    _serializeInputValues(e, t) {
      return e.reduce(function (e, s) {
        return (
          (s.checked || ("radio" !== s.type && "checkbox" !== s.type)) &&
            e.push(
              t({
                name: s.name,
                value: s.value,
              })
            ),
          e
        );
      }, []);
    }
    _validateProductObject(e) {
      if ("object" != typeof e) throw new TypeError(e + " is not an object.");
      if (void 0 === e.variants[0].options)
        throw new TypeError(
          "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
        );
      return e;
    }
    constructor(e, t, s) {
      (this.element = e),
        (this.product = this._validateProductObject(t)),
        (this.variantElement = this.element.querySelector(selectors$H.idInput)),
        (s = s || {}),
        (this._listeners = new Listeners()),
        this._listeners.add(
          this.element,
          "submit",
          this._onSubmit.bind(this, s)
        ),
        (this.optionInputs = this._initInputs(
          selectors$H.optionInput,
          s.onOptionChange
        )),
        (this.planInputs = this._initInputs(
          selectors$H.planInput,
          s.onPlanChange
        )),
        (this.quantityInputs = this._initInputs(
          selectors$H.quantityInput,
          s.onQuantityChange
        )),
        (this.propertyInputs = this._initInputs(
          selectors$H.propertyInput,
          s.onPropertyChange
        ));
    }
  };

  function fetchProduct(e) {
    const t = `${window.theme.routes.root}products/${e}.js`;
    return window
      .fetch(t)
      .then((e) => e.json())
      .catch((e) => {
        console.error(e);
      });
  }

  function getScript(e, t, s) {
    let i = document.getElementsByTagName("head")[0],
      o = !1,
      r = document.createElement("script");
    (r.src = e),
      (r.onload = r.onreadystatechange =
        function () {
          o ||
          (this.readyState &&
            "loaded" != this.readyState &&
            "complete" != this.readyState)
            ? s()
            : ((o = !0), t());
        }),
      i.appendChild(r);
  }
  const loaders = {};

  function loadScript(e = {}) {
    if ((e.type || (e.type = "json"), e.url))
      return loaders[e.url]
        ? loaders[e.url]
        : getScriptWithPromise(e.url, e.type);
    if (e.json)
      return loaders[e.json]
        ? Promise.resolve(loaders[e.json])
        : window
            .fetch(e.json)
            .then((e) => e.json())
            .then((t) => ((loaders[e.json] = t), t));
    if (e.name) {
      const t = "".concat(e.name, e.version);
      return loaders[t] ? loaders[t] : loadShopifyWithPromise(e);
    }
    return Promise.reject();
  }

  function getScriptWithPromise(e, t) {
    const s = new Promise((s, i) => {
      "text" === t
        ? fetch(e)
            .then((e) => e.text())
            .then((e) => {
              s(e);
            })
            .catch((e) => {
              i(e);
            })
        : getScript(
            e,
            function () {
              s();
            },
            function () {
              i();
            }
          );
    });
    return (loaders[e] = s), s;
  }

  function loadShopifyWithPromise(e) {
    const t = "".concat(e.name, e.version),
      s = new Promise((t, s) => {
        try {
          window.Shopify.loadFeatures([
            {
              name: e.name,
              version: e.version,
              onLoad: (e) => {
                onLoadFromShopify(t, s, e);
              },
            },
          ]);
        } catch (e) {
          s(e);
        }
      });
    return (loaders[t] = s), s;
  }

  function onLoadFromShopify(e, t, s) {
    return s ? t(s) : e();
  }
  (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
  const selectors$G = {
      scrollbarAttribute: "data-scrollbar",
      scrollbar: "data-scrollbar-slider",
      scrollbarSlideFullWidth: "data-scrollbar-slide-fullwidth",
      scrollbarArrowPrev: "[data-scrollbar-arrow-prev]",
      scrollbarArrowNext: "[data-scrollbar-arrow-next]",
    },
    classes$A = {
      hide: "is-hidden",
    },
    settings$2 = {
      delay: 200,
    };
  let NativeScrollbar = class {
    init() {
      this.arrowNext &&
        this.arrowPrev &&
        (this.toggleNextArrow(), this.events());
    }
    resize() {
      document.addEventListener("theme:resize", () => {
        this.toggleNextArrow();
      });
    }
    events() {
      this.arrowNext.addEventListener("click", (e) => {
        e.preventDefault(), this.goToNext();
      }),
        this.arrowPrev.addEventListener("click", (e) => {
          e.preventDefault(), this.goToPrev();
        }),
        this.scrollbar.addEventListener("scroll", () => {
          this.togglePrevArrow(), this.toggleNextArrow();
        });
    }
    goToNext() {
      const e =
        (this.scrollbar.hasAttribute(selectors$G.scrollbarSlideFullWidth)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2) +
        this.scrollbar.scrollLeft;
      this.move(e),
        this.arrowPrev.classList.remove(classes$A.hide),
        this.toggleNextArrow();
    }
    goToPrev() {
      const e = this.scrollbar.hasAttribute(selectors$G.scrollbarSlideFullWidth)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2,
        t = this.scrollbar.scrollLeft - e;
      this.move(t),
        this.arrowNext.classList.remove(classes$A.hide),
        this.togglePrevArrow();
    }
    toggleNextArrow() {
      setTimeout(() => {
        this.arrowNext.classList.toggle(
          classes$A.hide,
          Math.round(
            this.scrollbar.scrollLeft +
              this.scrollbar.getBoundingClientRect().width +
              1
          ) >= this.scrollbar.scrollWidth
        );
      }, settings$2.delay);
    }
    togglePrevArrow() {
      setTimeout(() => {
        this.arrowPrev.classList.toggle(
          classes$A.hide,
          this.scrollbar.scrollLeft <= 0
        );
      }, settings$2.delay);
    }
    scrollToVisibleElement() {
      [].forEach.call(this.scrollbar.children, (e) => {
        e.addEventListener("click", (t) => {
          t.preventDefault(), this.move(e.offsetLeft - e.clientWidth);
        });
      });
    }
    move(e) {
      this.scrollbar.scrollTo({
        top: 0,
        left: e,
        behavior: "smooth",
      });
    }
    constructor(e) {
      (this.scrollbar = e),
        (this.arrowNext = this.scrollbar.parentNode.querySelector(
          selectors$G.scrollbarArrowNext
        )),
        (this.arrowPrev = this.scrollbar.parentNode.querySelector(
          selectors$G.scrollbarArrowPrev
        )),
        this.scrollbar.hasAttribute(selectors$G.scrollbarAttribute) &&
          (this.init(), this.resize()),
        this.scrollbar.hasAttribute(selectors$G.scrollbar) &&
          this.scrollToVisibleElement();
    }
  };
  const defaults = {
      color: "ash",
    },
    selectors$F = {
      gridSwatchForm: "[data-grid-swatch-form]",
      swatch: "data-swatch",
      outerGrid: "[data-product-grid-item]",
      slide: "[data-product-image]",
      image: "data-swatch-image",
      sectionId: "[data-section-id]",
      productInfo: "[data-product-information]",
      variant: "data-swatch-variant",
      variantName: "data-swatch-variant-name",
      button: "[data-swatch-button]",
      link: "[data-product-link]",
      wrapper: "[data-grid-swatches]",
      template: "[data-swatch-template]",
      handle: "data-swatch-handle",
      label: "data-swatch-label",
      input: "[data-swatch-input]",
      text: "[data-swatch-text]",
      tooltip: "data-tooltip",
      swatchCount: "data-swatch-count",
      scrollbar: "data-scrollbar",
      dataVariantTitle: "data-variant-title",
    },
    classes$z = {
      visible: "is-visible",
      stopEvents: "no-events",
    };
  let ColorMatch = class {
      getColor() {
        return this.match;
      }
      init() {
        return loadScript({
          json: window.theme.assets.swatches,
        })
          .then((e) => this.matchColors(e, this.settings.color))
          .catch((e) => {
            console.log("failed to load swatch colors script"), console.log(e);
          });
      }
      matchColors(e, t) {
        let s = "#E5E5E5",
          i = null;
        const o = window.theme.assets.base || "/",
          r = t.toLowerCase().replace(/\s/g, ""),
          n = e.colors;
        if (n) {
          let e = null;
          if (
            n.filter((t, s) => {
              if (
                Object.keys(t).toString().toLowerCase().replace(/\s/g, "") === r
              )
                return (e = s), t;
            }).length &&
            null !== e
          ) {
            const t = Object.values(n[e])[0];
            (s = t),
              (t.includes(".jpg") ||
                t.includes(".jpeg") ||
                t.includes(".png") ||
                t.includes(".svg")) &&
                ((i = `${o}${t}`), (s = "#888888"));
          }
        }
        return {
          color: this.settings.color,
          path: i,
          hex: s,
        };
      }
      constructor(e = {}) {
        (this.settings = { ...defaults, ...e }), (this.match = this.init());
      }
    },
    Swatch = class {
      init() {
        this.setStyles(),
          this.variant && this.handleEvents(),
          this.tooltip && new Tooltip(this.tooltip);
      }
      setStyles() {
        this.colorMatch.hex &&
          this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
          this.colorMatch.path &&
            (this.element.style.setProperty(
              "background-image",
              `url(${this.colorMatch.path})`
            ),
            this.element.style.setProperty("background-size", "cover"),
            this.element.style.setProperty(
              "background-position",
              "center center"
            ));
      }
      handleEvents() {
        (this.outer = this.element.closest(selectors$F.outerGrid)),
          this.outer &&
            ((this.slide = this.outer.querySelector(selectors$F.slide)),
            (this.linkElement = this.outer.querySelector(selectors$F.link)),
            (this.linkElementAll = this.outer.querySelectorAll(
              selectors$F.link
            )),
            (this.linkDestination = getUrlWithVariant(
              this.linkElement.getAttribute("href"),
              this.variant
            )),
            (this.button = this.element.closest(selectors$F.button)),
            (this.imagesHidden = this.outer.querySelectorAll(
              `[${selectors$F.dataVariantTitle}][style*="display: none;"]`
            )),
            (this.outerHoverEvent = () => this.showHoverImages()),
            this.button.closest(selectors$F.gridSwatchForm) &&
              this.button.addEventListener(
                "mouseenter",
                function () {
                  this.changeImage();
                }.bind(this)
              ),
            this.button.closest(selectors$F.gridSwatchForm) ||
              this.button.addEventListener(
                "click",
                function () {
                  this.changeImage();
                }.bind(this)
              ),
            this.imagesHidden.length &&
              this.outer.addEventListener("mouseenter", this.outerHoverEvent));
      }
      showHoverImages() {
        this.imagesHidden.forEach((e) => {
          e.style.removeProperty("display");
        }),
          this.outer.removeEventListener("mouseenter", this.outerHoverEvent);
      }
      changeImage() {
        if (
          (this.linkElementAll.forEach((e) => {
            e.setAttribute("href", this.linkDestination);
          }),
          this.slide.setAttribute("src", this.linkDestination),
          this.image)
        ) {
          const e = this.variantName.replaceAll('"', "'"),
            t = this.slide.querySelector(
              `[${selectors$F.dataVariantTitle}="${e}"]`
            );
          if (t) {
            const e = this.slide.querySelector(
              `[${selectors$F.dataVariantTitle}].${classes$z.visible}`
            );
            e && e.classList.remove(classes$z.visible),
              t.classList.add(classes$z.visible);
          }
        }
      }
      constructor(e) {
        (this.element = e),
          (this.colorString = e.getAttribute(selectors$F.swatch)),
          (this.image = e.getAttribute(selectors$F.image)),
          (this.variant = e.getAttribute(selectors$F.variant)),
          (this.variantName = e.getAttribute(selectors$F.variantName)),
          (this.tooltip = this.element.closest(`[${selectors$F.tooltip}]`));
        new ColorMatch({
          color: this.colorString,
        })
          .getColor()
          .then((e) => {
            (this.colorMatch = e), this.init();
          });
      }
    },
    GridSwatch = class {
      init() {
        (this.wrap.innerHTML = ""),
          (this.count = 0),
          this.swatches.forEach((e) => {
            let t = null,
              s = !1,
              i = "";
            for (const s of this.product.variants) {
              const o = s.options.includes(e);
              if ((!t && o && (t = s), o && s.featured_media)) {
                (i = s.featured_media.preview_image.src), (t = s);
                break;
              }
            }
            for (const t of this.product.variants) {
              if (t.options.includes(e) && t.available) {
                s = !0;
                break;
              }
            }
            if (t) {
              const o = document.createElement("div");
              o.innerHTML = this.template;
              const r = `${this.sectionId}-${this.product.id}-${t.id}`,
                n = o.querySelector(selectors$F.button),
                a = o.querySelector(selectors$F.input),
                l = o.querySelector(`[${selectors$F.label}]`),
                c = o.querySelector(selectors$F.text);
              (n.style = `--animation-delay: ${(100 * this.count) / 1e3}s`),
                (n.dataset.tooltip = e),
                (a.value = e),
                (a.id = r),
                (a.dataset.variant = t.id),
                (a.disabled = !s),
                (l.htmlFor = r),
                (l.dataset.swatch = e),
                (l.dataset.variant = t),
                (l.dataset.variantName = t.title.replaceAll('"', "'")),
                (l.dataset.image = i),
                (c.innerText = e),
                (this.wrap.innerHTML += o.innerHTML),
                this.count++;
            }
          }),
          (this.swatchCount = this.productLink.querySelector(
            `[${selectors$F.swatchCount}]`
          )),
          (this.swatchElements = this.wrap.querySelectorAll(
            `[${selectors$F.swatch}]`
          )),
          (this.swatchForm = this.productLink.querySelector(
            selectors$F.gridSwatchForm
          )),
          (this.hideSwatchesTimer = 0),
          this.swatchCount.hasAttribute(selectors$F.swatchCount) &&
            ((this.swatchCount.innerText = `${this.count} ${
              this.count > 1 ? theme.strings.otherColor : theme.strings.oneColor
            }`),
            this.swatchCount.addEventListener("mouseenter", () => {
              this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
                this.productLink.classList.add(classes$z.stopEvents),
                this.swatchForm.classList.add(classes$z.visible);
            }),
            this.productInfo.addEventListener("mouseleave", () => {
              this.hideSwatchesTimer = setTimeout(() => {
                this.productLink.classList.remove(classes$z.stopEvents),
                  this.swatchForm.classList.remove(classes$z.visible);
              }, 100);
            })),
          this.wrap.hasAttribute(selectors$F.scrollbar) &&
            new NativeScrollbar(this.wrap),
          this.swatchElements.forEach((e) => {
            new Swatch(e);
          });
      }
      constructor(e, t) {
        (this.container = t),
          (this.wrap = e),
          (this.outerGrid = e.closest(selectors$F.outerGrid)),
          (this.productLink = e.closest(selectors$F.link)),
          (this.productInfo = e.closest(selectors$F.productInfo)),
          (this.template = document.querySelector(
            selectors$F.template
          ).innerHTML),
          (this.handle = e.getAttribute(selectors$F.handle)),
          (this.sectionId = this.wrap.closest(
            selectors$F.sectionId
          ).dataset.sectionId);
        const s = e.getAttribute(selectors$F.label).trim().toLowerCase();
        fetchProduct(this.handle).then((e) => {
          (this.product = e),
            (this.colorOption = e.options.find(function (e) {
              return e.name.toLowerCase() === s || null;
            })),
            this.colorOption &&
              ((this.swatches = this.colorOption.values), this.init());
        });
      }
    };
  const makeGridSwatches = (e) => {
      e.container.querySelectorAll(selectors$F.wrapper).forEach((e) => {
        new GridSwatch(e, void 0);
      });
    },
    swatchSection = {
      onLoad() {
        this.swatches = [];
        this.container
          .querySelectorAll(`[${selectors$F.swatch}]`)
          .forEach((e) => {
            this.swatches.push(new Swatch(e));
          });
      },
    },
    swatchGridSection = {
      onLoad() {
        makeGridSwatches(this);
      },
    },
    selectors$E = {
      dataEnableSound: "data-enable-sound",
      dataEnableBackground: "data-enable-background",
      dataEnableAutoplay: "data-enable-autoplay",
      dataEnableLoop: "data-enable-loop",
      dataVideoId: "data-video-id",
      dataVideoType: "data-video-type",
      videoIframe: "[data-video-id]",
    },
    classes$y = {
      loaded: "loaded",
    };
  let LoadVideoVimeo = class {
    init() {
      this.loadVimeoPlayer();
    }
    loadVimeoPlayer() {
      const e = "https://vimeo.com/" + this.videoID;
      let t = "";
      const s = this.player,
        i = {
          url: e,
          background: this.enableBackground,
          muted: this.disableSound,
          autoplay: this.enableAutoplay,
          loop: this.enableLoop,
        };
      for (let e in i)
        t += encodeURIComponent(e) + "=" + encodeURIComponent(i[e]) + "&";
      fetch(`https://vimeo.com/api/oembed.json?${t}`)
        .then((e) => e.json())
        .then(function (e) {
          (s.innerHTML = e.html),
            setTimeout(function () {
              s.parentElement.classList.add(classes$y.loaded);
            }, 1e3);
        })
        .catch(function (e) {
          console.log(e);
        });
    }
    constructor(e) {
      (this.container = e),
        (this.player = this.container.querySelector(selectors$E.videoIframe)),
        this.player &&
          ((this.videoID = this.player.getAttribute(selectors$E.dataVideoId)),
          (this.videoType = this.player.getAttribute(
            selectors$E.dataVideoType
          )),
          (this.enableBackground =
            "true" ===
            this.player.getAttribute(selectors$E.dataEnableBackground)),
          (this.disableSound =
            "false" === this.player.getAttribute(selectors$E.dataEnableSound)),
          (this.enableAutoplay =
            "false" !==
            this.player.getAttribute(selectors$E.dataEnableAutoplay)),
          (this.enableLoop =
            "false" !== this.player.getAttribute(selectors$E.dataEnableLoop)),
          "vimeo" == this.videoType && this.init());
    }
  };
  const selectors$D = {
      dataSectionId: "data-section-id",
      dataEnableSound: "data-enable-sound",
      dataHideOptions: "data-hide-options",
      dataCheckPlayerVisibility: "data-check-player-visibility",
      dataVideoId: "data-video-id",
      dataVideoType: "data-video-type",
      videoIframe: "[data-video-id]",
      videoWrapper: ".video-wrapper",
      youtubeWrapper: "[data-youtube-wrapper]",
    },
    classes$x = {
      loaded: "loaded",
    },
    players = [];
  let LoadVideoYT = class {
    init() {
      window.isYoutubeAPILoaded
        ? this.loadYoutubePlayer()
        : loadScript({
            url: "https://www.youtube.com/iframe_api",
          }).then(() => this.loadYoutubePlayer());
    }
    loadYoutubePlayer() {
      const e = {
        ...{
          height: "720",
          width: "1280",
          playerVars: this.videoOptionsVars,
          events: {
            onReady: (e) => {
              const t = e.target.getIframe(),
                s = t.id,
                i =
                  "true" ===
                  document
                    .querySelector(`#${s}`)
                    .getAttribute(selectors$D.dataEnableSound);
              t.setAttribute("tabindex", "-1"),
                i ? e.target.unMute() : e.target.mute(),
                e.target.playVideo(),
                this.checkPlayerVisibilityFlag &&
                  (this.checkPlayerVisibility(s),
                  window.addEventListener(
                    "scroll",
                    throttle(() => {
                      this.checkPlayerVisibility(s);
                    }, 150)
                  ));
            },
            onStateChange: (e) => {
              0 == e.data && e.target.playVideo(),
                1 == e.data &&
                  e.target
                    .getIframe()
                    .parentElement.classList.add(classes$x.loaded);
            },
          },
        },
      };
      (e.videoId = this.videoID),
        this.videoID.length &&
          YT.ready(() => {
            players[this.playerID] = new YT.Player(this.playerID, e);
          }),
        (window.isYoutubeAPILoaded = !0);
    }
    checkPlayerVisibility(e) {
      let t;
      if ("string" == typeof e) t = e;
      else {
        if (null == e.data) return;
        t = e.data.id;
      }
      const s = document.getElementById(t + "-container");
      if (!s) return;
      const i = players[t],
        o = s.getBoundingClientRect();
      let r =
        visibilityHelper.isElementPartiallyVisible(s) ||
        visibilityHelper.isElementTotallyVisible(s);
      o.top < 0 && s.clientHeight + o.top >= 0 && (r = !0),
        r && i && "function" == typeof i.playVideo
          ? i.playVideo()
          : !r && i && "function" == typeof i.pauseVideo && i.pauseVideo();
    }
    onUnload() {
      const e =
        "youtube-" + this.container.getAttribute(selectors$D.dataSectionId);
      players[e] && players[e].destroy();
    }
    constructor(e) {
      (this.container = e),
        (this.player = this.container.querySelector(selectors$D.videoIframe)),
        this.player &&
          ((this.videoOptionsVars = {}),
          (this.videoID = this.player.getAttribute(selectors$D.dataVideoId)),
          (this.videoType = this.player.getAttribute(
            selectors$D.dataVideoType
          )),
          "youtube" == this.videoType &&
            ((this.checkPlayerVisibilityFlag =
              "true" ===
              this.player.getAttribute(selectors$D.dataCheckPlayerVisibility)),
            (this.playerID = this.player.querySelector(
              selectors$D.youtubeWrapper
            )
              ? this.player.querySelector(selectors$D.youtubeWrapper).id
              : this.player.id),
            this.player.hasAttribute(selectors$D.dataHideOptions) &&
              (this.videoOptionsVars = {
                cc_load_policy: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                autohide: 0,
                controls: 0,
                branding: 0,
                showinfo: 0,
                rel: 0,
                fs: 0,
                wmode: "opaque",
              }),
            this.init(),
            this.container.addEventListener(
              "touchstart",
              function (e) {
                if (
                  e.target.matches(selectors$D.videoWrapper) ||
                  e.target.closest(selectors$D.videoWrapper)
                ) {
                  const t = e.target.querySelector(selectors$D.videoIframe).id;
                  players[t].playVideo();
                }
              },
              {
                passive: !0,
              }
            )));
    }
  };
  const selectors$C = {
      popupContainer: ".pswp",
      popupCloseBtn: ".pswp__custom-close",
      popupIframe: "iframe, video",
      popupCustomIframe: ".pswp__custom-iframe",
      popupThumbs: ".pswp__thumbs",
      popupButtons: ".pswp__button, .pswp__caption-close",
    },
    classes$w = {
      current: "is-current",
      customLoader: "pswp--custom-loader",
      customOpen: "pswp--custom-opening",
      loader: "pswp__loader",
      popupCloseButton: "pswp__button--close",
    },
    attributes$a = {
      dataOptionClasses: "data-pswp-option-classes",
      dataVideoType: "data-video-type",
      ariaCurrent: "aria-current",
    },
    loaderHTML = `<div class="${classes$w.loader}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
  let LoadPhotoswipe = class {
    init() {
      this.pswpElement.classList.add(classes$w.customOpen),
        this.initLoader(),
        loadScript({
          url: window.theme.assets.photoswipe,
        })
          .then(() => this.loadPopup())
          .catch((e) => console.error(e));
    }
    initLoader() {
      if (
        this.pswpElement.classList.contains(classes$w.customLoader) &&
        "" !== this.options &&
        this.options.mainClass
      ) {
        this.pswpElement.setAttribute(
          attributes$a.dataOptionClasses,
          this.options.mainClass
        );
        let e = document.createElement("div");
        (e.innerHTML = loaderHTML),
          (e = e.firstChild),
          this.pswpElement.appendChild(e);
      } else this.pswpElement.setAttribute(attributes$a.dataOptionClasses, "");
    }
    loadPopup() {
      const e = window.themePhotoswipe.PhotoSwipe.default,
        t = window.themePhotoswipe.PhotoSwipeUI.default;
      this.pswpElement.classList.contains(classes$w.customLoader) &&
        this.pswpElement.classList.remove(classes$w.customLoader),
        this.pswpElement.classList.remove(classes$w.customOpen),
        (this.popup = new e(this.pswpElement, t, this.items, this.options)),
        this.popup.init(),
        this.initVideo(),
        this.thumbsActions(),
        this.isVideo && this.hideUnusedButtons(),
        setTimeout(() => {
          this.a11y.trapFocus(this.pswpElement, {
            elementToFocus: this.closeBtn,
          });
        }, 200),
        this.popup.listen("close", () => this.onClose()),
        this.options &&
          this.options.closeElClasses &&
          this.options.closeElClasses.length &&
          this.options.closeElClasses.forEach((e) => {
            const t = this.pswpElement.querySelector(`.pswp__${e}`);
            t && t.addEventListener("keyup", this.keyupCloseEvent);
          });
    }
    initVideo() {
      const e = this.pswpElement.querySelector(selectors$C.popupCustomIframe);
      if (e) {
        const t = e.getAttribute(attributes$a.dataVideoType);
        (this.isVideo = !0),
          "youtube" == t
            ? new LoadVideoYT(e.parentElement)
            : "vimeo" == t && new LoadVideoVimeo(e.parentElement);
      }
    }
    thumbsActions() {
      this.popupThumbsContainer &&
        this.popupThumbsContainer.firstChild &&
        (this.popupThumbsContainer.addEventListener("wheel", (e) =>
          this.stopDisabledScroll(e)
        ),
        this.popupThumbsContainer.addEventListener("mousewheel", (e) =>
          this.stopDisabledScroll(e)
        ),
        this.popupThumbsContainer.addEventListener("DOMMouseScroll", (e) =>
          this.stopDisabledScroll(e)
        ),
        (this.popupThumbs = this.pswpElement.querySelectorAll(
          `${selectors$C.popupThumbs} > *`
        )),
        this.popupThumbs.forEach((e, t) => {
          e.addEventListener("click", (s) => {
            s.preventDefault();
            const i = e.parentElement.querySelector(`.${classes$w.current}`);
            i.classList.remove(classes$w.current),
              i.setAttribute(attributes$a.ariaCurrent, !1),
              e.classList.add(classes$w.current),
              e.setAttribute(attributes$a.ariaCurrent, !0),
              this.popup.goTo(t);
          });
        }),
        this.popup.listen("imageLoadComplete", () => this.setCurrentThumb()),
        this.popup.listen("beforeChange", () => this.setCurrentThumb()));
    }
    hideUnusedButtons() {
      const e = this.pswpElement.querySelectorAll(selectors$C.popupButtons);
      e.length &&
        e.forEach((e) => {
          e.classList.contains(classes$w.popupCloseButton) ||
            (e.style.display = "none");
        });
    }
    stopDisabledScroll(e) {
      e.stopPropagation();
    }
    keyupClose(e) {
      e.code === window.theme.keyboardKeys.ENTER && this.popup.close();
    }
    onClose() {
      const e = this.pswpElement.querySelector(selectors$C.popupIframe);
      if (
        (e && e.parentNode.removeChild(e),
        this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
      )
        for (; this.popupThumbsContainer.firstChild; )
          this.popupThumbsContainer.removeChild(
            this.popupThumbsContainer.firstChild
          );
      this.pswpElement.setAttribute(attributes$a.dataOptionClasses, "");
      const t = this.pswpElement.querySelector(`.${classes$w.loader}`);
      t && this.pswpElement.removeChild(t),
        this.options &&
          this.options.closeElClasses &&
          this.options.closeElClasses.length &&
          this.options.closeElClasses.forEach((e) => {
            const t = this.pswpElement.querySelector(`.pswp__${e}`);
            t && t.removeEventListener("keyup", this.keyupCloseEvent);
          }),
        this.a11y.removeTrapFocus(),
        window.accessibility.lastElement &&
          setTimeout(() => {
            window.accessibility.lastElement.focus();
          }, 200);
    }
    setCurrentThumb() {
      const e = this.pswpElement.querySelector(
        `${selectors$C.popupThumbs} > .${classes$w.current}`
      );
      if (
        (e &&
          (e.classList.remove(classes$w.current),
          e.setAttribute(attributes$a.ariaCurrent, !1)),
        !this.popupThumbs)
      )
        return;
      const t = this.popupThumbs[this.popup.getCurrentIndex()];
      t.classList.add(classes$w.current),
        t.setAttribute(attributes$a.ariaCurrent, !0),
        this.scrollThumbs(t);
    }
    scrollThumbs(e) {
      const t =
          this.popupThumbsContainer.scrollLeft +
          this.popupThumbsContainer.offsetWidth,
        s = e.offsetLeft;
      if (t <= s + e.offsetWidth || t > s) {
        const t = parseInt(window.getComputedStyle(e).marginLeft);
        this.popupThumbsContainer.scrollTo({
          top: 0,
          left: s - t,
          behavior: "smooth",
        });
      }
    }
    constructor(e, t = "") {
      (this.items = e),
        (this.pswpElement = document.querySelectorAll(
          selectors$C.popupContainer
        )[0]),
        (this.popup = null),
        (this.popupThumbs = null),
        (this.isVideo = !1),
        (this.popupThumbsContainer = this.pswpElement.querySelector(
          selectors$C.popupThumbs
        )),
        (this.closeBtn = this.pswpElement.querySelector(
          selectors$C.popupCloseBtn
        )),
        (this.keyupCloseEvent = (e) => this.keyupClose(e)),
        (this.a11y = a11y);
      (this.options =
        "" !== t
          ? t
          : {
              history: !1,
              focus: !1,
              mainClass: "",
            }),
        this.init();
    }
  };
  const selectors$B = {
      zoomWrapper: "[data-zoom-wrapper]",
      dataImageSrc: "data-image-src",
      dataImageWidth: "data-image-width",
      dataImageHeight: "data-image-height",
      dataImageAlt: "data-image-alt",
      dataImageZoomEnable: "data-image-zoom-enable",
      thumbs: ".pswp__thumbs",
      caption: "[data-zoom-caption]",
    },
    classes$v = {
      variantSoldOut: "variant--soldout",
      variantUnavailable: "variant--unavailable",
      popupThumb: "pswp__thumb",
      popupClass: "pswp-zoom-gallery",
      popupClassNoThumbs: "pswp-zoom-gallery--single",
      popupTitle: "product__title",
      popupTitleNew: "product__title pswp__title",
    };
  let Zoom = class {
    init() {
      this.zoomWrappers.length &&
        this.zoomWrappers.forEach((e, t) => {
          e.addEventListener("click", (s) => {
            s.preventDefault(),
              this.createZoom(t),
              (window.accessibility.lastElement = e);
          }),
            e.addEventListener("keyup", (s) => {
              s.code === window.theme.keyboardKeys.ENTER &&
                (s.preventDefault(),
                this.createZoom(t),
                (window.accessibility.lastElement = e));
            });
        });
    }
    createZoom(e) {
      let t = [],
        s = 0,
        i = "";
      this.zoomWrappers.forEach((o) => {
        const r = o.getAttribute(selectors$B.dataImageSrc),
          n = o.hasAttribute(selectors$B.dataImageAlt)
            ? o.getAttribute(selectors$B.dataImageAlt)
            : "";
        if (
          ((s += 1),
          t.push({
            src: r,
            w: parseInt(o.getAttribute(selectors$B.dataImageWidth)),
            h: parseInt(o.getAttribute(selectors$B.dataImageHeight)),
            msrc: r,
          }),
          (i += `<a href="#" class="${classes$v.popupThumb}" style="background-image: url('${r}')" aria-label="${n}" aria-current="false"></a>`),
          this.zoomWrappers.length === s)
        ) {
          const o = {
            history: !1,
            focus: !1,
            index: e,
            mainClass:
              1 === s
                ? `${classes$v.popupClass} ${classes$v.popupClassNoThumbs}`
                : `${classes$v.popupClass}`,
            showHideOpacity: !0,
            howAnimationDuration: 150,
            hideAnimationDuration: 250,
            closeOnScroll: !1,
            closeOnVerticalDrag: !1,
            captionEl: !0,
            closeEl: !0,
            closeElClasses: ["caption-close", "title"],
            tapToClose: !1,
            clickToCloseNonZoomable: !1,
            maxSpreadZoom: 2,
            loop: !0,
            spacing: 0,
            allowPanToNext: !0,
            pinchToClose: !1,
            addCaptionHTMLFn: (e, t, s) => {
              this.zoomCaption(e, t, s);
            },
            getThumbBoundsFn: () => {
              const t = this.zoomWrappers[e],
                s = window.pageYOffset || document.documentElement.scrollTop,
                i = t.getBoundingClientRect();
              return {
                x: i.left,
                y: i.top + s,
                w: i.width,
              };
            },
          };
          new LoadPhotoswipe(t, o),
            this.thumbsContainer &&
              "" !== i &&
              (this.thumbsContainer.innerHTML = i);
        }
      });
    }
    zoomCaption(e, t) {
      let s = "";
      const i = t.children[0];
      return (
        this.zoomCaptionElem &&
          ((s = this.zoomCaptionElem.innerHTML),
          this.zoomCaptionElem.closest(`.${classes$v.variantSoldOut}`)
            ? i.classList.add(classes$v.variantSoldOut)
            : i.classList.remove(classes$v.variantSoldOut),
          this.zoomCaptionElem.closest(`.${classes$v.variantUnavailable}`)
            ? i.classList.add(classes$v.variantUnavailable)
            : i.classList.remove(classes$v.variantUnavailable)),
        (s = s.replaceAll(classes$v.popupTitle, classes$v.popupTitleNew)),
        (i.innerHTML = s),
        !1
      );
    }
    constructor(e) {
      (this.container = e.container),
        (this.zoomWrappers = this.container.querySelectorAll(
          selectors$B.zoomWrapper
        )),
        (this.thumbsContainer = document.querySelector(selectors$B.thumbs)),
        (this.zoomCaptionElem = this.container.querySelector(
          selectors$B.caption
        )),
        (this.zoomEnable =
          "true" ===
          this.container.getAttribute(selectors$B.dataImageZoomEnable)),
        this.zoomEnable && this.init();
    }
  };
  const hosts = {
      html5: "html5",
      youtube: "youtube",
      vimeo: "vimeo",
    },
    selectors$A = {
      deferredMedia: "[data-deferred-media]",
      deferredMediaButton: "[data-deferred-media-button]",
      productMediaWrapper: "[data-product-single-media-wrapper]",
      productMediaSlider: "[data-product-single-media-slider]",
      mediaContainer: "[data-video]",
      mediaId: "data-media-id",
      dataTallLayout: "data-tall-layout",
    },
    classes$u = {
      mediaHidden: "media--hidden",
    };
  theme.mediaInstances = {};
  let Video = class {
    init() {
      this.container
        .querySelectorAll(selectors$A.mediaContainer)
        .forEach((e) => {
          const t = e.querySelector(selectors$A.deferredMediaButton);
          t && t.addEventListener("click", this.loadContent.bind(this, e));
        });
    }
    loadContent(e) {
      if (e.querySelector(selectors$A.deferredMedia).getAttribute("loaded"))
        return;
      const t = document.createElement("div");
      t.appendChild(
        e.querySelector("template").content.firstElementChild.cloneNode(!0)
      );
      const s = e.dataset.mediaId,
        i = t.querySelector("video, iframe"),
        o = this.hostFromVideoElement(i),
        r = e.querySelector(selectors$A.deferredMedia);
      r.appendChild(i).focus(),
        r.setAttribute("loaded", !0),
        (this.players[s] = {
          mediaId: s,
          sectionId: this.id,
          container: e,
          element: i,
          host: o,
          ready: () => this.createPlayer(s),
        });
      const n = this.players[s];
      switch (n.host) {
        case hosts.html5:
          this.loadVideo(n, hosts.html5);
          break;
        case hosts.vimeo:
          window.isVimeoAPILoaded
            ? this.loadVideo(n, hosts.vimeo)
            : loadScript({
                url: "https://player.vimeo.com/api/player.js",
              }).then(() => this.loadVideo(n, hosts.vimeo));
          break;
        case hosts.youtube:
          window.isYoutubeAPILoaded
            ? this.loadVideo(n, hosts.youtube)
            : loadScript({
                url: "https://www.youtube.com/iframe_api",
              }).then(() => this.loadVideo(n, hosts.youtube));
      }
    }
    hostFromVideoElement(e) {
      if ("VIDEO" === e.tagName) return hosts.html5;
      if ("IFRAME" === e.tagName) {
        if (
          /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
            e.src
          )
        )
          return hosts.youtube;
        if (e.src.includes("vimeo.com")) return hosts.vimeo;
      }
      return null;
    }
    loadVideo(e, t) {
      e.host === t && e.ready();
    }
    createPlayer(e) {
      const t = this.players[e];
      switch (t.host) {
        case hosts.html5:
          t.element.play(),
            t.element.addEventListener("play", () => this.pauseOtherMedia(e)),
            t.element.play(),
            t.container.addEventListener("theme:media:hidden", (e) =>
              this.onHidden(e)
            ),
            t.container.addEventListener("xrLaunch", (e) => this.onHidden(e)),
            t.container.addEventListener("theme:media:visible", (e) =>
              this.onVisible(e)
            ),
            this.tallLayout && this.observeVideo(t, e);
          break;
        case hosts.vimeo:
          (this.players[e].player = new Vimeo.Player(t.element)),
            this.players[e].player.play(),
            (window.isVimeoAPILoaded = !0),
            t.container.addEventListener("theme:media:hidden", (e) =>
              this.onHidden(e)
            ),
            t.container.addEventListener("xrLaunch", (e) => this.onHidden(e)),
            t.container.addEventListener("theme:media:visible", (e) =>
              this.onVisible(e)
            ),
            this.tallLayout && this.observeVideo(t, e);
          break;
        case hosts.youtube:
          if (t.host == hosts.youtube && t.player) return;
          YT.ready(() => {
            const s = t.container.dataset.videoId;
            (this.players[e].player = new YT.Player(t.element, {
              videoId: s,
              events: {
                onReady: (e) => e.target.playVideo(),
              },
            })),
              (window.isYoutubeAPILoaded = !0),
              t.container.addEventListener("theme:media:hidden", (e) =>
                this.onHidden(e)
              ),
              t.container.addEventListener("xrLaunch", (e) => this.onHidden(e)),
              t.container.addEventListener("theme:media:visible", (e) =>
                this.onVisible(e)
              ),
              this.tallLayout && this.observeVideo(t, e);
          });
      }
    }
    observeVideo(e, t) {
      new IntersectionObserver(
        (s, i) => {
          s.forEach((s) => {
            1 != s.intersectionRatio
              ? this.pauseVideo(e)
              : (this.playVideo(e), this.pauseOtherMedia(t));
          });
        },
        {
          threshold: 1,
        }
      ).observe(e.element);
    }
    playVideo(e) {
      e.player && e.player.playVideo
        ? e.player.playVideo()
        : e.element && e.element.play
        ? e.element.play()
        : e.player && e.player.play && e.player.play();
    }
    pauseVideo(e) {
      e.player && e.player.pauseVideo
        ? e.player.pauseVideo()
        : e.element && e.element.pause
        ? e.element.pause()
        : e.player && e.player.pause && e.player.pause();
    }
    onHidden(e) {
      void 0 !== e.target.dataset.mediaId &&
        this.pauseVideo(this.players[e.target.dataset.mediaId]);
    }
    onVisible(e) {
      void 0 !== e.target.dataset.mediaId &&
        this.playVideo(this.players[e.target.dataset.mediaId]);
    }
    pauseOtherMedia(e) {
      const t = `[${selectors$A.mediaId}="${e}"]`,
        s = document.querySelectorAll(
          `${selectors$A.productMediaWrapper}:not(${t})`
        );
      document
        .querySelector(`${selectors$A.productMediaWrapper}${t}`)
        .classList.remove(classes$u.mediaHidden),
        s.length &&
          s.forEach((e) => {
            e.dispatchEvent(new CustomEvent("theme:media:hidden")),
              e.classList.add(classes$u.mediaHidden);
          });
    }
    constructor(e) {
      (this.section = e),
        (this.container = e.container),
        (this.id = e.id),
        (this.tallLayout =
          "true" === this.container.getAttribute(selectors$A.dataTallLayout)),
        (this.players = {}),
        this.init();
    }
  };
  theme.mediaInstances = {};
  const selectors$z = {
      videoPlayer: "[data-video]",
      modelViewer: "[data-model]",
      sliderEnabled: "flickity-enabled",
    },
    classes$t = {
      mediaHidden: "media--hidden",
    };
  let Media = class {
    init() {
      this.detect3d(),
        this.launch3d(),
        new Video(this.section),
        new Zoom(this.section);
    }
    detect3d() {
      const e = this.container.querySelectorAll(selectors$z.modelViewer);
      e.length &&
        e.forEach((e) => {
          theme.ProductModel.init(e, this.id);
        });
    }
    launch3d() {
      document.addEventListener("shopify_xr_launch", () => {
        this.container
          .querySelector(
            `${selectors$z.modelViewer}:not(.${classes$t.mediaHidden})`
          )
          .dispatchEvent(new CustomEvent("xrLaunch"));
      });
    }
    constructor(e) {
      (this.section = e), (this.id = e.id), (this.container = e.container);
    }
  };
  const selectors$y = {
      productSlideshow: "[data-product-slideshow]",
      mobileSliderDisabled: "data-slideshow-disabled-mobile",
      productThumbs: "[data-product-thumbs]",
      sliderThumb: "[data-thumb-item]",
      dataTallLayout: "data-tall-layout",
      mediaType: "data-type",
      dataMediaId: "data-media-id",
      dataThumb: "data-thumb",
      dataThumbIndex: "data-thumb-index",
      deferredMediaButton: "[data-deferred-media-button]",
      ariaLabel: "aria-label",
      dataThumbnail: "[data-thumbnail]",
      productSlideThumb: ".js-product-slide-thumb",
      classSelected: ".is-active",
      thumbsSlider: "[data-thumbs-slider]",
      quickAddModal: "[data-quick-add-modal]",
      focusedElement: "[data-focus-element]",
      zoomElement: "[data-zoom-wrapper]",
    },
    classes$s = {
      active: "is-active",
      focused: "is-focused",
      dragging: "is-dragging",
      selected: "is-selected",
      sliderEnabled: "flickity-enabled",
      mediaHidden: "media--hidden",
    },
    attributes$9 = {
      ariaCurrent: "aria-current",
      sliderOptions: "data-options",
    },
    thumbIcons = {
      model:
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-model" viewBox="0 0 26 26"><path class="icon-media-model-outline" d="M.5 25v.5h25V.5H.5z" fill="none"/><path class="icon-media-model-element" d="M19.13 8.28L14 5.32a2 2 0 0 0-2 0l-5.12 3a2 2 0 0 0-1 1.76V16a2 2 0 0 0 1 1.76l5.12 3a2 2 0 0 0 2 0l5.12-3a2 2 0 0 0 1-1.76v-6a2 2 0 0 0-.99-1.72zm-6.4 11.1l-5.12-3a.53.53 0 0 1-.26-.38v-6a.53.53 0 0 1 .27-.46l5.12-3a.53.53 0 0 1 .53 0l5.12 3-4.72 2.68a1.33 1.33 0 0 0-.67 1.2v6a.53.53 0 0 1-.26 0z" opacity=".6" style="isolation:isolate"/></svg>',
      video:
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-media-video" viewBox="0 0 26 26"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 25h24V1H1v24z"/><path class="icon-media-video-outline" d="M.5 25v.5h25V.5H.5V25z"/><path class="icon-media-video-element" fill-rule="evenodd" clip-rule="evenodd" d="M9.718 6.72a1 1 0 0 0-1.518.855v10.736a1 1 0 0 0 1.562.827l8.35-5.677a1 1 0 0 0-.044-1.682l-8.35-5.06z" opacity=".6"/></svg>',
    };
  let sections$k = {},
    InitSlider = class {
      init() {
        this.slideshow &&
          (this.tallLayout
            ? this.mobileSliderDisabled ||
              (this.initSliderMobile(),
              document.addEventListener(
                "theme:resize:width",
                this.initSliderMobileEvent
              ))
            : this.mobileSliderDisabled
            ? (this.initSliderDesktop(),
              document.addEventListener(
                "theme:resize:width",
                this.initSliderDesktopEvent
              ))
            : this.createSlider());
      }
      initSliderMobile() {
        (window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth) < theme.sizes.small
          ? this.createSlider()
          : this.destroySlider();
      }
      initSliderDesktop() {
        (window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth) < theme.sizes.small
          ? this.destroySlider()
          : this.createSlider();
      }
      destroySlider() {
        this.slideshow.classList.contains(classes$s.sliderEnabled) &&
          this.flkty.destroy(),
          this.thumbs && (this.thumbs.innerHTML = "");
      }
      createSlider() {
        const e =
          (window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth) < theme.sizes.small;
        if (!this.slideshow || (this.mobileSliderDisabled && e)) return;
        const t = {
            autoPlay: !1,
            pageDots: !1,
            wrapAround: !0,
            ...this.customOptions,
          },
          s = this,
          i = this.slideshow.querySelectorAll(`[${selectors$y.mediaType}]`)[0];
        let o = {
          ...t,
          on: {
            ready: function () {
              const e = this.element;
              e.addEventListener("keyup", (t) => {
                if (t.code === window.theme.keyboardKeys.ENTER) {
                  const t = e.querySelector(
                    `.${classes$s.selected} ${selectors$y.zoomElement}`
                  );
                  t &&
                    (t.dispatchEvent(
                      new Event("click", {
                        bubbles: !1,
                      })
                    ),
                    (window.accessibility.lastElement = e));
                }
              }),
                s.sliderThumbs(this),
                s.accessibilityActions(this);
            },
          },
        };
        if (
          ((this.flkty = new FlickityFade(this.slideshow, o)),
          this.flkty.resize(),
          i)
        ) {
          const e = i.getAttribute(selectors$y.mediaType);
          ("model" !== e && "video" !== e && "external_video" !== e) ||
            ((this.flkty.options.draggable = !1), this.flkty.updateDraggable());
        }
        this.flkty.on("change", function (e) {
          let t = e;
          if (s.thumbs) {
            const i = s.thumbs.querySelector(selectors$y.classSelected),
              o = s.thumbs.querySelector(
                `${selectors$y.sliderThumb} [${selectors$y.dataThumbIndex}="${e}"]`
              );
            if (i) {
              const e = i.querySelector(`[${selectors$y.dataThumbIndex}]`);
              (t = Array.from(i.parentElement.children).indexOf(i)),
                i.classList.remove(classes$s.active),
                e && e.setAttribute(attributes$9.ariaCurrent, !1);
            }
            o &&
              (o.parentElement.classList.add(classes$s.active),
              o.setAttribute(attributes$9.ariaCurrent, !0)),
              s.scrollToThumb();
          }
          const i = this.cells[t].element,
            o = this.selectedElement;
          i.dispatchEvent(new CustomEvent("theme:media:hidden")),
            o.classList.remove(classes$s.mediaHidden);
        }),
          this.flkty.on("settle", function () {
            const e = this.selectedElement,
              t = Array.prototype.filter.call(
                e.parentNode.children,
                function (t) {
                  return t !== e;
                }
              ),
              i = e.getAttribute(selectors$y.mediaType),
              o = document.body.classList.contains(classes$s.focused);
            "model" === i || "video" === i || "external_video" === i
              ? ((s.flkty.options.draggable = !1), s.flkty.updateDraggable())
              : ((s.flkty.options.draggable = !0), s.flkty.updateDraggable()),
              o && e.dispatchEvent(new Event("focus")),
              t.length &&
                t.forEach((e) => {
                  e.classList.add(classes$s.mediaHidden);
                }),
              e.dispatchEvent(new CustomEvent("theme:media:visible"));
            const r = e.querySelector("deferred-media");
            r &&
              !0 !== r.getAttribute("loaded") &&
              e.querySelector(selectors$y.deferredMediaButton).dispatchEvent(
                new Event("click", {
                  bubbles: !1,
                })
              ),
              s.accessibilityActions(this);
          }),
          this.flkty.on("dragStart", (e, t) => {
            e.target.classList.add(classes$s.dragging);
          }),
          this.flkty.on("dragEnd", (e, t) => {
            const s = this.flkty.element.querySelector(
              `.${classes$s.dragging}`
            );
            s && s.classList.remove(classes$s.dragging);
          }),
          this.container.addEventListener("click", (e) => {
            const t = e.target;
            if (
              t.matches(selectors$y.productSlideThumb) ||
              t.closest(selectors$y.productSlideThumb)
            ) {
              e.preventDefault();
              const s = t.matches(selectors$y.productSlideThumb)
                  ? t
                  : t.closest(selectors$y.productSlideThumb),
                i = s.hasAttribute(selectors$y.dataThumbIndex)
                  ? parseInt(s.getAttribute(selectors$y.dataThumbIndex))
                  : 0;
              this.flkty.select(i);
            }
          });
      }
      accessibilityActions(e) {
        const t = e.slides;
        t.length &&
          t.forEach((e) => {
            const t = e.cells[0].element,
              s = t.querySelectorAll(
                `model-viewer, video, iframe, button, [href], input, ${selectors$y.focusedElement}`
              );
            t.classList.contains(classes$s.selected)
              ? t.removeAttribute("tabindex")
              : t.setAttribute("tabindex", "-1"),
              s.length &&
                s.forEach((e) => {
                  t.classList.contains(classes$s.selected)
                    ? e.removeAttribute("tabindex")
                    : e.setAttribute("tabindex", "-1");
                });
          });
      }
      scrollToThumb() {
        const e = this.container.querySelector(selectors$y.thumbsSlider);
        if (e) {
          const t = e.querySelector(selectors$y.classSelected);
          if (!t) return;
          const s = e.scrollTop,
            i = e.scrollLeft,
            o = e.offsetWidth,
            r = e.offsetHeight,
            n = s + r,
            a = i + o,
            l = t.offsetTop,
            c = t.offsetLeft,
            d = t.offsetWidth,
            h = t.offsetHeight,
            u = s > l,
            p = i > c,
            m = c + d > a,
            g = m || p;
          if (l + h > n || u || g) {
            const t =
              (window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth) < theme.sizes.small;
            let s = l - r + h,
              i = c - o + d;
            u && (s = l),
              m &&
                t &&
                (i += parseInt(window.getComputedStyle(e).paddingRight)),
              p &&
                ((i = c),
                t && (i -= parseInt(window.getComputedStyle(e).paddingLeft))),
              e.scrollTo({
                top: s,
                left: i,
                behavior: "smooth",
              });
          }
        }
      }
      sliderThumbs(e) {
        const t = e.slides;
        if (this.thumbs && t.length) {
          let e = "";
          t.forEach((t, s) => {
            const i = t.cells[0].element,
              o = i.getAttribute(selectors$y.mediaType),
              r = i.getAttribute(selectors$y.dataMediaId),
              n = i.getAttribute(selectors$y.dataThumb);
            let a = "";
            const l = thumbIcons[o] ? thumbIcons[o] : "";
            let c = "",
              d = !1;
            i.querySelector(`[${selectors$y.ariaLabel}]`) &&
              (a = i
                .querySelector(`[${selectors$y.ariaLabel}]`)
                .getAttribute(selectors$y.ariaLabel)),
              "" === a &&
                i.hasAttribute(selectors$y.ariaLabel) &&
                (a = i.getAttribute(selectors$y.ariaLabel)),
              (i.classList.contains(classes$s.active) || 0 === s) &&
                ((c = classes$s.active), (d = !0)),
              (e += `<div class="product__thumb ${c}" data-thumb-item><a href="${n}" class="product__thumb__link product__thumb__link--${o} js-product-slide-thumb" data-thumb-index="${s}" data-thumbnail data-media-id="${r}" aria-label="${a}" aria-current="${d}"><img class="product__thumb__link__image" loading="lazy" is="lazy-img" src="${n}" sizes="75px" alt="${a}" width="150" height="150">${l}</a></div>`);
          }),
            "" !== e &&
              ((e = `<div class="product__thumbs__holder" data-thumbs-slider>${e}</div>`),
              (this.thumbs.innerHTML = e));
        }
        const s = this.container.querySelectorAll(selectors$y.dataThumbnail);
        s.length &&
          s.forEach((t) => {
            t.addEventListener("click", function (e) {
              e.preventDefault();
            }),
              t.addEventListener("keyup", function (t) {
                if (t.code === window.theme.keyboardKeys.ENTER) {
                  const t = this.getAttribute(selectors$y.dataMediaId),
                    s = e.element
                      .querySelector(`[${selectors$y.dataMediaId}="${t}"]`)
                      .querySelectorAll(
                        'model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])'
                      )[0];
                  s &&
                    (s.dispatchEvent(new Event("focus")),
                    s.dispatchEvent(new Event("select")));
                }
              });
          });
      }
      onUnload() {
        this.tallLayout
          ? this.mobileSliderDisabled ||
            document.removeEventListener(
              "theme:resize:width",
              this.initSliderMobileEvent
            )
          : this.mobileSliderDisabled &&
            document.removeEventListener(
              "theme:resize:width",
              this.initSliderDesktopEvent
            );
      }
      constructor(e, t = null) {
        (this.container = t || e.container),
          (this.tallLayout =
            "true" === this.container.getAttribute(selectors$y.dataTallLayout)),
          (this.slideshow = this.container.querySelector(
            selectors$y.productSlideshow
          )),
          (this.thumbs = this.container.querySelector(
            selectors$y.productThumbs
          )),
          (this.mobileSliderDisabled =
            "true" ===
            this.container.getAttribute(selectors$y.mobileSliderDisabled)),
          (this.initSliderMobileEvent = () => this.initSliderMobile()),
          (this.initSliderDesktopEvent = () => this.initSliderDesktop()),
          this.slideshow &&
            this.slideshow.hasAttribute(attributes$9.sliderOptions) &&
            (this.customOptions = JSON.parse(
              decodeURIComponent(
                this.slideshow.getAttribute(attributes$9.sliderOptions)
              )
            )),
          (this.flkty = null),
          this.init();
      }
    };
  const initSlider = {
      onLoad() {
        sections$k[this.id] = new InitSlider(this);
      },
      onUnload(e) {
        sections$k[this.id].onUnload(e);
      },
    },
    selectors$x = {
      optionPosition: "data-option-position",
      optionInput: '[name^="options"], [data-popout-option]',
      optionInputCurrent:
        '[name^="options"]:checked, [name^="options"][type="hidden"]',
      selectOptionValue: "data-value",
      popout: "[data-popout]",
    },
    classes$r = {
      soldOut: "sold-out",
      unavailable: "unavailable",
    };
  let SelloutVariants = class {
    init() {
      this.update();
    }
    update() {
      this.getCurrentState(),
        this.optionElements.forEach((e) => {
          const t = e.closest(`[${selectors$x.optionPosition}]`);
          if (!t) return;
          const s = e.value || e.getAttribute(selectors$x.selectOptionValue),
            i = t.getAttribute(selectors$x.optionPosition),
            o = parseInt(i, 10) - 1,
            r = e.closest(selectors$x.popout);
          let n = [...this.selections];
          n[o] = s;
          const a = this.productJSON.variants.find((e) => {
            let t = !0;
            for (let s = 0; s < n.length; s++)
              e.options[s] !== n[s] && (t = !1);
            return t;
          });
          e.classList.remove(classes$r.soldOut, classes$r.unavailable),
            r && r.classList.remove(classes$r.soldOut, classes$r.unavailable),
            void 0 === a
              ? (e.classList.add(classes$r.unavailable),
                r && r.classList.add(classes$r.unavailable))
              : a &&
                !1 === a.available &&
                (e.classList.add(classes$r.soldOut),
                r && r.classList.add(classes$r.soldOut));
        });
    }
    getCurrentState() {
      this.selections = [];
      const e = this.container.querySelectorAll(selectors$x.optionInputCurrent);
      e.length &&
        e.forEach((e) => {
          const t = e.value;
          t && "" !== t && this.selections.push(t);
        });
    }
    constructor(e, t) {
      (this.container = e),
        (this.productJSON = t),
        (this.optionElements = this.container.querySelectorAll(
          selectors$x.optionInput
        )),
        this.productJSON && this.optionElements.length && this.init();
    }
  };
  const selectors$w = {
      product: "[data-product]",
      productForm: "[data-product-form]",
      addToCart: "[data-add-to-cart]",
      addToCartText: "[data-add-to-cart-text]",
      comparePrice: "[data-compare-price]",
      comparePriceText: "[data-compare-text]",
      formWrapper: "[data-form-wrapper]",
      originalSelectorId: "[data-product-select]",
      priceWrapper: "[data-price-wrapper]",
      productSlideshow: "[data-product-slideshow]",
      productImage: "[data-product-image]",
      productJson: "[data-product-json]",
      productPrice: "[data-product-price]",
      unitPrice: "[data-product-unit-price]",
      unitBase: "[data-product-base]",
      unitWrapper: "[data-product-unit]",
      isPreOrder: "[data-product-preorder]",
      sliderEnabled: "flickity-enabled",
      productSlide: ".product__slide",
      dataTallLayout: "data-tall-layout",
      dataEnableHistoryState: "data-enable-history-state",
      subPrices: "[data-subscription-watch-price]",
      subSelectors: "[data-subscription-selectors]",
      subsToggle: "[data-toggles-group]",
      subsChild: "data-group-toggle",
      subDescription: "[data-plan-description]",
      priceOffWrap: "[data-price-off]",
      priceOffType: "[data-price-off-type]",
      priceOffAmount: "[data-price-off-amount]",
      dataImageId: "data-image-id",
      remainingCount: "[data-remaining-count]",
      remainingMax: "[data-remaining-max]",
      remainingMaxAttr: "data-remaining-max",
      remainingWrapper: "[data-remaining-wrapper]",
      remainingJSON: "[data-product-remaining-json]",
      optionValue: "[data-option-value]",
      optionPosition: "data-option-position",
    },
    classes$q = {
      hide: "hide",
      variantSoldOut: "variant--soldout",
      variantUnavailable: "variant--unavailable",
      productPriceSale: "product__price--sale",
      remainingLow: "count-is-low",
      remainingIn: "count-is-in",
      remainingOut: "count-is-out",
      remainingUnavailable: "count-is-unavailable",
    };
  let ProductAddForm = class {
    init() {
      let e = null;
      const t = this.container.querySelector(selectors$w.productJson);
      t && (e = t.innerHTML),
        e
          ? ((this.productJSON = JSON.parse(e)),
            this.linkForm(),
            (this.sellout = new SelloutVariants(
              this.container,
              this.productJSON
            )))
          : console.error("Missing product JSON");
    }
    destroy() {
      this.productForm.destroy();
    }
    linkForm() {
      (this.productForm = new ProductForm(this.container, this.productJSON, {
        onOptionChange: this.onOptionChange.bind(this),
        onPlanChange: this.onPlanChange.bind(this),
      })),
        this.pushState(this.productForm.getFormState()),
        this.subsToggleListeners();
    }
    onOptionChange(e) {
      console.log('dhgjghj');
      this.pushState(e.dataset), this.updateProductImage(e);
    }
    onPlanChange(e) {
      this.subPrices && this.pushState(e.dataset);
    }
    pushState(e) {
      var t;
      (this.productState = this.setProductState(e)),
        this.updateAddToCartState(e),
        this.updateProductPrices(e),
        this.updateSaleText(e),
        this.updateSubscriptionText(e),
        this.updateRemaining(e),
        this.fireHookEvent(e),
        this.updateLegend(e),
        null === (t = this.sellout) || void 0 === t || t.update(e),
        this.enableHistoryState && this.updateHistoryState(e);
    }
    updateAddToCartState(e) {
      const t = e.variant;
      let s = theme.strings.addToCart;
      const i = this.container.querySelectorAll(selectors$w.priceWrapper),
        o = this.container.querySelectorAll(selectors$w.addToCart),
        r = this.container.querySelectorAll(selectors$w.addToCartText),
        n = this.container.querySelectorAll(selectors$w.formWrapper);
      this.isPreOrder && (s = theme.strings.preOrder),
        i.length &&
          t &&
          i.forEach((e) => {
            e.classList.remove(classes$q.hide);
          }),
        o.length &&
          o.forEach((e) => {
            t && t.available ? (e.disabled = !1) : (e.disabled = !0);
          }),
        r.length &&
          r.forEach((e) => {
            t
              ? t.available
                ? (e.innerHTML = s)
                : (e.innerHTML = theme.strings.soldOut)
              : (e.innerHTML = theme.strings.unavailable);
          }),
        n.length &&
          n.forEach((e) => {
            if (t) {
              t.available
                ? e.classList.remove(
                    classes$q.variantSoldOut,
                    classes$q.variantUnavailable
                  )
                : (e.classList.add(classes$q.variantSoldOut),
                  e.classList.remove(classes$q.variantUnavailable));
              const s = e.querySelector(selectors$w.originalSelectorId);
              s && (s.value = t.id);
            } else
              e.classList.add(classes$q.variantUnavailable),
                e.classList.remove(classes$q.variantSoldOut);
          });
    }
    updateHistoryState(e) {
      const t = e.variant,
        s = e.plan,
        i = window.location.href;
      if (t && i.includes("/product")) {
        const e = new window.URL(i),
          o = e.searchParams;
        o.set("variant", t.id),
          s && s.detail && s.detail.id && this.productState.hasPlan
            ? o.set("selling_plan", s.detail.id)
            : o.delete("selling_plan"),
          (e.search = o.toString());
        const r = e.toString();
        window.history.replaceState(
          {
            path: r,
          },
          "",
          r
        );
      }
    }
    updateRemaining(e) {
      const t = e.variant;
      if (
        t &&
        this.remainingWrapper &&
        this.remainingJSON &&
        this.remainingCount
      ) {
        const e = this.remainingJSON[t.id];
        e && e <= this.remainingMaxInt && e > 0
          ? (this.remainingWrapper.classList.remove(
              classes$q.remainingIn,
              classes$q.remainingOut,
              classes$q.remainingUnavailable
            ),
            this.remainingWrapper.classList.add(classes$q.remainingLow),
            (this.remainingCount.innerHTML = e))
          : this.productState.soldOut
          ? (this.remainingWrapper.classList.remove(
              classes$q.remainingLow,
              classes$q.remainingIn,
              classes$q.remainingUnavailable
            ),
            this.remainingWrapper.classList.add(classes$q.remainingOut))
          : this.productState.available &&
            (this.remainingWrapper.classList.remove(
              classes$q.remainingLow,
              classes$q.remainingOut,
              classes$q.remainingUnavailable
            ),
            this.remainingWrapper.classList.add(classes$q.remainingIn));
      } else
        this.remainingWrapper &&
          (this.remainingWrapper.classList.remove(
            classes$q.remainingIn,
            classes$q.remainingOut,
            classes$q.remainingLow
          ),
          this.remainingWrapper.classList.add(classes$q.remainingUnavailable));
    }
    getBaseUnit(e) {
      return 1 === e.unit_price_measurement.reference_value
        ? e.unit_price_measurement.reference_unit
        : e.unit_price_measurement.reference_value +
            e.unit_price_measurement.reference_unit;
    }
    subsToggleListeners() {
      this.container.querySelectorAll(selectors$w.subsToggle).forEach((e) => {
        e.addEventListener(
          "change",
          function (e) {
            const t = e.target.value.toString(),
              s = this.container.querySelector(
                `[${selectors$w.subsChild}="${t}"]`
              ),
              i = this.container.querySelectorAll(`[${selectors$w.subsChild}]`);
            if (s) {
              s.classList.remove(classes$q.hide);
              const e = s.querySelector('[name="selling_plan"]');
              (e.checked = !0), e.dispatchEvent(new Event("change"));
            }
            i.forEach((e) => {
              if (e !== s) {
                e.classList.add(classes$q.hide);
                e.querySelectorAll('[name="selling_plan"]').forEach((e) => {
                  (e.checked = !1), e.dispatchEvent(new Event("change"));
                });
              }
            });
          }.bind(this)
        );
      });
    }
    updateSaleText(e) {
      this.productState.planSale
        ? this.updateSaleTextSubscription(e)
        : this.productState.onSale
        ? this.updateSaleTextStandard(e)
        : this.priceOffWrap && this.priceOffWrap.classList.add(classes$q.hide);
    }
    updateSaleTextStandard(e) {
      if (
        (this.priceOffType &&
          (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"),
        this.priceOffAmount && this.priceOffWrap)
      ) {
        const t = e.variant,
          s = (t.compare_at_price - t.price) / t.compare_at_price,
          i = Math.floor(100 * s);
        (this.priceOffAmount.innerHTML = `${i}%`),
          this.priceOffWrap.classList.remove(classes$q.hide);
      }
    }
    updateSubscriptionText(e) {
      e.plan && this.planDecription
        ? ((this.planDecription.innerHTML = e.plan.detail.description),
          this.planDecription.classList.remove(classes$q.hide))
        : this.planDecription &&
          this.planDecription.classList.add(classes$q.hide);
    }
    updateSaleTextSubscription(e) {
      if (
        (this.priceOffType &&
          (this.priceOffType.innerHTML =
            window.theme.strings.subscription || "subscripton"),
        this.priceOffAmount && this.priceOffWrap)
      ) {
        const t = e.plan.detail.price_adjustments[0],
          s = t.value;
        t && "percentage" === t.value_type
          ? (this.priceOffAmount.innerHTML = `${s}%`)
          : (this.priceOffAmount.innerHTML = themeCurrency.formatMoney(
              s,
              theme.moneyFormat
            )),
          this.priceOffWrap.classList.remove(classes$q.hide);
      }
    }
    updateProductPrices(e) {
      const t = e.variant,
        s = e.plan;
      this.container.querySelectorAll(selectors$w.priceWrapper).forEach((e) => {
        const i = e.querySelector(selectors$w.comparePrice),
          o = e.querySelector(selectors$w.productPrice),
          r = e.querySelector(selectors$w.comparePriceText);
        let n = "",
          a = "";
        this.productState.available &&
          ((n = t.compare_at_price), (a = t.price)),
          this.productState.hasPlan && (a = s.allocation.price),
          this.productState.planSale &&
            ((n = s.allocation.compare_at_price), (a = s.allocation.price)),
          i &&
            (this.productState.onSale || this.productState.planSale
              ? (i.classList.remove(classes$q.hide),
                r.classList.remove(classes$q.hide),
                o.classList.add(classes$q.productPriceSale))
              : (i.classList.add(classes$q.hide),
                r.classList.add(classes$q.hide),
                o.classList.remove(classes$q.productPriceSale)),
            (i.innerHTML = themeCurrency.formatMoney(n, theme.moneyFormat))),
          (o.innerHTML =
            0 === a
              ? window.theme.strings.free
              : themeCurrency.formatMoney(a, theme.moneyFormat));
      }),
        this.hasUnitPricing && this.updateProductUnits(e);
    }
    updateProductUnits(e) {
      const t = e.variant,
        s = e.plan;
      let i = null;
      if (
        (t && t.unit_price && (i = t.unit_price),
        s &&
          s.allocation &&
          s.allocation.unit_price &&
          (i = s.allocation.unit_price),
        i)
      ) {
        const e = this.getBaseUnit(t),
          s = themeCurrency.formatMoney(i, theme.moneyFormat);
        (this.container.querySelector(selectors$w.unitPrice).innerHTML = s),
          (this.container.querySelector(selectors$w.unitBase).innerHTML = e),
          showElement(this.container.querySelector(selectors$w.unitWrapper));
      } else hideElement(this.container.querySelector(selectors$w.unitWrapper));
    }
    fireHookEvent(e) {
      const t = e.variant;
      this.container.dispatchEvent(
        new CustomEvent("theme:variant:change", {
          detail: {
            variant: t,
          },
          bubbles: !0,
        })
      );
    }
    setProductState(e) {
      const t = e.variant,
        s = e.plan,
        i = {
          available: !0,
          soldOut: !1,
          onSale: !1,
          showUnitPrice: !1,
          requiresPlan: !1,
          hasPlan: !1,
          planPerDelivery: !1,
          planSale: !1,
        };
      return (
        !t || (t.requires_selling_plan && !s)
          ? (i.available = !1)
          : (t.available || (i.soldOut = !0),
            t.compare_at_price > t.price && (i.onSale = !0),
            t.unit_price && (i.showUnitPrice = !0),
            this.product &&
              this.product.requires_selling_plan &&
              (i.requiresPlan = !0),
            s &&
              this.subPrices &&
              ((i.hasPlan = !0),
              s.allocation.per_delivery_price !== s.allocation.price &&
                (i.planPerDelivery = !0),
              t.price > s.allocation.price && (i.planSale = !0))),
        i
      );
    }
    updateProductImage(e) {
      const t = e.dataset.variant;
      if (t && t.featured_media) {
        const e = this.container.querySelector(
            `${selectors$w.productImage}[${selectors$w.dataImageId}="${t.featured_media.id}"]`
          ),
          s = null == e ? void 0 : e.closest(selectors$w.productSlide);
        if (s) {
          const t =
              (window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth) >= window.theme.sizes.small,
            i = Array.from(s.parentElement.children).indexOf(s),
            o = this.container.querySelector(selectors$w.productSlideshow);
          if (
            (o && o.classList.contains(selectors$w.sliderEnabled)
              ? FlickityFade.data(o).select(i)
              : o &&
                !t &&
                o.scrollTo({
                  top: 0,
                  left: s.offsetLeft,
                  behavior: "smooth",
                }),
            t && this.tallLayout)
          ) {
            const t = e.getBoundingClientRect().top;
            if (0 === i && t + window.scrollY > window.pageYOffset) return;
            document.dispatchEvent(
              new CustomEvent("theme:tooltip:close", {
                bubbles: !1,
                detail: {
                  hideTransition: !1,
                },
              })
            ),
              scrollTo(t);
          }
        }
      }
    }
    updateLegend(e) {
      const t = e.variant;
      if (t) {
        const e = this.container.querySelectorAll(selectors$w.optionValue);
        e.length &&
          e.forEach((e) => {
            const s = e.closest(`[${selectors$w.optionPosition}]`);
            if (s) {
              const i = s.getAttribute(selectors$w.optionPosition),
                o = parseInt(i, 10) - 1,
                r = t.options[o];
              e.innerHTML = r;
            }
          });
      }
    }
    constructor(e, t = null) {
      if (
        ((this.section = e),
        (this.container = t || e.container),
        (this.tallLayout =
          "true" === this.container.getAttribute(selectors$w.dataTallLayout)),
        (this.product = this.container.querySelector(selectors$w.product)),
        (this.productForm = this.container.querySelector(
          selectors$w.productForm
        )),
        (this.sellout = null),
        (this.priceOffWrap = this.container.querySelector(
          selectors$w.priceOffWrap
        )),
        (this.priceOffAmount = this.container.querySelector(
          selectors$w.priceOffAmount
        )),
        (this.priceOffType = this.container.querySelector(
          selectors$w.priceOffType
        )),
        (this.planDecription = this.container.querySelector(
          selectors$w.subDescription
        )),
        (this.remainingWrapper = this.container.querySelector(
          selectors$w.remainingWrapper
        )),
        this.remainingWrapper)
      ) {
        const e = this.container.querySelector(selectors$w.remainingMax);
        if (!e) return;
        (this.remainingMaxInt = parseInt(
          e.getAttribute(selectors$w.remainingMaxAttr),
          10
        )),
          (this.remainingCount = this.container.querySelector(
            selectors$w.remainingCount
          )),
          (this.remainingJSONWrapper = this.container.querySelector(
            selectors$w.remainingJSON
          )),
          (this.remainingJSON = null),
          this.remainingJSONWrapper &&
          "" !== this.remainingJSONWrapper.innerHTML
            ? (this.remainingJSON = JSON.parse(
                this.remainingJSONWrapper.innerHTML
              ))
            : console.warn("Missing product quantity JSON");
      }
      (this.enableHistoryState =
        "true" ===
        this.container.getAttribute(selectors$w.dataEnableHistoryState)),
        (this.hasUnitPricing = this.container.querySelector(
          selectors$w.unitWrapper
        )),
        (this.subSelectors = this.container.querySelector(
          selectors$w.subSelectors
        )),
        (this.subPrices = this.container.querySelector(selectors$w.subPrices)),
        (this.isPreOrder = this.container.querySelector(
          selectors$w.isPreOrder
        ));
      new QuantityCounter(this.container).init(), this.init();
    }
  };
  const productFormSection = {
      onLoad() {
        this.section = new ProductAddForm(this);
      },
    },
    classes$p = {
      added: "is-added",
      animated: "is-animated",
      disabled: "is-disabled",
      error: "has-error",
      hide: "is-hidden",
      hiding: "is-hiding",
      loading: "is-loading",
      open: "is-open",
      overlayText: "product-item--overlay-text",
      visible: "is-visible",
      siblingLinkCurrent: "siblings__link--current",
      focused: "is-focused",
    },
    settings$1 = {
      errorDelay: 3e3,
      animationDelay: 500,
    },
    selectors$v = {
      addButtonWrapper: "[data-add-action-wrapper]",
      animation: "[data-animation]",
      apiContent: "[data-api-content]",
      buttonQuickAdd: "[data-quick-add-btn]",
      buttonQuickAddText: "[data-quick-add-btn-text]",
      buttonQuickAddMobile: "[data-quick-add-btn-mobile]",
      cartDrawer: "[data-cart-drawer]",
      cartLineItems: "[data-line-items]",
      focusable:
        'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
      media: "[data-media-slide]",
      messageError: "[data-message-error]",
      modalContainer: "[data-product-upsell-container]",
      modalContent: "[data-product-upsell-ajax]",
      productGridItem: "data-product-grid-item",
      productInformationHolder: "[data-product-information]",
      popoutWrapper: "[data-popout]",
      quickAddHolder: "data-quick-add-holder",
      quickAddModal: "[data-quick-add-modal]",
      quickAddModalTemplate: "[data-quick-add-modal-template]",
      quickAddVariant: "data-quick-add-variant",
      quickAddProp: "data-quick-add-props",
      siblingSwapper: "data-sibling-swapper",
      swatch: "[data-swatch]",
      tooltip: "[data-tooltip]",
    };
  let QuickAddProduct = class extends HTMLElement {
    init() {
      if (
        (this.modalButton &&
          this.modalTemplate &&
          this.modalButton.addEventListener("click", (e) => {
            e.preventDefault();
            const t = this.modalButton.hasAttribute(selectors$v.siblingSwapper),
              s = this.modalButton.classList.contains(
                classes$p.siblingLinkCurrent
              );
            s ||
              (this.modalButton.classList.add(classes$p.loading),
              (this.modalButton.disabled = !0),
              this.closeTooltip(),
              t &&
                !s &&
                ((this.modalContainer = document.querySelector(
                  selectors$v.modalContainer
                )),
                this.modalContainer.classList.add(classes$p.loading),
                this.hideAnimatedItems()),
              this.modal &&
                ((this.oldModalID = this.modal.id),
                this.modalID && (this.modal.id = this.modalID)),
              this.getProductHTML());
          }),
        this.buttonQuickAdd)
      ) {
        const e = this.buttonQuickAdd.querySelector(
          selectors$v.buttonQuickAddText
        );
        e &&
          0 ===
            parseInt(
              getComputedStyle(this.buttonQuickAdd).getPropertyValue(
                "--btn-text-width"
              )
            ) &&
          this.buttonQuickAdd.style.setProperty(
            "--btn-text-width",
            `${e.clientWidth}px`
          ),
          this.buttonQuickAdd.hasAttribute(selectors$v.quickAddVariant) &&
            (this.buttonQuickAdd.addEventListener("click", (e) => {
              e.preventDefault();
              const t = this.buttonQuickAdd.getAttribute(
                selectors$v.quickAddVariant
              );
              if (t) {
                const e = this.buttonQuickAdd.hasAttribute(
                  selectors$v.quickAddProp
                )
                  ? JSON.parse(
                      this.buttonQuickAdd
                        .getAttribute(selectors$v.quickAddProp)
                        .replaceAll("'", '"')
                    )
                  : null;
                this.addToCart(t, e);
              }
            }),
            theme.settings.enableQuickAdd &&
              this.buttonQuickAdd.closest(`[${selectors$v.quickAddHolder}]`) &&
              this.errorHandler());
      }
      this.buttonQuickAddMobile &&
        this.buttonQuickAddMobile.addEventListener("click", () => {
          this.buttonQuickAddMobile.classList.add(classes$p.loading),
            this.button.dispatchEvent(new Event("click"));
        }),
        this.quickAddHolder &&
          this.quickAddHolder.addEventListener("animationend", () => {
            this.quickAddHolder.classList.contains(classes$p.disabled) &&
              this.quickAddHolder.classList.remove(classes$p.disabled);
          }),
        document.addEventListener("theme:product:added", () => {
          this.resetQuickAddButtons(),
            this.modal &&
              this.modal.classList.contains(classes$p.open) &&
              MicroModal.close(this.modalID);
        });
    }
    addToCart(e, t = null) {
      const s = this.buttonQuickAdd.closest(selectors$v.quickAddHolder)
        ? this.buttonQuickAdd
        : null;
      let i = {
        id: e,
        quantity: 1,
      };
      if (t) {
        const e = {
          properties: t,
        };
        i = { ...i, ...e };
      }
      document.dispatchEvent(
        new CustomEvent("theme:cart:add", {
          bubbles: !0,
          detail: {
            element: this.quickAddHolder,
            label: s,
            button: this.buttonQuickAdd,
            data: i,
          },
        })
      );
    }
    errorHandler() {
      this.quickAddHolder.addEventListener("theme:cart:error", (e) => {
        const t = e.detail.holder,
          s = t.closest(`[${selectors$v.productGridItem}]`);
        if (!s) return;
        const i = t.querySelector(selectors$v.messageError),
          o = s.classList.contains(classes$p.overlayText),
          r = s.querySelector(selectors$v.productInformationHolder),
          n = t.querySelector(selectors$v.buttonQuickAdd),
          a = t.querySelector(selectors$v.buttonQuickAddMobile);
        n &&
          (n.classList.remove(classes$p.added, classes$p.loading),
          n.classList.add(classes$p.error)),
          a &&
            (a.classList.remove(classes$p.added, classes$p.loading),
            a.classList.add(classes$p.error)),
          i && (i.innerText = e.detail.description),
          o && r.classList.add(classes$p.hide),
          setTimeout(() => {
            this.resetQuickAddButtons(),
              o && r.classList.remove(classes$p.hide);
          }, settings$1.errorDelay);
      });
    }
    resetQuickAddButtons() {
      this.quickAddHolder &&
        this.quickAddHolder.classList.remove(classes$p.visible),
        this.button &&
          (this.buttonQuickAdd.classList.remove(
            classes$p.added,
            classes$p.error
          ),
          (this.buttonQuickAdd.disabled = !1)),
        this.buttonQuickAddMobile &&
          (this.buttonQuickAddMobile.classList.remove(
            classes$p.added,
            classes$p.error
          ),
          (this.buttonQuickAddMobile.disabled = !1));
    }
    getProductHTML() {
      this.modalContent && this.oldModalID === this.modalID
        ? this.modalCreate()
        : window
            .fetch(
              `${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`
            )
            .then(this.upsellErrorsHandler)
            .then((e) => e.text())
            .then((e) => {
              const t = document.createElement("div");
              (t.innerHTML = e),
                (this.modalContent = document.querySelector(
                  selectors$v.modalContent
                )),
                (this.modalContent.innerHTML = t.querySelector(
                  selectors$v.apiContent
                ).innerHTML),
                this.initFormFunctionalities(),
                this.modalCreate();
            });
    }
    initFormFunctionalities() {
      new ProductAddForm(null, this.modal), new InitSlider(null, this.modal);
      const e = this.modalContent.querySelectorAll(selectors$v.swatch);
      e.length &&
        e.forEach((e) => {
          new Swatch(e);
        });
      const t = this.modalContent.querySelectorAll(selectors$v.popoutWrapper);
      t.length &&
        t.forEach((e) => {
          new Popout(e);
        });
      const s = this.modalContent.querySelectorAll(selectors$v.tooltip);
      s.length &&
        s.forEach((e) => {
          new Tooltip(e);
        }),
        wrapElements(this.modalContent);
    }
    modalCreate() {
      (this.modalContainer = document.querySelector(
        selectors$v.modalContainer
      )),
        MicroModal.show(this.modalID, {
          onShow: (e, t, s) => {
            const i = e.querySelector(selectors$v.focusable),
              o = {
                container: e,
                id: this.modalID,
              };
            (theme.mediaInstances[this.id] = new Media(o)),
              theme.mediaInstances[this.id].init(),
              this.quickAddHolder.classList.add(classes$p.disabled),
              this.modalButton &&
                (this.modalButton.classList.remove(classes$p.loading),
                (this.modalButton.disabled = !1)),
              this.buttonQuickAddMobile &&
                (this.buttonQuickAddMobile.classList.remove(classes$p.loading),
                (this.buttonQuickAddMobile.disabled = !1)),
              requestAnimationFrame(() => {
                this.modalContainer
                  .querySelectorAll(selectors$v.animation)
                  .forEach((e) => {
                    e.classList.add(classes$p.animated);
                  }),
                  setTimeout(() => {
                    this.modalContainer.classList.remove(classes$p.loading);
                  }, settings$1.animationDelay);
              }),
              setTimeout(() => {
                trapFocus(e, {
                  elementToFocus: i,
                });
              }, settings$1.animationDelay),
              document.dispatchEvent(
                new CustomEvent("theme:quick-add:open", {
                  bubbles: !0,
                })
              ),
              document.dispatchEvent(
                new CustomEvent("theme:scroll:lock", {
                  bubbles: !0,
                  detail: this.modalContainer,
                })
              ),
              this.modalContainer.addEventListener(
                "scroll",
                this.closeTooltipEvent
              );
          },
          onClose: (e, t, s) => {
            s && s.preventDefault();
            e.querySelectorAll(selectors$v.media).forEach((e) => {
              e.dispatchEvent(new CustomEvent("pause"));
            }),
              this.modalButton && (this.modalButton.disabled = !1),
              this.buttonQuickAddMobile &&
                (this.buttonQuickAddMobile.disabled = !1),
              this.quickAddHolder &&
                this.quickAddHolder.classList.contains(classes$p.disabled) &&
                this.quickAddHolder.classList.remove(classes$p.disabled),
              removeTrapFocus(),
              document.body.classList.contains(classes$p.focused) &&
                this.buttonQuickAdd &&
                (this.buttonQuickAdd.classList.add(classes$p.visible),
                setTimeout(() => {
                  this.buttonQuickAdd.focus(),
                    this.buttonQuickAdd.classList.remove(classes$p.visible);
                }, 50)),
              this.resetAnimatedItems(),
              (this.cartDrawer &&
                this.cartDrawer.classList.contains(classes$p.open)) ||
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", {
                    bubbles: !0,
                  })
                ),
              this.modalContainer.removeEventListener(
                "scroll",
                this.closeTooltipEvent
              );
          },
        });
    }
    closeTooltip() {
      document.dispatchEvent(
        new CustomEvent("theme:tooltip:close", {
          bubbles: !1,
          detail: {
            hideTransition: !0,
          },
        })
      );
    }
    upsellErrorsHandler(e) {
      return e.ok
        ? e
        : e.json().then(function (t) {
            throw new FetchError({
              status: e.statusText,
              headers: e.headers,
              json: t,
            });
          });
    }
    hideAnimatedItems() {
      this.modalContainer &&
        this.modalContainer
          .querySelectorAll(selectors$v.animation)
          .forEach((e) => {
            e.classList.add(classes$p.hiding);
          });
    }
    resetAnimatedItems() {
      this.modalContainer &&
        this.modalContainer
          .querySelectorAll(selectors$v.animation)
          .forEach((e) => {
            e.classList.remove(classes$p.animated);
          });
    }
    constructor() {
      if (
        (super(),
        (this.container = this),
        (this.quickAddHolder = this.container.querySelector(
          `[${selectors$v.quickAddHolder}]`
        )),
        this.quickAddHolder)
      ) {
        if (
          ((this.html = document.documentElement),
          (this.isCartItem = Boolean(
            this.quickAddHolder.closest(selectors$v.cartLineItems)
          )),
          (this.modalTemplate = this.quickAddHolder.querySelector(
            selectors$v.quickAddModalTemplate
          )),
          (this.modal = document.querySelector(selectors$v.quickAddModal)),
          (this.modalID = this.quickAddHolder.getAttribute(
            selectors$v.quickAddHolder
          )),
          (this.modalButton = this.quickAddHolder.querySelector(
            `[data-popup-${this.modalID}]`
          )),
          (this.handle = this.modalButton
            ? this.modalButton.getAttribute(`data-popup-${this.modalID}`)
            : null),
          (this.cartDrawer = document.querySelector(selectors$v.cartDrawer)),
          (this.buttonQuickAdd = this.quickAddHolder.querySelector(
            selectors$v.buttonQuickAdd
          )),
          (this.button = this.modalButton || this.buttonQuickAdd),
          (this.buttonQuickAddMobile = this.quickAddHolder.querySelector(
            selectors$v.buttonQuickAddMobile
          )),
          (this.closeTooltipEvent = () => throttle(this.closeTooltip(), 50)),
          (this.oldModalID = null),
          (this.modalContainer = null),
          (this.modalContent = null),
          !this.modal && this.modalTemplate)
        ) {
          const e = this.modalTemplate.innerHTML,
            t = document.createElement("div");
          t.innerHTML = e;
          const s = t.querySelector(selectors$v.quickAddModal);
          document.body.appendChild(s),
            (this.modal = document.querySelector(selectors$v.quickAddModal));
        }
        this.init();
      }
    }
  };
  const selectors$u = {
      productCutline: "[data-product-cutline]",
      productLink: "[data-product-link]",
      productGridItem: "[data-product-grid-item]",
      productInfo: "[data-product-information]",
      productImage: "[data-product-image-default]",
      productImageSibling: "[data-product-image-sibling]",
      productPrice: "[data-product-price]",
      siblingsInnerHolder: "[data-sibling-inner]",
      siblingCount: "[data-sibling-count]",
      siblingHolder: "[data-sibling-holder]",
      siblingFieldset: "[data-sibling-fieldset]",
      siblingLink: "[data-sibling-link]",
    },
    classes$o = {
      visible: "is-visible",
      fade: "is-fade",
      stopEvents: "no-events",
      active: "is-active",
    },
    attributes$8 = {
      siblingAddedImage: "data-sibling-added-image",
      siblingCutline: "data-sibling-cutline",
      siblingImage: "data-sibling-image",
      siblingLink: "data-sibling-link",
      siblingPrice: "data-sibling-price",
      productLink: "data-product-link",
    };
  let SiblingSwatches = class {
      init() {
        this.cacheDefaultValues(),
          this.product.addEventListener("mouseleave", () =>
            this.resetProductValues()
          ),
          this.swatches.forEach((e) => {
            e.addEventListener("mouseenter", (e) => this.showSibling(e));
          }),
          this.productLinks.length &&
            this.swatches.forEach((e) => {
              e.addEventListener("click", () => {
                this.productLinks[0].click();
              });
            });
      }
      cacheDefaultValues() {
        (this.productLinkValue = this.productLinks[0].hasAttribute(
          attributes$8.productLink
        )
          ? this.productLinks[0].getAttribute(attributes$8.productLink)
          : ""),
          (this.productPriceValue = this.productPrice.innerHTML),
          this.productCutline &&
            (this.productCutlineValue = this.productCutline.innerHTML);
      }
      resetProductValues() {
        this.product.classList.remove(classes$o.active),
          this.productLinkValue &&
            this.productLinks.forEach((e) => {
              e.href = this.productLinkValue;
            }),
          this.productPrice &&
            (this.productPrice.innerHTML = this.productPriceValue),
          this.productCutline &&
            this.productCutline &&
            (this.productCutline.innerHTML = this.productCutlineValue),
          this.hideSiblingImage();
      }
      showSibling(e) {
        const t = e.target,
          s = t.hasAttribute(attributes$8.siblingLink)
            ? t.getAttribute(attributes$8.siblingLink)
            : "",
          i = t.hasAttribute(attributes$8.siblingPrice)
            ? t.getAttribute(attributes$8.siblingPrice)
            : "",
          o = t.hasAttribute(attributes$8.siblingCutline)
            ? t.getAttribute(attributes$8.siblingCutline)
            : "",
          r = t.hasAttribute(attributes$8.siblingImage)
            ? t.getAttribute(attributes$8.siblingImage)
            : "";
        s &&
          this.productLinks.forEach((e) => {
            e.href = s;
          }),
          i && (this.productPrice.innerHTML = i),
          (this.productCutline.innerHTML = o || ""),
          r && this.showSiblingImage(r);
      }
      showSiblingImage(e) {
        if (!this.productImageSibling) return;
        const t = window.devicePixelRatio || 1,
          s = this.productImage.offsetWidth * t,
          i = 180 * Math.ceil(s / 180),
          o = themeImages.getSizedImageUrl(e, `${i}x`),
          r = this.productImageSibling.querySelector(`[src="${o}"]`),
          n = () => {
            this.productImageSibling.classList.add(classes$o.visible),
              this.productImageSibling
                .querySelector(`[src="${o}"]`)
                .classList.add(classes$o.fade);
          },
          a = () => {
            this.productImageSibling.querySelectorAll("img").forEach((e) => {
              e.classList.remove(classes$o.fade);
            }),
              requestAnimationFrame(n);
          };
        if (r) a();
        else {
          const e = document.createElement("img");
          (e.src = o),
            this.productCutline && (e.alt = this.productCutline.innerText),
            e.addEventListener("load", () => {
              this.productImageSibling.append(e), a();
            });
        }
      }
      hideSiblingImage() {
        this.productImageSibling &&
          (this.productImageSibling.classList.remove(classes$o.visible),
          this.productImageSibling.querySelectorAll("img").forEach((e) => {
            e.classList.remove(classes$o.fade);
          }));
      }
      constructor(e, t) {
        (this.swatches = e),
          (this.product = t),
          (this.productLinks = this.product.querySelectorAll(
            selectors$u.productLink
          )),
          (this.productCutline = this.product.querySelector(
            selectors$u.productCutline
          )),
          (this.productPrice = this.product.querySelector(
            selectors$u.productPrice
          )),
          (this.productImage = this.product.querySelector(
            selectors$u.productImage
          )),
          (this.productImageSibling = this.product.querySelector(
            selectors$u.productImageSibling
          )),
          this.init();
      }
    },
    Sibling = class {
      init() {
        this.initScrollbar(),
          this.siblingCount &&
            this.siblingFieldset &&
            this.productInfo &&
            (this.siblingCount.addEventListener("mouseenter", () =>
              this.showSiblings()
            ),
            this.productInfo.addEventListener("mouseleave", () =>
              this.hideSiblings()
            )),
          this.siblingLinks.length &&
            new SiblingSwatches(this.siblingLinks, this.product);
      }
      showSiblings() {
        this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
          this.productLink &&
            this.productLink.classList.add(classes$o.stopEvents),
          this.siblingFieldset.classList.add(classes$o.visible);
      }
      hideSiblings() {
        this.hideSwatchesTimer = setTimeout(() => {
          this.productLink &&
            this.productLink.classList.remove(classes$o.stopEvents),
            this.siblingFieldset.classList.remove(classes$o.visible);
        }, 100);
      }
      initScrollbar() {
        this.siblingScrollbar && new NativeScrollbar(this.siblingScrollbar);
      }
      constructor(e, t) {
        (this.holder = e),
          (this.product = t),
          (this.siblingScrollbar = this.holder.querySelector(
            selectors$u.siblingsInnerHolder
          )),
          (this.siblingCount = this.holder.querySelector(
            selectors$u.siblingCount
          )),
          (this.siblingFieldset = this.holder.querySelector(
            selectors$u.siblingFieldset
          )),
          (this.siblingLinks = this.holder.querySelectorAll(
            selectors$u.siblingLink
          )),
          (this.productInfo = this.holder.closest(selectors$u.productInfo)),
          (this.productLink = this.holder.closest(selectors$u.link)),
          (this.hideSwatchesTimer = 0),
          this.init();
      }
    },
    Siblings = class {
      constructor(e) {
        (this.container = e.container),
          (this.siblingHolders = this.container.querySelectorAll(
            `${selectors$u.productGridItem} ${selectors$u.siblingHolder}`
          )),
          this.siblingHolders.length &&
            this.siblingHolders.forEach((e) => {
              new Sibling(e, e.closest(selectors$u.productGridItem));
            });
      }
    };
  const siblings = {
      onLoad() {
        new Siblings(this);
      },
    },
    selectors$t = {
      rangeSlider: "[data-range-slider]",
      rangeDotLeft: "[data-range-left]",
      rangeDotRight: "[data-range-right]",
      rangeLine: "[data-range-line]",
      rangeHolder: "[data-range-holder]",
      dataMin: "data-se-min",
      dataMax: "data-se-max",
      dataMinValue: "data-se-min-value",
      dataMaxValue: "data-se-max-value",
      dataStep: "data-se-step",
      dataFilterUpdate: "data-range-filter-update",
      priceMin: "[data-field-price-min]",
      priceMax: "[data-field-price-max]",
    },
    classes$n = {
      initialized: "is-initialized",
    };
  let RangeSlider = class {
    init() {
      let e = this.min;
      this.slider.hasAttribute(selectors$t.dataMinValue) &&
        (e = parseFloat(this.slider.getAttribute(selectors$t.dataMinValue)));
      let t = this.max;
      this.slider.hasAttribute(selectors$t.dataMaxValue) &&
        (t = parseFloat(this.slider.getAttribute(selectors$t.dataMaxValue))),
        e < this.min && (e = this.min),
        t > this.max && (t = this.max),
        e > t && (e = t),
        this.slider.getAttribute(selectors$t.dataStep) &&
          (this.step = Math.abs(
            parseFloat(this.slider.getAttribute(selectors$t.dataStep))
          )),
        this.reset(),
        document.addEventListener("theme:resize", this.resizeFilters),
        (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
        (this.selectedTouch = null),
        (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
        this.setMinValue(e),
        this.setMaxValue(t),
        this.touchLeft.addEventListener("mousedown", this.onStartEvent),
        this.touchRight.addEventListener("mousedown", this.onStartEvent),
        this.touchLeft.addEventListener("touchstart", this.onStartEvent, {
          passive: !0,
        }),
        this.touchRight.addEventListener("touchstart", this.onStartEvent, {
          passive: !0,
        }),
        this.slider.classList.add(classes$n.initialized);
    }
    reset() {
      (this.touchLeft.style.left = "0px"),
        (this.touchRight.style.left =
          this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.lineSpan.style.marginLeft = "0px"),
        (this.lineSpan.style.width =
          this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.startX = 0),
        (this.x = 0);
    }
    setMinValue(e) {
      const t = (e - this.min) / (this.max - this.min);
      (this.touchLeft.style.left =
        Math.ceil(
          t *
            (this.slider.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact))
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.slider.setAttribute(selectors$t.dataMinValue, e);
    }
    setMaxValue(e) {
      const t = (e - this.min) / (this.max - this.min);
      (this.touchRight.style.left =
        Math.ceil(
          t *
            (this.slider.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact)) +
            this.normalizeFact
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.slider.setAttribute(selectors$t.dataMaxValue, e);
    }
    onStart(e) {
      let t = e;
      e.touches && (t = e.touches[0]),
        e.currentTarget === this.touchLeft
          ? (this.x = this.touchLeft.offsetLeft)
          : e.currentTarget === this.touchRight &&
            (this.x = this.touchRight.offsetLeft),
        (this.startX = t.pageX - this.x),
        (this.selectedTouch = e.currentTarget),
        document.addEventListener("mousemove", this.onMoveEvent),
        document.addEventListener("mouseup", this.onStopEvent),
        document.addEventListener("touchmove", this.onMoveEvent, {
          passive: !0,
        }),
        document.addEventListener("touchend", this.onStopEvent, {
          passive: !0,
        });
    }
    onMove(e) {
      let t = e;
      if (
        (e.touches && (t = e.touches[0]),
        (this.x = t.pageX - this.startX),
        this.selectedTouch === this.touchLeft
          ? (this.x >
            this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
              ? (this.x =
                  this.touchRight.offsetLeft -
                  this.selectedTouch.offsetWidth +
                  10)
              : this.x < 0 && (this.x = 0),
            (this.selectedTouch.style.left = this.x + "px"))
          : this.selectedTouch === this.touchRight &&
            (this.x <
            this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
              ? (this.x =
                  this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
              : this.x > this.maxX && (this.x = this.maxX),
            (this.selectedTouch.style.left = this.x + "px")),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.calculateValue(),
        this.slider.getAttribute("on-change"))
      ) {
        new Function("min, max", this.slider.getAttribute("on-change"))(
          this.slider.getAttribute(selectors$t.dataMinValue),
          this.slider.getAttribute(selectors$t.dataMaxValue)
        );
      }
      this.onChange(
        this.slider.getAttribute(selectors$t.dataMinValue),
        this.slider.getAttribute(selectors$t.dataMaxValue)
      );
    }
    onStop() {
      document.removeEventListener("mousemove", this.onMoveEvent),
        document.removeEventListener("mouseup", this.onStopEvent),
        document.removeEventListener("touchmove", this.onMoveEvent),
        document.removeEventListener("touchend", this.onStopEvent),
        (this.selectedTouch = null),
        this.calculateValue(),
        this.onChanged(
          this.slider.getAttribute(selectors$t.dataMinValue),
          this.slider.getAttribute(selectors$t.dataMaxValue)
        );
    }
    onChange(e, t) {
      const s = this.slider.closest(selectors$t.rangeHolder);
      if (s) {
        const i = s.querySelector(selectors$t.priceMin),
          o = s.querySelector(selectors$t.priceMax);
        i && o && ((i.value = e), (o.value = t));
      }
    }
    onChanged(e, t) {
      this.slider.hasAttribute(selectors$t.dataFilterUpdate) &&
        this.slider.dispatchEvent(
          new CustomEvent("theme:range:update", {
            bubbles: !0,
          })
        );
    }
    calculateValue() {
      const e =
        (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
      let t = this.lineSpan.offsetLeft / this.initialValue,
        s = t + e;
      if (
        ((t = t * (this.max - this.min) + this.min),
        (s = s * (this.max - this.min) + this.min),
        0 !== this.step)
      ) {
        let e = Math.floor(t / this.step);
        (t = this.step * e),
          (e = Math.floor(s / this.step)),
          (s = this.step * e);
      }
      this.selectedTouch === this.touchLeft &&
        this.slider.setAttribute(selectors$t.dataMinValue, t),
        this.selectedTouch === this.touchRight &&
          this.slider.setAttribute(selectors$t.dataMaxValue, s);
    }
    onUnload() {
      this.resizeFilters &&
        document.removeEventListener("theme:resize", this.resizeFilters);
    }
    constructor(e) {
      (this.container = e.container),
        (this.slider = e.querySelector(selectors$t.rangeSlider)),
        (this.resizeFilters = () => this.init()),
        this.slider &&
          ((this.onMoveEvent = (e) => this.onMove(e)),
          (this.onStopEvent = (e) => this.onStop(e)),
          (this.onStartEvent = (e) => this.onStart(e)),
          (this.startX = 0),
          (this.x = 0),
          (this.touchLeft = this.slider.querySelector(
            selectors$t.rangeDotLeft
          )),
          (this.touchRight = this.slider.querySelector(
            selectors$t.rangeDotRight
          )),
          (this.lineSpan = this.slider.querySelector(selectors$t.rangeLine)),
          (this.min = parseFloat(
            this.slider.getAttribute(selectors$t.dataMin)
          )),
          (this.max = parseFloat(
            this.slider.getAttribute(selectors$t.dataMax)
          )),
          (this.step = 0),
          (this.normalizeFact = 26),
          this.init());
    }
  };
  const selectors$s = {
      collectionSidebar: "[data-collection-sidebar]",
      form: "[data-collection-filters-form]",
      input: "input",
      select: "select",
      label: "label",
      textarea: "textarea",
      priceMin: "[data-field-price-min]",
      priceMax: "[data-field-price-max]",
      priceMinValue: "data-field-price-min",
      priceMaxValue: "data-field-price-max",
      rangeMin: "[data-se-min-value]",
      rangeMax: "[data-se-max-value]",
      rangeMinValue: "data-se-min-value",
      rangeMaxValue: "data-se-max-value",
      rangeMinDefault: "data-se-min",
      rangeMaxDefault: "data-se-max",
      productsContainer: "[data-products-grid]",
      product: "[data-product-grid-item]",
      filterUpdateUrlButton: "[data-filter-update-url]",
      activeFilters: "[data-active-filters]",
      activeFiltersCount: "data-active-filters-count",
      sort: "data-sort-enabled",
      collectionNav: "[data-collection-nav]",
    },
    classes$m = {
      hidden: "hidden",
      loading: "is-loading",
    };
  let sections$j = {},
    FiltersForm = class {
      init() {
        this.form &&
          (this.initRangeSlider(),
          this.sidebar.addEventListener(
            "input",
            debounce((e) => {
              const t = e.type,
                s = e.target;
              if (
                (t === selectors$s.input ||
                  t === selectors$s.select ||
                  t === selectors$s.label ||
                  t === selectors$s.textarea) &&
                this.form &&
                "function" == typeof this.form.submit
              ) {
                const t = this.form.querySelector(selectors$s.priceMin),
                  i = this.form.querySelector(selectors$s.priceMax);
                t &&
                  i &&
                  (s.hasAttribute(selectors$s.priceMinValue) && !i.value
                    ? (i.value = i.placeholder)
                    : s.hasAttribute(selectors$s.priceMaxValue) &&
                      !t.value &&
                      (t.value = t.placeholder)),
                  this.submitForm(e);
              }
            }, 500)
          ),
          this.sidebar.addEventListener("theme:range:update", (e) =>
            this.updateRange(e)
          )),
          this.sidebar &&
            this.sidebar.addEventListener("click", (e) =>
              this.filterUpdateFromUrl(e)
            ),
          this.productsContainer &&
            this.productsContainer.addEventListener("click", (e) =>
              this.filterUpdateFromUrl(e)
            ),
          this.sort &&
            this.container.addEventListener("theme:filter:update", (e) =>
              this.submitForm(e)
            ),
          (this.sidebar || this.sort) &&
            window.addEventListener("popstate", (e) => this.submitForm(e));
      }
      initRangeSlider() {
        new RangeSlider(this.form);
      }
      filterUpdateFromUrl(e) {
        const t = e.target;
        if (
          t.matches(selectors$s.filterUpdateUrlButton) ||
          (t.closest(selectors$s.filterUpdateUrlButton) && t)
        ) {
          e.preventDefault();
          const s = t.matches(selectors$s.filterUpdateUrlButton)
            ? t
            : t.closest(selectors$s.filterUpdateUrlButton);
          this.submitForm(e, s.getAttribute("href"));
        }
      }
      submitForm(e, t = "") {
        this.sort = this.container.querySelector(`[${selectors$s.sort}]`);
        const s = this.sort ? this.sort.getAttribute(selectors$s.sort) : "";
        if (!e || (e && "popstate" !== e.type))
          if ("" === t) {
            let t = new window.URL(window.location.href).searchParams;
            const i = t,
              o = Object.fromEntries(i),
              r = t.toString();
            if (r.includes("filter.") || r.includes("page="))
              for (const e in o)
                (e.includes("filter.") || "page" === e) && t.delete(e);
            if (this.form) {
              const e = new FormData(this.form),
                s = new URLSearchParams(e),
                i = this.form.querySelector(selectors$s.rangeMin),
                o = this.form.querySelector(selectors$s.rangeMax),
                r =
                  i && i.hasAttribute(selectors$s.rangeMinDefault)
                    ? i.getAttribute(selectors$s.rangeMinDefault)
                    : "",
                n =
                  o && o.hasAttribute(selectors$s.rangeMaxDefault)
                    ? o.getAttribute(selectors$s.rangeMaxDefault)
                    : "";
              let a = 0;
              for (let [e, i] of s.entries())
                e.includes("filter.") &&
                  i &&
                  (t.append(e, i),
                  ((i === r && "filter.v.price.gte" === e) ||
                    (i === n && "filter.v.price.lte" === e)) &&
                    (a += 1));
              2 === a &&
                (t.delete("filter.v.price.gte"),
                t.delete("filter.v.price.lte"));
            }
            if (s || (e && e.detail && e.detail.href)) {
              const i = s || e.detail.href;
              t.set("sort_by", i);
            }
            const n = t.toString(),
              a = n ? `?${n}` : location.pathname;
            window.history.pushState(null, "", a);
          } else window.history.pushState(null, "", t);
        else
          this.sort &&
            this.sort.dispatchEvent(
              new CustomEvent("theme:filter:sort", {
                bubbles: !1,
              })
            );
        this.productsContainer &&
          (this.productsContainer.classList.add(classes$m.loading),
          fetch(`${window.location.pathname}${window.location.search}`)
            .then((e) => e.text())
            .then((e) => {
              if (
                ((this.productsContainer.innerHTML = new DOMParser()
                  .parseFromString(e, "text/html")
                  .querySelector(selectors$s.productsContainer).innerHTML),
                this.sidebar)
              ) {
                this.sidebar.innerHTML = new DOMParser()
                  .parseFromString(e, "text/html")
                  .querySelector(selectors$s.collectionSidebar).innerHTML;
                const t = this.sidebar.querySelector(
                    `[${selectors$s.activeFiltersCount}]`
                  ),
                  s = this.container.querySelectorAll(
                    selectors$s.activeFilters
                  );
                if (t && s.length) {
                  const e = parseInt(
                    t.getAttribute(selectors$s.activeFiltersCount)
                  );
                  s.forEach((t) => {
                    (t.textContent = e),
                      t.classList.toggle(classes$m.hidden, e < 1);
                  });
                }
              }
              this.form &&
                ((this.form = this.container.querySelector(selectors$s.form)),
                this.initRangeSlider());
              new Collection(this.section).onUnload(!1),
                makeGridSwatches(this.section),
                new Siblings(this.section),
                document.dispatchEvent(
                  new CustomEvent("theme:tooltip:close", {
                    bubbles: !1,
                    detail: {
                      hideTransition: !1,
                    },
                  })
                ),
                this.collectionNav &&
                  scrollTo(this.collectionNav.getBoundingClientRect().top),
                setTimeout(() => {
                  this.productsContainer.classList.remove(classes$m.loading);
                }, 500);
            })
            .catch((e) => {
              console.log(e);
            }));
      }
      updateRange(e) {
        if (this.form && "function" == typeof this.form.submit) {
          const t = this.form.querySelector(selectors$s.rangeMin),
            s = this.form.querySelector(selectors$s.rangeMax),
            i = this.form.querySelector(selectors$s.priceMin),
            o = this.form.querySelector(selectors$s.priceMax);
          if (
            t &&
            s &&
            i &&
            o &&
            t.hasAttribute(selectors$s.rangeMinValue) &&
            s.hasAttribute(selectors$s.rangeMaxValue)
          ) {
            const r = parseInt(i.placeholder),
              n = parseInt(o.placeholder),
              a = parseInt(t.getAttribute(selectors$s.rangeMinValue)),
              l = parseInt(s.getAttribute(selectors$s.rangeMaxValue));
            (r === a && n === l) ||
              ((i.value = a), (o.value = l), this.submitForm(e));
          }
        }
      }
      constructor(e) {
        (this.section = e),
          (this.container = this.section.container),
          (this.sidebar = this.container.querySelector(
            selectors$s.collectionSidebar
          )),
          (this.form = this.container.querySelector(selectors$s.form)),
          (this.sort = this.container.querySelector(`[${selectors$s.sort}]`)),
          (this.productsContainer = this.container.querySelector(
            selectors$s.productsContainer
          )),
          (this.collectionNav = this.container.querySelector(
            selectors$s.collectionNav
          )),
          this.init();
      }
    };
  const collectionFiltersForm = {
      onLoad() {
        sections$j[this.id] = new FiltersForm(this);
      },
    },
    selectors$r = {
      dataSort: "data-sort-enabled",
      sortLinks: "[data-sort-link]",
      sortValue: "data-value",
      sortButton: "[data-popout-toggle]",
      sortButtonText: "[data-sort-button-text]",
      collectionSidebarHeading: "[data-collection-sidebar-heading]",
      collectionSidebar: "[data-collection-sidebar]",
      collectionSidebarSlider: "[data-collection-sidebar-slider]",
      collectionSidebarSlideOut: "[data-collection-sidebar-slide-out]",
      collectionSidebarCloseButton: "[data-collection-sidebar-close]",
      showMoreOptions: "[data-show-more]",
      groupTagsButton: "[data-aria-toggle]",
      collectionNav: "[data-collection-nav]",
      linkHidden: "[data-link-hidden]",
      underlay: "[data-drawer-underlay]",
      swatch: "data-swatch",
      animation: "[data-animation]",
    },
    classes$l = {
      animated: "drawer--animated",
      hiding: "is-hiding",
      expanded: "expanded",
      noMobileAnimation: "no-mobile-animation",
      hidden: "is-hidden",
      active: "is-active",
      focused: "is-focused",
    };
  let sections$i = {},
    Collection = class {
      init() {
        if ((this.sort && this.initSort(), null !== this.groupTagsButton)) {
          document.addEventListener("theme:resize", this.sidebarResizeEvent),
            this.groupTagsButton.addEventListener(
              "click",
              this.groupTagsButtonClickEvent
            ),
            this.collectionSidebar &&
              setTimeout(() => {
                this.collectionSidebar.classList.remove(
                  classes$l.noMobileAnimation
                );
              }, 1e3);
          new MutationObserver((e) => {
            for (const t of e)
              if ("attributes" === t.type) {
                "true" == t.target.ariaExpanded && this.showSidebarCallback();
              }
          }).observe(this.groupTagsButton, {
            attributes: !0,
            childList: !1,
            subtree: !1,
          });
        }
        this.collectionSidebarCloseButtons.length &&
          this.collectionSidebarCloseButtons.forEach((e) => {
            e.addEventListener("click", this.collectionSidebarCloseEvent);
          }),
          this.container.addEventListener(
            "keyup",
            function (e) {
              e.code === window.theme.keyboardKeys.ESCAPE && this.hideSidebar();
            }.bind(this)
          ),
          this.underlay &&
            this.underlay.addEventListener(
              "click",
              this.collectionSidebarCloseEvent
            ),
          this.showMoreOptions &&
            this.showMoreOptions.forEach((e) => {
              e.addEventListener("click", (t) => {
                t.preventDefault(),
                  e.parentElement.classList.add(classes$l.hidden),
                  e.parentElement.previousElementSibling
                    .querySelectorAll(selectors$r.linkHidden)
                    .forEach((e, t) => {
                      e.classList.remove(classes$l.hidden),
                        0 === t && (window.accessibility.lastFocused = e);
                    });
                this.container.querySelector(
                  selectors$r.collectionSidebarSlideOut
                ) &&
                  (this.accessibility.removeTrapFocus(),
                  this.accessibility.trapFocus(this.collectionSidebar, {
                    elementToFocus: window.accessibility.lastFocused,
                  }));
              });
            }),
          this.collectionSidebarHeading &&
            this.collectionSidebarHeading.forEach((e) => {
              e.addEventListener("click", (e) => this.collectionAccordion(e)),
                e.addEventListener("keyup", (e) => {
                  (e.code !== window.theme.keyboardKeys.SPACE &&
                    e.code !== window.theme.keyboardKeys.ENTER) ||
                    !document.body.classList.contains(classes$l.focused) ||
                    ((window.accessibility.lastFocused = e.currentTarget),
                    this.collectionAccordion(e));
                });
            }),
          this.swatches &&
            this.swatches.forEach((e) => {
              new Swatch(e);
            }),
          this.collectionSidebar &&
            (this.collectionSidebar.addEventListener("transitionend", () => {
              this.collectionSidebar.classList.contains(classes$l.expanded) ||
                this.collectionSidebar.classList.remove(classes$l.animated);
            }),
            this.toggleSidebarSlider());
      }
      collectionAccordion(e) {
        e.preventDefault();
        const t = e.currentTarget;
        t.classList.toggle(classes$l.active),
          slideToggle(t.nextElementSibling, 500),
          t.nextElementSibling.nextElementSibling &&
            slideToggle(t.nextElementSibling.nextElementSibling, 500);
        const s = this.container.querySelector(
          selectors$r.collectionSidebarSlideOut
        );
        if (s) {
          const e = () => {
            this.accessibility.removeTrapFocus(),
              this.accessibility.trapFocus(this.collectionSidebar),
              this.accessibility.trapFocus(this.collectionSidebar, {
                elementToFocus: window.accessibility.lastFocused,
              }),
              s.removeEventListener("transitionend", e);
          };
          s.addEventListener("transitionend", e);
        }
      }
      collectionSidebarScroll() {
        document.dispatchEvent(
          new CustomEvent("theme:tooltip:close", {
            bubbles: !1,
            detail: {
              hideTransition: !1,
            },
          })
        );
      }
      sortActions(e, t = !0) {
        const s = e ? e.getAttribute(selectors$r.sortValue) : "";
        this.sort.setAttribute(selectors$r.dataSort, s);
        const i = this.sort.querySelector(selectors$r.sortButtonText),
          o = this.sort.querySelector(`.${classes$l.active}`);
        if (i) {
          const t = e ? e.textContent.trim() : "";
          i.textContent = t;
        }
        o && o.classList.remove(classes$l.active),
          this.sort.classList.toggle(classes$l.active, e),
          e &&
            (e.parentElement.classList.add(classes$l.active),
            t &&
              e.dispatchEvent(
                new CustomEvent("theme:filter:update", {
                  bubbles: !0,
                  detail: {
                    href: s,
                  },
                })
              ));
      }
      onSortButtonClick(e) {
        e.preventDefault(),
          this.sortButton && this.sortButton.dispatchEvent(new Event("click")),
          this.sortActions(e.currentTarget);
      }
      onSortCheck(e) {
        let t = null;
        if (window.location.search.includes("sort_by")) {
          const e = new window.URL(window.location.href).searchParams;
          for (const [s, i] of e.entries()) {
            const e = this.sort.querySelector(
              `[${selectors$r.sortValue}="${i}"]`
            );
            if (s.includes("sort_by") && e) {
              t = e;
              break;
            }
          }
        }
        this.sortActions(t, !1);
      }
      initSort() {
        this.sortLinks.forEach((e) => {
          e.addEventListener("click", this.onSortButtonClickEvent);
        }),
          this.sort.addEventListener(
            "theme:filter:sort",
            this.onSortCheckEvent
          ),
          this.sortButton &&
            this.sortButton.addEventListener("click", () => {
              console.log('sortbutton',this.sortButton);
              try{
              const e =
                  (window.innerWidth ||
                    document.documentElement.clientWidth ||
                    document.body.clientWidth) < theme.sizes.small,
                t = this.collectionSidebar.classList.contains(
                  classes$l.expanded
                );
              e && t && this.hideSidebar();
              }catch(er){console.log(er);}
            });
      }
      showSidebarCallback() {
        const e =
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth,
          t = this.container.querySelector(selectors$r.collectionSidebarSlider),
          s = this.container.querySelector(
            selectors$r.collectionSidebarSlideOut
          ),
          i = t || s,
          o = document.documentElement.hasAttribute("data-scroll-locked");
        this.collectionSidebar.classList.add(classes$l.animated),
          null === s &&
            e > theme.sizes.small &&
            o &&
            (this.accessibility.removeTrapFocus(),
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", {
                bubbles: !0,
              })
            )),
          (e < theme.sizes.small || null !== s) &&
            (s &&
              this.accessibility.trapFocus(this.collectionSidebar, {
                elementToFocus: this.collectionSidebar.querySelector(
                  selectors$r.collectionSidebarCloseButton
                ),
              }),
            document.dispatchEvent(
              new CustomEvent("theme:scroll:lock", {
                bubbles: !0,
                detail: i,
              })
            )),
          i && i.addEventListener("scroll", this.collectionSidebarScrollEvent);
      }
      hideSidebar() {
        const e = this.container.querySelector(
            selectors$r.collectionSidebarSlider
          ),
          t = this.container.querySelector(
            selectors$r.collectionSidebarSlideOut
          ),
          s = e || t,
          i = document.documentElement.hasAttribute("data-scroll-locked");
        this.groupTagsButton.setAttribute("aria-expanded", "false"),
          this.collectionSidebar.classList.remove(classes$l.expanded),
          s &&
            s.removeEventListener("scroll", this.collectionSidebarScrollEvent),
          t && this.accessibility.removeTrapFocus(),
          i &&
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", {
                bubbles: !0,
              })
            );
      }
      toggleSidebarSlider() {
        (window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth) < theme.sizes.small
          ? this.hideSidebar()
          : this.collectionSidebar.classList.contains(classes$l.expanded) &&
            this.showSidebarCallback();
      }
      collectionSidebarClose(e) {
        e.preventDefault(),
          this.hideSidebar(),
          document.body.classList.contains(classes$l.focused) &&
            this.groupTagsButton &&
            this.groupTagsButton.focus();
      }
      groupTagsButtonClick() {
        document.documentElement.hasAttribute("data-scroll-locked") &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", {
              bubbles: !0,
            })
          );
      }
      onUnload(e = !0) {
        null !== this.groupTagsButton &&
          (document.removeEventListener(
            "theme:resize",
            this.sidebarResizeEvent
          ),
          this.groupTagsButton.removeEventListener(
            "click",
            this.groupTagsButtonClickEvent
          )),
          this.collectionSidebarCloseButtons.length &&
            e &&
            this.collectionSidebarCloseButtons.forEach((e) => {
              e.removeEventListener("click", this.collectionSidebarCloseEvent);
            }),
          this.collectionSidebarScrollable & e &&
            this.collectionSidebarScrollable.removeEventListener(
              "scroll",
              this.collectionSidebarScrollEvent
            ),
          this.underlay &&
            this.underlay.removeEventListener(
              "click",
              this.collectionSidebarCloseEvent
            ),
          this.sort &&
            (this.sortLinks.forEach((e) => {
              e.removeEventListener("click", this.onClickEvent);
            }),
            this.sort.removeEventListener(
              "theme:filter:sort",
              this.onSortCheckEvent
            ));
      }
      constructor(e) {
        (this.container = e.container),
          (this.sort = this.container.querySelector(
            `[${selectors$r.dataSort}]`
          )),
          (this.sortButton = this.container.querySelector(
            selectors$r.sortButton
          )),
          (this.sortLinks = this.container.querySelectorAll(
            selectors$r.sortLinks
          )),
          (this.collectionSidebar = this.container.querySelector(
            selectors$r.collectionSidebar
          )),
          (this.collectionSidebarCloseButtons = this.container.querySelectorAll(
            selectors$r.collectionSidebarCloseButton
          )),
          (this.groupTagsButton = this.container.querySelector(
            selectors$r.groupTagsButton
          )),
          (this.collectionNav = this.container.querySelector(
            selectors$r.collectionNav
          )),
          (this.showMoreOptions = this.container.querySelectorAll(
            selectors$r.showMoreOptions
          )),
          (this.collectionSidebarHeading = this.container.querySelectorAll(
            selectors$r.collectionSidebarHeading
          )),
          (this.underlay = this.container.querySelector(selectors$r.underlay)),
          (this.swatches = this.container.querySelectorAll(
            `[${selectors$r.swatch}]`
          )),
          (this.accessibility = a11y),
          (this.groupTagsButtonClickEvent = (e) =>
            this.groupTagsButtonClick(e)),
          (this.collectionSidebarCloseEvent = (e) =>
            this.collectionSidebarClose(e)),
          (this.collectionSidebarScrollEvent = () =>
            this.collectionSidebarScroll()),
          (this.onSortButtonClickEvent = (e) => this.onSortButtonClick(e)),
          (this.onSortCheckEvent = (e) => this.onSortCheck(e)),
          (this.sidebarResizeEvent = () => this.toggleSidebarSlider()),
          this.init();
      }
    };
  const collectionSection = {
    onLoad() {
      sections$i[this.id] = new Collection(this);
    },
    onUnload() {
      sections$i[this.id].onUnload();
    },
  };
  register("collection", [
    slider,
    parallaxHero,
    collectionSection,
    popoutSection,
    swatchGridSection,
    collectionFiltersForm,
    tooltipSection,
    siblings,
  ]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", QuickAddProduct);
  const selectors$q = {
      frame: "[data-ticker-frame]",
      scale: "[data-ticker-scale]",
      text: "[data-ticker-text]",
      clone: "data-clone",
    },
    attributes$7 = {
      speed: "data-marquee-speed",
    },
    classes$k = {
      animation: "ticker--animated",
      unloaded: "ticker--unloaded",
      comparitor: "ticker__comparitor",
    },
    settings = {
      textAnimationTime: 1.63,
      space: 100,
    };
  let Ticker = class {
    unload() {
      document.removeEventListener("theme:resize", this.resizeEvent);
    }
    listen() {
      document.addEventListener("theme:resize", this.resizeEvent),
        this.checkWidth();
    }
    checkWidth() {
      const e =
          2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", ""),
        t = this.frame.getAttribute(attributes$7.speed)
          ? this.frame.getAttribute(attributes$7.speed)
          : settings.textAnimationTime;
      if (
        this.frame.clientWidth - e < this.comparitor.clientWidth ||
        this.stopClone
      ) {
        if (
          (this.text.classList.add(classes$k.animation),
          1 === this.scale.childElementCount)
        ) {
          if (
            ((this.clone = this.text.cloneNode(!0)),
            this.clone.setAttribute(selectors$q.clone, ""),
            this.scale.appendChild(this.clone),
            this.stopClone)
          )
            for (let e = 0; e < 10; e++) {
              const e = this.text.cloneNode(!0);
              e.setAttribute(selectors$q.clone, ""), this.scale.appendChild(e);
            }
          const e = (
            (this.text.clientWidth / settings.space) *
            Number(t)
          ).toFixed(2);
          this.scale.style.setProperty("--animation-time", `${e}s`);
        }
      } else {
        this.text.classList.add(classes$k.animation);
        let e = this.scale.querySelector(`[${selectors$q.clone}]`);
        e && this.scale.removeChild(e),
          this.text.classList.remove(classes$k.animation);
      }
    }
    constructor(e, t = !1) {
      (this.frame = e),
        (this.stopClone = t),
        (this.scale = this.frame.querySelector(selectors$q.scale)),
        (this.text = this.frame.querySelector(selectors$q.text)),
        (this.comparitor = this.text.cloneNode(!0)),
        this.comparitor.classList.add(classes$k.comparitor),
        this.frame.appendChild(this.comparitor),
        this.scale.classList.remove(classes$k.unloaded),
        (this.resizeEvent = debounce(() => this.checkWidth(), 100)),
        this.listen();
    }
  };
  const selectors$p = {
      bar: "[data-bar]",
      barSlide: "[data-slide]",
      frame: "[data-ticker-frame]",
      header: "[data-header-wrapper]",
      slider: "[data-slider]",
      marquee: "[data-marquee]",
      tickerScale: "[data-ticker-scale]",
      tickerText: "[data-ticker-text]",
    },
    classes$j = {
      tickerAnimated: "ticker--animated",
    },
    attributes$6 = {
      slide: "data-slide",
      stop: "data-stop",
      style: "style",
      targetReferrer: "data-target-referrer",
    },
    sections$h = {};
  let Bar = class {
    init() {
      this.removeAnnouncement(),
        this.slider && this.initSliders(),
        this.marquee && this.initTickers(!0),
        document.dispatchEvent(
          new CustomEvent("theme:announcement:init", {
            bubbles: !0,
          })
        );
    }
    removeAnnouncement() {
      for (let e = 0; e < this.slides.length; e++) {
        const t = this.slides[e];
        t.hasAttribute(attributes$6.targetReferrer) &&
          (-1 !==
            this.locationPath.indexOf(
              t.getAttribute(attributes$6.targetReferrer)
            ) ||
            window.Shopify.designMode ||
            t.parentNode.removeChild(t));
      }
    }
    initSliders() {
      (this.slider = new Slider(this.barHolder)),
        this.slider.flkty
          ? (this.slider.flkty.reposition(),
            this.barHolder.addEventListener("theme:slider:loaded", () => {
              this.initTickers();
            }))
          : this.initTickers();
    }
    initTickers(e = !1) {
      this.barHolder.querySelectorAll(selectors$p.frame).forEach((t) => {
        new Ticker(t, e);
      });
    }
    toggleTicker(e, t) {
      const s = document.querySelector(selectors$p.tickerScale),
        i = document.querySelector(
          `[${attributes$6.slide}="${e.detail.blockId}"]`
        );
      t &&
        i &&
        (s.setAttribute(attributes$6.stop, ""),
        s.querySelectorAll(selectors$p.tickerText).forEach((e) => {
          e.classList.remove(classes$j.tickerAnimated),
            (e.style.transform = `translate3d(${-(
              i.offsetLeft - i.clientWidth
            )}px, 0, 0)`);
        })),
        !t &&
          i &&
          (s.querySelectorAll(selectors$p.tickerText).forEach((e) => {
            e.classList.add(classes$j.tickerAnimated),
              e.removeAttribute(attributes$6.style);
          }),
          s.removeAttribute(attributes$6.stop));
    }
    onBlockSelect(e) {
      this.slider ? this.slider.onBlockSelect(e) : this.toggleTicker(e, !0);
    }
    onBlockDeselect(e) {
      this.slider ? this.slider.onBlockDeselect(e) : this.toggleTicker(e, !1);
    }
    constructor(e) {
      (this.barHolder = e),
        (this.locationPath = location.href),
        (this.slides = this.barHolder.querySelectorAll(selectors$p.barSlide)),
        (this.slider = this.barHolder.querySelector(selectors$p.slider)),
        (this.marquee = this.barHolder.querySelector(selectors$p.marquee)),
        this.init();
    }
  };
  const bar = {
    onLoad() {
      sections$h[this.id] = [];
      const e = this.container.querySelector(selectors$p.bar);
      e && sections$h[this.id].push(new Bar(e));
    },
    onBlockSelect(e) {
      sections$h[this.id].length &&
        sections$h[this.id].forEach((t) => {
          "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        });
    },
    onBlockDeselect(e) {
      sections$h[this.id].length &&
        sections$h[this.id].forEach((t) => {
          "function" == typeof t.onBlockSelect && t.onBlockDeselect(e);
        });
    },
  };
  register("announcement", [bar]);
  const selectors$o = {
      body: "body",
      drawerWrappper: "[data-drawer]",
      drawerContent: "[data-drawer-content]",
      underlay: "[data-drawer-underlay]",
      stagger: "[data-stagger-animation]",
      wrapper: "[data-header-transparent]",
      transparent: "data-header-transparent",
      drawerToggle: "data-drawer-toggle",
      scrollableElements: "[data-sliderule-pane], [data-sliderule]",
      focusable:
        'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    },
    classes$i = {
      animated: "drawer--animated",
      visible: "drawer--visible",
      isFocused: "is-focused",
      headerStuck: "js__header__stuck",
    };
  let sections$g = {},
    Drawer = class {
      connectToggle() {
        this.buttons.forEach((e) => {
          e.addEventListener("click", () => {
            this.drawer.dispatchEvent(
              new CustomEvent("theme:drawer:toggle", {
                bubbles: !1,
              })
            );
          });
        });
      }
      connectDrawer() {
        this.drawer.addEventListener("theme:drawer:toggle", () => {
          this.drawer.classList.contains(classes$i.visible)
            ? this.drawer.dispatchEvent(
                new CustomEvent("theme:drawer:close", {
                  bubbles: !0,
                })
              )
            : this.drawer.dispatchEvent(
                new CustomEvent("theme:drawer:open", {
                  bubbles: !0,
                })
              );
        }),
          this.drawerContent &&
            this.drawerContent.addEventListener("transitionend", () => {
              this.drawer.classList.contains(classes$i.visible) ||
                (this.drawer.classList.remove(classes$i.animated),
                document.dispatchEvent(
                  new CustomEvent("theme:sliderule:close", {
                    bubbles: !1,
                  })
                ));
            }),
          document.addEventListener("theme:cart:open", this.hideDrawer),
          document.addEventListener("theme:drawer:close", this.hideDrawer),
          document.addEventListener("theme:drawer:open", this.showDrawer);
      }
      watchFocus(e) {
        !this.wrapper.contains(e.target) &&
          this.body.classList.contains(classes$i.isFocused) &&
          this.hideDrawer();
      }
      closers() {
        this.wrapper.addEventListener(
          "keyup",
          function (e) {
            e.code === window.theme.keyboardKeys.ESCAPE &&
              (this.hideDrawer(), this.buttons[0].focus());
          }.bind(this)
        ),
          this.underlay.addEventListener("click", () => {
            this.hideDrawer();
          });
      }
      showDrawer() {
        if (
          this.drawerContent &&
          this.drawerContent.querySelector(this.btnSelector)
        ) {
          this.accessibility.removeTrapFocus();
          const e =
            1e3 *
            parseFloat(
              window.getComputedStyle(this.drawerContent).transitionDuration
            );
          setTimeout(() => {
            this.accessibility.trapFocus(this.drawerContent, {
              elementToFocus: this.drawerContent.querySelector(
                this.btnSelector
              ),
            });
          }, e);
        }
        document.dispatchEvent(
          new CustomEvent("theme:drawer:close", {
            bubbles: !1,
          })
        ),
          this.buttons.forEach((e) => {
            e.setAttribute("aria-expanded", !0);
          }),
          this.drawer.classList.add(classes$i.visible),
          this.drawer.classList.add(classes$i.animated),
          this.drawer.querySelector(selectors$o.focusable).focus(),
          this.wrapper.setAttribute(selectors$o.transparent, !1),
          document.addEventListener("focusin", this.initWatchFocus),
          this.scrollableElements.length &&
            this.scrollableElements.forEach((e) => {
              document.dispatchEvent(
                new CustomEvent("theme:scroll:lock", {
                  bubbles: !0,
                  detail: e,
                })
              );
            });
      }
      hideDrawer() {
        this.drawer.classList.contains(classes$i.visible) &&
          (this.accessibility.removeTrapFocus(),
          this.body.classList.contains(classes$i.isFocused) &&
            this.buttons.length &&
            this.buttons[0].focus(),
          this.buttons.forEach((e) => {
            e.setAttribute("aria-expanded", !1);
          }),
          this.drawer.classList.remove(classes$i.visible),
          document.removeEventListener("focusin", this.initWatchFocus),
          this.wrapper.classList.contains(classes$i.headerStuck) ||
            this.wrapper.setAttribute(
              selectors$o.transparent,
              theme.settings.transparentHeader
            ),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", {
              bubbles: !0,
            })
          ));
      }
      onUnload() {
        document.removeEventListener("theme:cart:open", this.hideDrawer),
          document.removeEventListener("theme:drawer:close", this.hideDrawer),
          document.removeEventListener("theme:drawer:open", this.showDrawer);
      }
      constructor(e) {
        (this.drawer = e),
          (this.drawerWrapper = this.drawer.closest(
            selectors$o.drawerWrappper
          )),
          (this.drawerContent = this.drawer.querySelector(
            selectors$o.drawerContent
          )),
          (this.scrollableElements = this.drawer.querySelectorAll(
            selectors$o.scrollableElements
          )),
          (this.underlay = this.drawer.querySelector(selectors$o.underlay)),
          (this.wrapper = this.drawer.closest(selectors$o.wrapper)),
          (this.key = this.drawer.dataset.drawer),
          (this.btnSelector = `[${selectors$o.drawerToggle}='${this.key}']`),
          (this.buttons = document.querySelectorAll(this.btnSelector)),
          (this.staggers = this.drawer.querySelectorAll(selectors$o.stagger)),
          (this.body = document.querySelector(selectors$o.body)),
          (this.accessibility = a11y),
          (this.initWatchFocus = (e) => this.watchFocus(e)),
          (this.showDrawer = this.showDrawer.bind(this)),
          (this.hideDrawer = this.hideDrawer.bind(this)),
          this.connectToggle(),
          this.connectDrawer(),
          this.closers();
      }
    };
  const drawer = {
      onLoad() {
        sections$g[this.id] = [];
        this.container
          .querySelectorAll(selectors$o.drawerWrappper)
          .forEach((e) => {
            sections$g[this.id].push(new Drawer(e));
          });
      },
      onUnload() {
        sections$g[this.id].forEach((e) => {
          "function" == typeof e.onUnload && e.onUnload();
        });
      },
    },
    selectors$n = {
      announcement: "[data-announcement-wrapper]",
      headerWrapper: "[data-header-wrapper]",
      header: "[data-header-wrapper] header",
    },
    classes$h = {
      stuck: "js__header__stuck",
      stuckAnimated: "js__header__stuck--animated",
      triggerAnimation: "js__header__stuck--trigger-animation",
      stuckBackdrop: "js__header__stuck__backdrop",
      headerIsNotVisible: "is-not-visible",
      hasStickyHeader: "has-sticky-header",
    },
    attributes$5 = {
      transparent: "data-header-transparent",
      stickyHeader: "data-header-sticky",
      scrollLock: "data-scroll-locked",
    };
  let sections$f = {},
    Sticky = class {
      unload() {
        (this.sticks || this.animated) &&
          document.removeEventListener("theme:scroll", this.scrollEventListen),
          this.animated &&
            (document.removeEventListener(
              "theme:scroll:up",
              this.scrollEventUpListen
            ),
            document.removeEventListener(
              "theme:scroll:down",
              this.scrollEventDownListen
            )),
          this.static &&
            document.removeEventListener(
              "theme:scroll",
              this.scrollEventStatic
            );
      }
      listen() {
        (this.sticks || this.animated) &&
          document.addEventListener("theme:scroll", this.scrollEventListen),
          this.animated &&
            (document.addEventListener(
              "theme:scroll:up",
              this.scrollEventUpListen
            ),
            document.addEventListener(
              "theme:scroll:down",
              this.scrollEventDownListen
            ));
      }
      listenScroll(e) {
        e.detail.down
          ? (!this.currentlyStuck &&
              e.detail.position > this.stickDown &&
              this.stickSimple(),
            !this.currentlyBlurred &&
              e.detail.position > this.blur &&
              this.addBlur())
          : (e.detail.position <= this.stickUp && this.unstickSimple(),
            e.detail.position <= this.blur && this.removeBlur());
      }
      stickSimple() {
        this.animated && this.cls.add(classes$h.stuckAnimated),
          this.cls.add(classes$h.stuck),
          this.wrapper.setAttribute(attributes$5.transparent, !1),
          (this.currentlyStuck = !0);
      }
      unstickSimple() {
        document.documentElement.hasAttribute(attributes$5.scrollLock) ||
          (this.cls.remove(classes$h.stuck),
          this.wrapper.setAttribute(
            attributes$5.transparent,
            theme.settings.transparentHeader
          ),
          this.animated && this.cls.remove(classes$h.stuckAnimated),
          (this.currentlyStuck = !1));
      }
      scrollDownInit() {
        window.scrollY > this.stickDown && this.stickSimple(),
          window.scrollY > this.blur && this.addBlur();
      }
      stickDirectional() {
        this.cls.add(classes$h.triggerAnimation);
      }
      unstickDirectional() {
        this.cls.remove(classes$h.triggerAnimation);
      }
      scrollDownDirectional() {
        this.unstickDirectional();
      }
      scrollUpDirectional() {
        window.scrollY <= this.stickDown
          ? this.unstickDirectional()
          : this.stickDirectional();
      }
      addBlur() {
        this.cls.add(classes$h.stuckBackdrop), (this.currentlyBlurred = !0);
      }
      removeBlur() {
        this.cls.remove(classes$h.stuckBackdrop), (this.currentlyBlurred = !1);
      }
      checkIsVisible() {
        const e = document.querySelector(selectors$n.headerWrapper),
          t = e.getAttribute(attributes$5.stickyHeader),
          s = this.win.pageYOffset;
        t ||
          e.classList.toggle(
            classes$h.headerIsNotVisible,
            s >= this.headerHeight
          );
      }
      constructor(e) {
        (this.wrapper = e),
          (this.type = this.wrapper.dataset.headerSticky),
          (this.sticks = !1),
          (this.static = !0),
          this.wrapper.hasAttribute(attributes$5.stickyHeader) &&
            ((this.sticks = !0), (this.static = !1)),
          (this.win = window),
          (this.animated = "directional" === this.type),
          (this.currentlyStuck = !1),
          (this.cls = this.wrapper.classList);
        const t = document.querySelector(selectors$n.announcement),
          s = t ? t.clientHeight : 0;
        (this.headerHeight = document.querySelector(
          selectors$n.header
        ).clientHeight),
          (this.blur = this.headerHeight + s),
          (this.stickDown = this.headerHeight + s),
          (this.stickUp = s),
          (this.scrollEventStatic = () => this.checkIsVisible()),
          (this.scrollEventListen = (e) => this.listenScroll(e)),
          (this.scrollEventUpListen = () => this.scrollUpDirectional()),
          (this.scrollEventDownListen = () => this.scrollDownDirectional()),
          "false" !== this.wrapper.getAttribute(attributes$5.transparent) &&
            (this.blur = s),
          this.sticks &&
            ((this.stickDown = s),
            this.scrollDownInit(),
            document.body.classList.add(classes$h.hasStickyHeader)),
          this.static &&
            document.addEventListener("theme:scroll", this.scrollEventStatic),
          this.listen();
      }
    };
  const stickyHeader = {
      onLoad() {
        sections$f = new Sticky(this.container);
      },
      onUnload: function () {
        "function" == typeof sections$f.unload && sections$f.unload();
      },
    },
    selectors$m = {
      disclosureToggle: "data-hover-disclosure-toggle",
      disclosureWrappper: "[data-hover-disclosure]",
      link: "[data-top-link]",
      wrapper: "[data-header-wrapper]",
      stagger: "[data-stagger]",
      staggerPair: "[data-stagger-first]",
      staggerAfter: "[data-stagger-second]",
      focusable:
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
    },
    classes$g = {
      isVisible: "is-visible",
      meganavVisible: "meganav--visible",
      meganavIsTransitioning: "meganav--is-transitioning",
    };
  let sections$e = {},
    disclosures = {},
    HoverDisclosure = class {
      onBlockSelect(e) {
        this.disclosure.contains(e.target) && this.showDisclosure(e);
      }
      onBlockDeselect(e) {
        this.disclosure.contains(e.target) && this.hideDisclosure();
      }
      showDisclosure(e) {
        e &&
          e.type &&
          "mouseenter" === e.type &&
          this.wrapper.classList.add(classes$g.meganavIsTransitioning),
          this.grandparent
            ? this.wrapper.classList.add(classes$g.meganavVisible)
            : this.wrapper.classList.remove(classes$g.meganavVisible),
          this.trigger.setAttribute("aria-expanded", !0),
          this.trigger.classList.add(classes$g.isVisible),
          this.disclosure.classList.add(classes$g.isVisible),
          this.transitionTimeout && clearTimeout(this.transitionTimeout),
          (this.transitionTimeout = setTimeout(() => {
            this.wrapper.classList.remove(classes$g.meganavIsTransitioning);
          }, 200));
      }
      hideDisclosure() {
        this.disclosure.classList.remove(classes$g.isVisible),
          this.trigger.classList.remove(classes$g.isVisible),
          this.trigger.setAttribute("aria-expanded", !1),
          this.wrapper.classList.remove(
            classes$g.meganavVisible,
            classes$g.meganavIsTransitioning
          );
      }
      staggerChildAnimations() {
        this.disclosure
          .querySelectorAll(selectors$m.stagger)
          .forEach((e, t) => {
            e.style.transitionDelay = 50 * t + 10 + "ms";
          });
        this.disclosure
          .querySelectorAll(selectors$m.staggerPair)
          .forEach((e, t) => {
            const s = 100 * t;
            (e.style.transitionDelay = `${s}ms`),
              e.parentElement
                .querySelectorAll(selectors$m.staggerAfter)
                .forEach((e, t) => {
                  const i = 20 * (t + 1);
                  e.style.transitionDelay = `${s + i}ms`;
                });
          });
      }
      handleTablets() {
        this.trigger.addEventListener(
          "touchstart",
          function (e) {
            this.disclosure.classList.contains(classes$g.isVisible) ||
              (e.preventDefault(), this.showDisclosure(e));
          }.bind(this),
          {
            passive: !0,
          }
        );
      }
      connectHoverToggle() {
        this.trigger.addEventListener("mouseenter", (e) =>
          this.showDisclosure(e)
        ),
          this.link.addEventListener("focus", (e) => this.showDisclosure(e)),
          this.trigger.addEventListener("mouseleave", () =>
            this.hideDisclosure()
          ),
          this.trigger.addEventListener("focusout", (e) => {
            this.trigger.contains(e.relatedTarget) || this.hideDisclosure();
          }),
          this.disclosure.addEventListener("keyup", (e) => {
            e.code === window.theme.keyboardKeys.ESCAPE &&
              this.hideDisclosure();
          });
      }
      constructor(e) {
        (this.disclosure = e),
          (this.wrapper = e.closest(selectors$m.wrapper)),
          (this.key = this.disclosure.id),
          (this.trigger = document.querySelector(
            `[${selectors$m.disclosureToggle}='${this.key}']`
          )),
          (this.link = this.trigger.querySelector(selectors$m.link)),
          (this.grandparent = this.trigger.classList.contains("grandparent")),
          (this.transitionTimeout = 0),
          this.trigger.setAttribute("aria-haspopup", !0),
          this.trigger.setAttribute("aria-expanded", !1),
          this.trigger.setAttribute("aria-controls", this.key),
          this.connectHoverToggle(),
          this.handleTablets(),
          this.staggerChildAnimations();
      }
    };
  const hoverDisclosure = {
      onLoad() {
        (sections$e[this.id] = []),
          (disclosures = this.container.querySelectorAll(
            selectors$m.disclosureWrappper
          )),
          disclosures.forEach((e) => {
            sections$e[this.id].push(new HoverDisclosure(e));
          });
      },
      onBlockSelect(e) {
        sections$e[this.id].forEach((t) => {
          "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
        });
      },
      onBlockDeselect(e) {
        sections$e[this.id].forEach((t) => {
          "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
        });
      },
    },
    selectors$l = {
      count: "data-cart-count",
    };
  let Totals = class {
    listen() {
      document.addEventListener(
        "theme:cart:change",
        function (e) {
          (this.cart = e.detail.cart), this.update();
        }.bind(this)
      );
    }
    update() {
      this.cart &&
        this.counts.forEach((e) => {
          e.setAttribute(selectors$l.count, this.cart.item_count),
            (e.innerHTML =
              this.cart.item_count < 10 ? `${this.cart.item_count}` : "9+");
        });
    }
    constructor(e) {
      (this.section = e),
        (this.counts = this.section.querySelectorAll(`[${selectors$l.count}]`)),
        (this.cart = null),
        this.listen();
    }
  };
  const headerTotals = {
      onLoad() {
        new Totals(this.container);
      },
    },
    selectors$k = {
      body: "body",
      popdownTrigger: "data-popdown-toggle",
      close: "[data-popdown-close]",
      input: "[data-predictive-search-input]",
    },
    classes$f = {
      isVisible: "is-visible",
      focused: "is-focused",
    };
  let sections$d = {},
    SearchPopdownTriggers = class {
      initTriggerEvents() {
        this.trigger.setAttribute("aria-haspopup", !0),
          this.trigger.setAttribute("aria-expanded", !1),
          this.trigger.setAttribute("aria-controls", this.key),
          this.trigger.addEventListener("click", (e) => {
            e.preventDefault(),
              this.body.classList.contains(classes$f.focused) ||
                this.showPopdown();
          }),
          this.trigger.addEventListener("keyup", (e) => {
            (e.code !== window.theme.keyboardKeys.SPACE &&
              e.code !== window.theme.keyboardKeys.ENTER) ||
              !this.body.classList.contains(classes$f.focused) ||
              this.showPopdown();
          });
      }
      initPopdownEvents() {
        this.popdown.addEventListener(
          "keyup",
          function (e) {
            e.code === window.theme.keyboardKeys.ESCAPE && this.hidePopdown();
          }.bind(this)
        ),
          this.close.addEventListener(
            "click",
            function () {
              this.hidePopdown();
            }.bind(this)
          ),
          this.document.addEventListener("click", (e) => {
            const t = e.target,
              s = !(
                t.matches(`[${selectors$k.popdownTrigger}]`) ||
                t.closest(`[${selectors$k.popdownTrigger}]`)
              ),
              i = !(t.matches(`#${this.key}`) || t.closest(`#${this.key}`));
            s &&
              i &&
              this.popdown.classList.contains(classes$f.isVisible) &&
              this.hidePopdown();
          });
      }
      hidePopdown() {
        this.popdown.classList.remove(classes$f.isVisible),
          this.input.form.reset(),
          this.input.dispatchEvent(
            new CustomEvent("clear", {
              bubbles: !1,
            })
          ),
          this.accessibility.removeTrapFocus(),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", {
              bubbles: !0,
            })
          ),
          this.body.classList.contains(classes$f.focused) &&
            setTimeout(() => {
              this.trigger.focus();
            }, 200);
      }
      showPopdown() {
        document.dispatchEvent(
          new CustomEvent("theme:drawer:close", {
            bubbles: !1,
          })
        ),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", {
              bubbles: !0,
              detail: this.popdown,
            })
          ),
          this.popdown.classList.add(classes$f.isVisible);
        const e =
            1e3 *
            parseFloat(
              window
                .getComputedStyle(this.popdown)
                .getPropertyValue("transition-duration")
            ),
          t = this.input.value;
        (this.input.value = ""),
          (this.input.value = t),
          setTimeout(() => {
            this.accessibility.trapFocus(this.popdown), this.input.focus();
          }, e);
      }
      constructor(e) {
        (this.trigger = e),
          (this.key = this.trigger.getAttribute(selectors$k.popdownTrigger));
        const t = `[id='${this.key}']`;
        (this.document = document),
          (this.popdown = document.querySelector(t)),
          (this.input = this.popdown.querySelector(selectors$k.input)),
          (this.close = this.popdown.querySelector(selectors$k.close)),
          (this.body = document.querySelector(selectors$k.body)),
          (this.accessibility = a11y),
          this.initTriggerEvents(),
          this.initPopdownEvents();
      }
    };
  const searchPopdown = {
      onLoad() {
        sections$d[this.id] = [];
        this.container
          .querySelectorAll(`[${selectors$k.popdownTrigger}]`)
          .forEach((e) => {
            sections$d[this.id].push(new SearchPopdownTriggers(e));
          });
      },
    },
    selectors$j = {
      apiSearchResults: "[data-api-search-results]",
      searchInput: 'input[type="search"]',
      searchType: 'input[name="type"]',
      searchPopdown: "[data-search-popdown]",
      searchResults: "[data-search-results]",
      searchResultsOuter: "[data-search-results-outer]",
    },
    classes$e = {
      searched: "is-searched",
      loading: "is-loading",
    };
  let PredictiveSearch = class extends HTMLElement {
    onChange() {
      const e = this.input.value.trim();
      e.length && this.getSearchResults(e);
    }
    getSearchResults(e) {
      fetch(
        `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
          e
        )}&${encodeURIComponent("resources[type]")}=${
          this.searchType
        }&${encodeURIComponent(
          "resources[limit]"
        )}=4&section_id=header-predictive-search`
      )
        .then((e) => {
          if (!e.ok) throw new Error(e.status);
          return e.text();
        })
        .then((e) => {
          const t = new DOMParser()
            .parseFromString(e, "text/html")
            .querySelector(selectors$j.apiSearchResults).innerHTML;
          (this.searchResults.innerHTML = t),
            this.searchPopdown.classList.add(classes$e.searched),
            this.searchResultsOuter.classList.remove(classes$e.loading);
        })
        .catch((e) => {
          throw e;
        });
    }
    reset() {
      (this.searchResults.innerHTML = ""),
        this.searchPopdown.classList.remove(classes$e.searched),
        (this.input.val = ""),
        this.a11y.removeTrapFocus();
    }
    constructor() {
      super(),
        (this.input = this.querySelector(selectors$j.searchInput)),
        (this.searchResults = this.querySelector(selectors$j.searchResults)),
        (this.searchResultsOuter = this.querySelector(
          selectors$j.searchResultsOuter
        )),
        (this.searchPopdown = this.querySelector(selectors$j.searchPopdown)),
        (this.searchType = this.querySelector(selectors$j.searchType).value),
        (this.a11y = a11y),
        this.input.addEventListener(
          "input",
          debounce((e) => {
            const t = e.target.value;
            t && t.length > 1
              ? (this.searchResultsOuter.classList.add(classes$e.loading),
                this.onChange(e))
              : this.reset();
          }, 300).bind(this)
        ),
        this.input.addEventListener("clear", this.reset.bind(this));
    }
  };
  const selectors$i = {
      slideruleOpen: "data-sliderule-open",
      slideruleClose: "data-sliderule-close",
      sliderulePane: "data-sliderule-pane",
      slideruleWrappper: "[data-sliderule]",
      drawerContent: "[data-drawer-content]",
      focusable:
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      dataAnimates: "data-animates",
      children:
        ":scope > [data-animates], \n             :scope > * > [data-animates], \n             :scope > * > * >[data-animates],\n             :scope > * > .sliderule-grid  > *",
    },
    classes$d = {
      isVisible: "is-visible",
      isHiding: "is-hiding",
      isHidden: "is-hidden",
      scrolling: "is-scrolling",
    };
  let sections$c = {},
    HeaderMobileSliderule = class {
      clickEvents() {
        this.trigger.addEventListener("click", () => {
          (this.cachedButton = this.trigger), this.showSliderule();
        }),
          this.exit.forEach((e) => {
            e.addEventListener("click", () => {
              this.hideSliderule();
            });
          });
      }
      keyboardEvents() {
        this.sliderule.addEventListener("keyup", (e) => {
          e.stopPropagation(),
            e.code === window.theme.keyboardKeys.ESCAPE && this.hideSliderule();
        });
      }
      trapFocusSliderule(e = !0) {
        const t = e
          ? this.sliderule.querySelector(this.exitSelector)
          : this.cachedButton;
        this.accessibility.removeTrapFocus(),
          t &&
            this.drawerContent &&
            this.accessibility.trapFocus(this.drawerContent, {
              elementToFocus: t,
            });
      }
      hideSliderule(e = !1) {
        const t = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
        this.pane.setAttribute(selectors$i.sliderulePane, t),
          this.pane.classList.add(classes$d.isHiding),
          this.sliderule.classList.add(classes$d.isHiding);
        const s = e
            ? `[${selectors$i.dataAnimates}].${classes$d.isHidden}`
            : `[${selectors$i.dataAnimates}="${t}"]`,
          i = this.pane.querySelectorAll(s);
        i.length &&
          i.forEach((e) => {
            e.classList.remove(classes$d.isHidden);
          });
        const o = e
          ? this.pane.querySelectorAll(
              `.${classes$d.isVisible}, .${classes$d.isHiding}`
            )
          : this.children;
        o.forEach((s, i) => {
          const r = o.length - 1 == i;
          s.classList.remove(classes$d.isVisible),
            e &&
              (s.classList.remove(classes$d.isHiding),
              this.pane.classList.remove(classes$d.isHiding));
          const n = () => {
            parseInt(this.pane.getAttribute(selectors$i.sliderulePane)) === t &&
              this.sliderule.classList.remove(classes$d.isVisible),
              this.sliderule.classList.remove(classes$d.isHiding),
              this.pane.classList.remove(classes$d.isHiding),
              r &&
                (this.accessibility.removeTrapFocus(),
                e || this.trapFocusSliderule(!1)),
              s.removeEventListener("animationend", n);
          };
          s.addEventListener("animationend", n);
        });
      }
      showSliderule() {
        let e = null;
        const t = this.sliderule.closest(`.${classes$d.isVisible}`);
        let s = this.pane;
        t && (s = t),
          s.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          }),
          s.classList.add(classes$d.scrolling);
        const i = () => {
          s.scrollTop <= 0
            ? (s.classList.remove(classes$d.scrolling),
              e && cancelAnimationFrame(e))
            : (e = requestAnimationFrame(i));
        };
        (e = requestAnimationFrame(i)),
          this.sliderule.classList.add(classes$d.isVisible);
        const o = parseInt(this.pane.dataset.sliderulePane, 10),
          r = o + 1;
        this.pane.setAttribute(selectors$i.sliderulePane, r);
        const n = this.pane.querySelectorAll(
          `[${selectors$i.dataAnimates}="${o}"]`
        );
        n.length &&
          n.forEach((e, t) => {
            const s = n.length - 1 == t;
            e.classList.add(classes$d.isHiding);
            const i = () => {
              e.classList.remove(classes$d.isHiding),
                parseInt(this.pane.getAttribute(selectors$i.sliderulePane)) !==
                  o && e.classList.add(classes$d.isHidden),
                s && this.trapFocusSliderule(),
                e.removeEventListener("animationend", i);
            };
            e.addEventListener("animationend", i);
          });
      }
      closeSliderule() {
        this.pane &&
          this.pane.hasAttribute(selectors$i.sliderulePane) &&
          parseInt(this.pane.getAttribute(selectors$i.sliderulePane)) > 0 &&
          (this.hideSliderule(!0),
          parseInt(this.pane.getAttribute(selectors$i.sliderulePane)) > 0 &&
            this.pane.setAttribute(selectors$i.sliderulePane, 0));
      }
      onUnload() {
        document.removeEventListener(
          "theme:sliderule:close",
          this.closeSliderule
        );
      }
      constructor(e) {
        (this.sliderule = e), (this.key = this.sliderule.id);
        const t = `[${selectors$i.slideruleOpen}='${this.key}']`;
        (this.exitSelector = `[${selectors$i.slideruleClose}='${this.key}']`),
          (this.trigger = document.querySelector(t)),
          (this.exit = document.querySelectorAll(this.exitSelector)),
          (this.pane = document.querySelector(
            `[${selectors$i.sliderulePane}]`
          )),
          (this.children = this.sliderule.querySelectorAll(
            selectors$i.children
          )),
          (this.drawerContent = document.querySelector(
            selectors$i.drawerContent
          )),
          (this.cachedButton = null),
          (this.accessibility = a11y),
          this.trigger.setAttribute("aria-haspopup", !0),
          this.trigger.setAttribute("aria-expanded", !1),
          this.trigger.setAttribute("aria-controls", this.key),
          (this.closeSliderule = this.closeSliderule.bind(this)),
          this.clickEvents(),
          this.keyboardEvents(),
          document.addEventListener(
            "theme:sliderule:close",
            this.closeSliderule
          );
      }
    };
  const headerMobileSliderule = {
      onLoad() {
        sections$c[this.id] = [];
        this.container
          .querySelectorAll(selectors$i.slideruleWrappper)
          .forEach((e) => {
            sections$c[this.id].push(new HeaderMobileSliderule(e));
          });
      },
      onUnload() {
        sections$c[this.id].forEach((e) => {
          "function" == typeof e.onUnload && e.onUnload();
        });
      },
    },
    selectors$h = {
      wrapper: "[data-header-wrapper]",
      html: "html",
      style: "data-header-style",
      widthContentWrapper: "[data-takes-space-wrapper]",
      widthContent: "[data-child-takes-space]",
      desktop: "[data-header-desktop]",
      cloneClass: "js__header__clone",
      showMobileClass: "js__show__mobile",
      backfill: "[data-header-backfill]",
      transparent: "data-header-transparent",
      overrideBorder: "header-override-border",
      firstSectionHasImage:
        ".main-content > .shopify-section:first-child [data-overlay-header]",
      preventTransparentHeader:
        ".main-content > .shopify-section:first-child [data-prevent-transparent-header]",
      deadLink: '.navlink[href="#"]',
    };
  let sections$b = {},
    Header = class {
      checkForImage() {
        this.overlayedImages = document.querySelectorAll(
          selectors$h.firstSectionHasImage
        );
        let e = document.querySelectorAll(
          selectors$h.preventTransparentHeader
        ).length;
        this.overlayedImages.length && !e && this.isTransparentHeader
          ? (this.listenOverlay(),
            this.wrapper.setAttribute(selectors$h.transparent, !0),
            (document.querySelector(selectors$h.backfill).style.display =
              "none"),
            (theme.settings.transparentHeader = !0))
          : (this.wrapper.setAttribute(selectors$h.transparent, !1),
            (document.querySelector(selectors$h.backfill).style.display =
              "block"),
            (theme.settings.transparentHeader = !1)),
          !this.overlayedImages.length ||
            e ||
            this.isTransparentHeader ||
            this.wrapper.classList.add(selectors$h.overrideBorder),
          this.subtractAnnouncementHeight();
      }
      listenOverlay() {
        document.addEventListener("theme:resize", this.resizeEventOverlay),
          this.subtractAnnouncementHeight();
      }
      listenWidth() {
        document.addEventListener("theme:resize", this.resizeEventWidth),
          this.checkWidth();
      }
      listenSectionEvents() {
        document.addEventListener(
          "shopify:section:load",
          this.headerUpdateEvent
        ),
          document.addEventListener(
            "shopify:section:unload",
            this.headerUpdateEvent
          ),
          document.addEventListener(
            "shopify:section:reorder",
            this.headerUpdateEvent
          );
      }
      killDeadLinks() {
        this.deadLinks.forEach((e) => {
          e.onclick = (e) => {
            e.preventDefault();
          };
        });
      }
      subtractAnnouncementHeight() {
        const e = getScreenOrientation(),
          { announcementHeight: t, headerHeight: s } = readHeights();
        let { windowHeight: i } = readHeights();
        this.screenOrientation === e && window.innerWidth < 768
          ? (i = window.initialWindowHeight)
          : (window.initialWindowHeight = i),
          this.overlayedImages.forEach((e) => {
            theme.settings.transparentHeader
              ? e.style.setProperty("--full-screen", i - t + "px")
              : e.style.setProperty("--full-screen", i - s + "px"),
              e.classList.add("has-overlay");
          }),
          this.screenOrientation !== e && (this.screenOrientation = e);
      }
      checkWidth() {
        document.body.clientWidth < this.minWidth
          ? this.wrapper.classList.add(selectors$h.showMobileClass)
          : this.wrapper.classList.remove(selectors$h.showMobileClass);
      }
      getMinWidth() {
        const e = this.wrapper.cloneNode(!0);
        e.classList.add(selectors$h.cloneClass), document.body.appendChild(e);
        const t = e.querySelectorAll(selectors$h.widthContentWrapper);
        let s = 0,
          i = 0;
        return (
          t.forEach((e) => {
            const t = e.querySelectorAll(selectors$h.widthContent);
            let o = 0;
            (o = 3 === t.length ? _sumSplitWidths(t) : _sumWidths(t)),
              o > s && ((s = o), (i = 20 * t.length));
          }),
          document.body.removeChild(e),
          s + i
        );
      }
      unload() {
        document.removeEventListener("theme:resize", this.resizeEventWidth),
          document.removeEventListener("theme:resize", this.resizeEventOverlay),
          document.removeEventListener(
            "shopify:section:load",
            this.headerUpdateEvent
          ),
          document.removeEventListener(
            "shopify:section:unload",
            this.headerUpdateEvent
          ),
          document.removeEventListener(
            "shopify:section:reorder",
            this.headerUpdateEvent
          );
      }
      constructor(e) {
        (this.wrapper = e),
          (this.html = document.querySelector(selectors$h.html)),
          (this.style = this.wrapper.dataset.style),
          (this.desktop = this.wrapper.querySelector(selectors$h.desktop)),
          (this.isTransparentHeader =
            "false" !== this.wrapper.getAttribute(selectors$h.transparent)),
          (this.overlayedImages = document.querySelectorAll(
            selectors$h.firstSectionHasImage
          )),
          (this.deadLinks = document.querySelectorAll(selectors$h.deadLink)),
          (this.headerUpdateEvent = debounce(() => this.checkForImage(), 500)),
          (this.resizeEventWidth = () => this.checkWidth()),
          (this.resizeEventOverlay = () => this.subtractAnnouncementHeight()),
          this.killDeadLinks(),
          "drawer" !== this.style &&
            this.desktop &&
            ((this.minWidth = this.getMinWidth()), this.listenWidth()),
          this.checkForImage(),
          this.listenSectionEvents(),
          (this.screenOrientation = getScreenOrientation());
      }
    };

  function _sumSplitWidths(e) {
    let t = [];
    e.forEach((e) => {
      e.firstElementChild && t.push(e.firstElementChild.clientWidth);
    }),
      t[0] > t[2] ? (t[2] = t[0]) : (t[0] = t[2]);
    return t.reduce((e, t) => e + t);
  }

  function _sumWidths(e) {
    let t = 0;
    return (
      e.forEach((e) => {
        t += e.clientWidth;
      }),
      t
    );
  }
  const header = {
    onLoad() {
      (sections$b = new Header(this.container)), setVarsOnResize();
    },
    onUnload() {
      "function" == typeof sections$b.unload && sections$b.unload();
    },
  };
  register("header", [
    header,
    drawer,
    popoutSection,
    headerMobileSliderule,
    stickyHeader,
    hoverDisclosure,
    headerTotals,
    searchPopdown,
  ]),
    customElements.get("predictive-search") ||
      customElements.define("predictive-search", PredictiveSearch);
  const selectors$g = {
      scrollElement: "[data-block-scroll]",
      flickityEnabled: "flickity-enabled",
    },
    sections$a = {};
  let BlockScroll = class {
    onBlockSelect(e) {
      const t = this.container.querySelector(selectors$g.scrollElement);
      if (t && !t.classList.contains(selectors$g.flickityEnabled)) {
        const s = e.srcElement;
        s &&
          t.scrollTo({
            top: 0,
            left: s.offsetLeft,
            behavior: "smooth",
          });
      }
    }
    constructor(e) {
      this.container = e.container;
    }
  };
  const blockScroll = {
      onLoad() {
        sections$a[this.id] = new BlockScroll(this);
      },
      onBlockSelect(e) {
        sections$a[this.id].onBlockSelect(e);
      },
    },
    selectors$f = {
      slider: "[data-slider-mobile]",
      slide: "[data-slide]",
      thumb: "[data-slider-thumb]",
      sliderContainer: "[data-slider-container]",
      popupContainer: "[data-popup-container]",
      popupContent: "[data-popup-content]",
      popupClose: "[data-popup-close]",
      headerSticky: "[data-header-sticky]",
      headerHeight: "[data-header-height]",
    },
    classes$c = {
      isAnimating: "is-animating",
      isSelected: "is-selected",
      isOpen: "is-open",
    },
    attributes$4 = {
      thumbValue: "data-slider-thumb",
    },
    sections$9 = {};
  let Look = class {
    init() {
      this.slider &&
        this.slides.length &&
        this.thumbs.length &&
        (this.popupContainer.addEventListener("transitionend", () => {
          this.popupContainer.classList.remove(classes$c.isAnimating);
        }),
        this.popupContainer.addEventListener("transitionstart", () => {
          this.popupContainer.classList.add(classes$c.isAnimating);
        }),
        this.popupClose.forEach((e) => {
          e.addEventListener("click", () => {
            this.popupContainer.classList.remove(classes$c.isOpen),
              this.scrollUnlock();
          });
        }),
        this.thumbs.forEach((e, t) => {
          e.addEventListener("click", (s) => {
            s.preventDefault();
            const i =
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth,
              o =
                e.hasAttribute(attributes$4.thumbValue) &&
                "" !== e.getAttribute(attributes$4.thumbValue)
                  ? parseInt(e.getAttribute(attributes$4.thumbValue))
                  : t,
              r = this.slides[o];
            if (i < theme.sizes.small) {
              const e = parseInt(
                  window.getComputedStyle(this.slider).paddingLeft
                ),
                t = r.offsetLeft;
              this.slider.scrollTo({
                top: 0,
                left: t - e,
                behavior: "auto",
              }),
                this.scrollLock(),
                this.popupContainer.classList.add(
                  classes$c.isAnimating,
                  classes$c.isOpen
                );
            } else {
              const e =
                  document.querySelector(selectors$f.headerSticky) &&
                  document.querySelector(selectors$f.headerHeight)
                    ? document
                        .querySelector(selectors$f.headerHeight)
                        .getBoundingClientRect().height
                    : 0,
                t = r.getBoundingClientRect().top,
                s = r.offsetHeight / 2,
                i = window.innerHeight,
                o = i / 2,
                n = this.container.querySelector(selectors$f.sliderContainer);
              let a = t + s - o + window.scrollY;
              if (n) {
                const t = n.getBoundingClientRect().top + window.scrollY,
                  s = t + n.offsetHeight;
                a < t ? (a = t - e) : a + i > s && (a = s - i);
              }
              window.scrollTo({
                top: a,
                left: 0,
                behavior: "smooth",
              });
            }
          });
        }));
    }
    scrollLock() {
      document.dispatchEvent(
        new CustomEvent("theme:scroll:lock", {
          bubbles: !0,
          detail: this.slider,
        })
      ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.popupContent,
          })
        );
    }
    scrollUnlock() {
      document.dispatchEvent(
        new CustomEvent("theme:scroll:unlock", {
          bubbles: !0,
        })
      );
    }
    constructor(e) {
      (this.container = e.container),
        (this.slider = this.container.querySelector(selectors$f.slider)),
        (this.slides = this.container.querySelectorAll(selectors$f.slide)),
        (this.thumbs = this.container.querySelectorAll(selectors$f.thumb)),
        (this.popupContainer = this.container.querySelector(
          selectors$f.popupContainer
        )),
        (this.popupContent = this.container.querySelector(
          selectors$f.popupContent
        )),
        (this.popupClose = this.container.querySelectorAll(
          selectors$f.popupClose
        )),
        this.init();
    }
  };
  const lookSection = {
    onLoad() {
      sections$9[this.id] = new Look(this);
    },
  };
  register("look", [lookSection, swatchGridSection, siblings, blockScroll]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", QuickAddProduct);
  const selectors$e = {
      body: "body",
      dataRelatedSectionElem: "[data-related-section]",
      dataTabsHolder: "[data-tabs-holder]",
      dataTab: "data-tab",
      dataTabIndex: "data-tab-index",
      dataTabStartIndex: "data-start-index",
      dataTabStartIndexMobile: "data-start-index-mobile",
      dataAos: "[data-aos]",
      blockId: "data-block-id",
      tabsLi: "[data-tab]",
      tabLink: ".tab-link",
      tabLinkRecent: ".tab-link__recent",
      tabContent: ".tab-content",
      scrollbarHolder: "[data-scrollbar]",
      scrollbarArrowPrev: "[data-scrollbar-arrow-prev]",
      scrollbarArrowNext: "[data-scrollbar-arrow-next]",
      productModal: "[data-product-modal]",
    },
    classes$b = {
      current: "current",
      hide: "hide",
      alt: "alt",
      aosAnimate: "aos-animate",
      aosNoTransition: "aos-no-transition",
      focused: "is-focused",
    },
    sections$8 = {};
  let GlobalTabs = class {
    init() {
      const e =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth,
        t = this.container,
        s = t.querySelectorAll(selectors$e.tabsLi),
        i = t.hasAttribute(selectors$e.dataTabStartIndex)
          ? t.getAttribute(selectors$e.dataTabStartIndex)
          : 0;
      let o = t.querySelector(`${selectors$e.tabLink}-${i}`),
        r = t.querySelector(`${selectors$e.tabContent}-${i}`);
      if (e < theme.sizes.small) {
        const e = t.hasAttribute(selectors$e.dataTabStartIndexMobile)
          ? t.getAttribute(selectors$e.dataTabStartIndexMobile)
          : i;
        (o = t.querySelector(`${selectors$e.tabLink}-${e}`)),
          (r = t.querySelector(`${selectors$e.tabContent}-${e}`));
      }
      r && r.classList.add(classes$b.current),
        o && o.classList.add(classes$b.current),
        this.checkVisibleTabLinks(),
        this.container.addEventListener("theme:tab:check", () =>
          this.checkRecentTab()
        ),
        this.container.addEventListener("theme:tab:hide", () =>
          this.hideRelatedTab()
        ),
        s.length &&
          s.forEach((e) => {
            const s = parseInt(e.getAttribute(selectors$e.dataTab)),
              i = t.querySelector(`${selectors$e.tabContent}-${s}`);
            e.addEventListener("click", () => {
              this.tabChange(e, i);
            }),
              e.addEventListener("keyup", (t) => {
                (t.code !== window.theme.keyboardKeys.SPACE &&
                  t.code !== window.theme.keyboardKeys.ENTER) ||
                  !this.body.classList.contains(classes$b.focused) ||
                  this.tabChange(e, i);
              });
          });
    }
    tabChange(e, t) {
      if (e.classList.contains(classes$b.current)) return;
      this.container
        .querySelector(`${selectors$e.tabsLi}.${classes$b.current}`)
        .classList.remove(classes$b.current);
      this.container
        .querySelector(`${selectors$e.tabContent}.${classes$b.current}`)
        .classList.remove(classes$b.current),
        e.classList.add(classes$b.current),
        t.classList.add(classes$b.current),
        e.classList.contains(classes$b.hide) && t.classList.add(classes$b.hide),
        this.checkVisibleTabLinks(),
        this.accessibility.a11y.removeTrapFocus(),
        this.container.dispatchEvent(
          new CustomEvent("theme:tab:change", {
            bubbles: !0,
          })
        ),
        e.dispatchEvent(
          new CustomEvent("theme:form:sticky", {
            bubbles: !0,
            detail: {
              element: "tab",
            },
          })
        ),
        this.animateItems(t);
    }
    animateItems(e, t = !0) {
      const s = e.querySelectorAll(selectors$e.dataAos);
      s.length &&
        s.forEach((e) => {
          e.classList.remove(classes$b.aosAnimate),
            t &&
              (e.classList.add(classes$b.aosNoTransition),
              setTimeout(() => {
                e.classList.remove(classes$b.aosNoTransition),
                  e.classList.add(classes$b.aosAnimate);
              }));
        });
    }
    initNativeScrollbar() {
      this.scrollbarHolder.length &&
        this.scrollbarHolder.forEach((e) => {
          new NativeScrollbar(e);
        });
    }
    checkVisibleTabLinks() {
      const e = this.container.querySelectorAll(selectors$e.tabsLi),
        t = this.container.querySelectorAll(
          `${selectors$e.tabLink}.${classes$b.hide}`
        );
      e.length - t.length < 2
        ? this.container.classList.add(classes$b.alt)
        : this.container.classList.remove(classes$b.alt);
    }
    checkRecentTab() {
      const e = this.container.querySelector(selectors$e.tabLinkRecent);
      if (e) {
        e.classList.remove(classes$b.hide);
        const t = parseInt(e.getAttribute(selectors$e.dataTab)),
          s = this.container.querySelector(
            `${selectors$e.tabContent}[${selectors$e.dataTabIndex}="${t}"]`
          );
        s && (s.classList.remove(classes$b.hide), this.animateItems(s, !1)),
          this.checkVisibleTabLinks(),
          this.initNativeScrollbar();
      }
    }
    hideRelatedTab() {
      const e = this.container.querySelector(
        selectors$e.dataRelatedSectionElem
      );
      if (!e) return;
      const t = e.closest(`${selectors$e.tabContent}.${classes$b.current}`);
      if (!t) return;
      const s = parseInt(t.getAttribute(selectors$e.dataTabIndex)),
        i = this.container.querySelectorAll(selectors$e.tabsLi);
      if (i.length > s) {
        const e = i[s].nextSibling;
        e &&
          (i[s].classList.add(classes$b.hide),
          e.dispatchEvent(new Event("click")),
          this.initNativeScrollbar());
      }
    }
    onBlockSelect(e) {
      const t = this.container.querySelector(
        `${selectors$e.tabLink}[${selectors$e.blockId}="${e.detail.blockId}"]`
      );
      t &&
        (t.dispatchEvent(new Event("click")),
        t.parentNode.scrollTo({
          top: 0,
          left: t.offsetLeft - t.clientWidth,
          behavior: "smooth",
        }));
    }
    constructor(e) {
      (this.container = e),
        (this.body = document.querySelector(selectors$e.body)),
        (this.accessibility = window.accessibility),
        this.container &&
          ((this.scrollbarHolder = this.container.querySelectorAll(
            selectors$e.scrollbarHolder
          )),
          this.init(),
          this.initNativeScrollbar());
    }
  };
  const tabs = {
    onLoad() {
      sections$8[this.id] = [];
      this.container
        .querySelectorAll(selectors$e.dataTabsHolder)
        .forEach((e) => {
          sections$8[this.id].push(new GlobalTabs(e));
        });
    },
    onBlockSelect(e) {
      sections$8[this.id].forEach((t) => {
        "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
      });
    },
  };
  register("product-grid", [slider, swatchGridSection, tabs, siblings]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", QuickAddProduct);
  const tokensReducer = (e, t) => {
      const {
        el: s,
        elStyle: i,
        elHeight: o,
        rowsLimit: r,
        rowsWrapped: n,
        options: a,
      } = e;
      let l = e.buffer,
        c = l;
      if (n === r + 1) return { ...e };
      const d = l;
      let h = n,
        u = o;
      return (
        (s.innerHTML = c =
          l.length
            ? `${l}${a.delimiter}${t}${a.replaceStr}`
            : `${t}${a.replaceStr}`),
        parseFloat(i.height) > parseFloat(o) &&
        (h++, (u = i.height), h === r + 1)
          ? ((s.innerHTML = c =
              "." === d[d.length - 1] && "..." === a.replaceStr
                ? `${d}..`
                : `${d}${a.replaceStr}`),
            { ...e, elHeight: u, rowsWrapped: h })
          : ((s.innerHTML = c = d.length ? `${d}${a.delimiter}${t}` : `${t}`),
            { ...e, buffer: c, elHeight: u, rowsWrapped: h })
      );
    },
    ellipsis = (e = "", t = 1, s = {}) => {
      const i = {
          replaceStr: "...",
          debounceDelay: 250,
          delimiter: " ",
          ...s,
        },
        o =
          e &&
          (e instanceof NodeList
            ? e
            : 1 === e.nodeType
            ? [e]
            : document.querySelectorAll(e));
      for (let e = 0; e < o.length; e++) {
        const s = o[e],
          r = /<!--[\s\S]*?-->/g,
          n = s.innerHTML.replace(r, "").split(i.delimiter);
        s.innerHTML = "";
        const a = window.getComputedStyle(s);
        n.reduce(tokensReducer, {
          el: s,
          buffer: s.innerHTML,
          elStyle: a,
          elHeight: 0,
          rowsLimit: t,
          rowsWrapped: 0,
          options: i,
        });
      }
    },
    fadeOut = (e, t = null) => {
      (e.style.opacity = 1),
        (function s() {
          (e.style.opacity -= 0.1) < 0
            ? (e.style.display = "none")
            : requestAnimationFrame(s),
            0 === parseFloat(e.style.opacity) && "function" == typeof t && t();
        })();
    },
    selectors$d = {
      pickupContainer: "data-store-availability-container",
      shopifySection: ".shopify-section",
      drawer: "[data-pickup-drawer]",
      drawerBody: "[data-pickup-drawer-body]",
      drawerOpen: "[data-pickup-drawer-open]",
      drawerClose: "[data-pickup-drawer-close]",
      body: "body",
    },
    classes$a = {
      isOpen: "is-open",
      isHidden: "hidden",
    };
  let sections$7 = {},
    PickupAvailability = class {
      fetchPickupAvailability(e) {
        const t = this.container.querySelector(
          `[${selectors$d.pickupContainer}]`
        );
        if (!t) return;
        if (
          (e && !e.detail.variant) ||
          (e && e.detail.variant && !e.detail.variant.available)
        )
          return void t.classList.add(classes$a.isHidden);
        const s =
          e && e.detail.variant
            ? e.detail.variant.id
            : t.getAttribute(selectors$d.pickupContainer);
        (this.drawer = this.body.querySelector(selectors$d.drawer)),
          this.drawer && this.body.removeChild(this.drawer),
          s &&
            fetch(
              `${window.theme.routes.root}variants/${s}/?section_id=api-pickup-availability`
            )
              .then(this.handleErrors)
              .then((e) => e.text())
              .then((e) => {
                const s = new DOMParser()
                  .parseFromString(e, "text/html")
                  .querySelector(selectors$d.shopifySection).innerHTML;
                (t.innerHTML = s),
                  (this.drawer = this.container.querySelector(
                    selectors$d.drawer
                  )),
                  this.drawer
                    ? ((this.clone = this.drawer.cloneNode(!0)),
                      this.body.appendChild(this.clone),
                      t.classList.remove(classes$a.isHidden),
                      t.removeChild(this.drawer),
                      (this.drawer = this.body.querySelector(
                        selectors$d.drawer
                      )),
                      (this.drawerBody = this.body.querySelector(
                        selectors$d.drawerBody
                      )),
                      (this.buttonDrawerOpen = this.body.querySelector(
                        selectors$d.drawerOpen
                      )),
                      (this.buttonDrawerClose = this.body.querySelectorAll(
                        selectors$d.drawerClose
                      )),
                      this.buttonDrawerOpen &&
                        this.buttonDrawerOpen.addEventListener("click", () => {
                          this.openDrawer(),
                            (window.accessibility.lastElement =
                              this.buttonDrawerOpen);
                        }),
                      this.buttonDrawerClose.length &&
                        this.buttonDrawerClose.forEach((e) => {
                          e.addEventListener("click", () => this.closeDrawer());
                        }),
                      this.drawer.addEventListener("keyup", (e) => {
                        e.code === window.theme.keyboardKeys.ESCAPE &&
                          this.closeDrawer();
                      }))
                    : t.classList.add(classes$a.isHidden);
              })
              .catch((e) => {
                console.error(e);
              });
      }
      openDrawer() {
        this.drawer &&
          (this.drawer.classList.add(classes$a.isOpen),
          this.drawer.dispatchEvent(
            new CustomEvent("theme:scroll:lock", {
              bubbles: !0,
              detail: this.drawerBody,
            })
          ),
          setTimeout(() => {
            const e = this.drawer.querySelector(selectors$d.drawerClose);
            this.a11y.removeTrapFocus(),
              this.a11y.trapFocus(this.drawer, {
                elementToFocus: e,
              });
          }, 200));
      }
      closeDrawer() {
        this.drawer &&
          (this.drawer.classList.remove(classes$a.isOpen),
          this.drawer.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", {
              bubbles: !0,
              detail: this.drawerBody,
            })
          ),
          this.a11y.removeTrapFocus(),
          window.accessibility.lastElement &&
            setTimeout(() => {
              window.accessibility.lastElement.focus();
            }, 200));
      }
      closeEvent() {
        document.addEventListener("click", (e) => {
          const t = e.target;
          t.matches(selectors$d.drawerOpen) ||
            t.closest(selectors$d.drawer) ||
            this.closeDrawer();
        });
      }
      handleErrors(e) {
        return e.ok
          ? e
          : e.json().then(function (t) {
              throw new FetchError({
                status: e.statusText,
                headers: e.headers,
                json: t,
              });
            });
      }
      constructor(e) {
        (this.container = e.container),
          (this.drawer = null),
          (this.drawerBody = null),
          (this.buttonDrawerOpen = null),
          (this.buttonDrawerClose = null),
          (this.body = document.querySelector(selectors$d.body)),
          (this.a11y = a11y),
          this.container.addEventListener("theme:variant:change", (e) =>
            this.fetchPickupAvailability(e)
          ),
          this.closeEvent();
      }
    };
  const pickupAvailability = {
      onLoad() {
        sections$7[this.id] = new PickupAvailability(this);
      },
    },
    selectors$c = {
      complementaryProducts: "complementary-products",
      quickAddProduct: "quick-add-product",
    },
    classes$9 = {
      loaded: "is-loaded",
    },
    attributes$3 = {
      url: "data-url",
    };
  let ComplementaryProducts = class extends HTMLElement {
    connectedCallback() {
      new IntersectionObserver(
        ((e, t) => {
          e[0].isIntersecting &&
            (t.unobserve(this),
            this.hasAttribute(attributes$3.url) &&
              "" !== this.getAttribute(attributes$3.url) &&
              fetch(this.getAttribute(attributes$3.url))
                .then((e) => e.text())
                .then((e) => {
                  const t = document.createElement("div");
                  t.innerHTML = e;
                  const s = t.querySelector(selectors$c.complementaryProducts);
                  s &&
                    s.innerHTML.trim().length &&
                    (this.innerHTML = s.innerHTML),
                    t.querySelector(
                      `${selectors$c.complementaryProducts} ${selectors$c.quickAddProduct}`
                    ) && this.classList.add(classes$9.loaded);
                })
                .catch((e) => {
                  console.error(e);
                }));
        }).bind(this),
        {
          rootMargin: "0px 0px 400px 0px",
        }
      ).observe(this);
    }
    constructor() {
      super();
    }
  };
  const selectors$b = {
      slideshow: "[data-product-slideshow]",
      dataStickyEnabled: "data-sticky-enabled",
      productPage: ".product__page",
      formWrapper: "[data-form-wrapper]",
      headerSticky: "[data-header-sticky]",
      headerHeight: "[data-header-height]",
    },
    classes$8 = {
      sticky: "is-sticky",
    };
  window.theme.variables = {
    productPageSticky: !1,
  };
  const sections$6 = {};
  let ProductSticky = class {
    init() {
      this.stickyEnabled &&
        (this.stickyScrollCheck(),
        document.addEventListener("theme:resize", this.resizeEvent)),
        this.initSticky();
    }
    initSticky() {
      theme.variables.productPageSticky &&
        ((this.requestAnimationSticky = requestAnimationFrame(() =>
          this.calculateStickyPosition()
        )),
        this.formWrapper.addEventListener("theme:form:sticky", (e) => {
          this.removeAnimationFrame(),
            (this.requestAnimationSticky = requestAnimationFrame(() =>
              this.calculateStickyPosition(e)
            ));
        }),
        document.addEventListener("theme:scroll", this.scrollEvent));
    }
    scrollEvents(e) {
      (this.scrollTop = e.detail.position),
        (this.scrollDirectionDown = e.detail.down),
        this.requestAnimationSticky ||
          (this.requestAnimationSticky = requestAnimationFrame(() =>
            this.calculateStickyPosition()
          ));
    }
    resizeEvents(e) {
      this.stickyScrollCheck(),
        document.removeEventListener("theme:scroll", this.scrollEvent),
        this.initSticky();
    }
    stickyScrollCheck() {
      const e =
          (window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth) >= window.theme.sizes.small,
        t = this.container.querySelector(
          `${selectors$b.productPage} ${selectors$b.formWrapper}`
        );
      if (t)
        if (e) {
          const e = this.container.querySelector(selectors$b.formWrapper),
            s = this.container.querySelector(selectors$b.slideshow);
          if (!e || !s) return;
          e.offsetHeight < s.offsetHeight
            ? ((theme.variables.productPageSticky = !0),
              t.classList.add(classes$8.sticky))
            : ((theme.variables.productPageSticky = !1),
              t.classList.remove(classes$8.sticky));
        } else
          (theme.variables.productPageSticky = !1),
            t.classList.remove(classes$8.sticky);
    }
    calculateStickyPosition(e = null) {
      if (document.documentElement.hasAttribute("data-scroll-locked"))
        return void this.removeAnimationFrame();
      const t = Boolean(e && e.detail),
        s = Boolean(t && e.detail.element && "accordion" === e.detail.element),
        i = this.formWrapper.offsetHeight,
        o = window.innerHeight - i - this.defaultTopBottomSpacings,
        r = Math.abs(this.scrollTop - this.scrollLastPosition);
      this.scrollDirectionDown
        ? (this.stickyScrollTop -= r)
        : (this.stickyScrollTop += r),
        this.stickyFormLoad &&
          (document.querySelector(selectors$b.headerSticky) &&
          document.querySelector(selectors$b.headerHeight)
            ? (this.stickyDefaultTop = parseInt(
                document
                  .querySelector(selectors$b.headerHeight)
                  .getBoundingClientRect().height
              ))
            : (this.stickyDefaultTop = this.defaultTopBottomSpacings),
          (this.stickyScrollTop = this.stickyDefaultTop)),
        (this.stickyScrollTop = Math.min(
          Math.max(this.stickyScrollTop, o),
          this.stickyDefaultTop
        ));
      const n = this.stickyScrollTop - this.currentPoint;
      (this.currentPoint = this.stickyFormLoad
        ? this.stickyScrollTop
        : this.currentPoint + 0.5 * n),
        this.formWrapper.style.setProperty(
          "--sticky-top",
          `${this.currentPoint}px`
        ),
        (this.scrollLastPosition = this.scrollTop),
        (this.stickyFormLoad = !1),
        (s && this.onChangeCounter <= 10) ||
        (s && this.stickyFormLastHeight !== i) ||
        (this.stickyScrollTop !== this.currentPoint &&
          this.requestAnimationSticky)
          ? (s && (this.onChangeCounter += 1),
            s && this.stickyFormLastHeight !== i && (this.onChangeCounter = 11),
            (this.requestAnimationSticky = requestAnimationFrame(() =>
              this.calculateStickyPosition(e)
            )))
          : this.requestAnimationSticky && this.removeAnimationFrame(),
        (this.stickyFormLastHeight = i);
    }
    removeAnimationFrame() {
      this.requestAnimationSticky &&
        (cancelAnimationFrame(this.requestAnimationSticky),
        (this.requestAnimationSticky = null),
        (this.onChangeCounter = 0));
    }
    onUnload() {
      this.stickyEnabled &&
        document.removeEventListener("theme:resize", this.resizeEvent),
        theme.variables.productPageSticky &&
          document.removeEventListener("theme:scroll", this.scrollEvent);
    }
    constructor(e) {
      (this.section = e),
        (this.container = e.container),
        (this.stickyEnabled =
          "true" ===
          this.container.getAttribute(selectors$b.dataStickyEnabled)),
        (this.formWrapper = this.container.querySelector(
          selectors$b.formWrapper
        )),
        (this.stickyScrollTop = 0),
        (this.scrollLastPosition = 0),
        (this.stickyDefaultTop = 0),
        (this.currentPoint = 0),
        (this.defaultTopBottomSpacings = 30),
        (this.scrollTop = window.scrollY),
        (this.scrollDirectionDown = !0),
        (this.requestAnimationSticky = null),
        (this.stickyFormLoad = !0),
        (this.stickyFormLastHeight = null),
        (this.onChangeCounter = 0),
        (this.scrollEvent = (e) => this.scrollEvents(e)),
        (this.resizeEvent = (e) => this.resizeEvents(e)),
        setTimeout(() => {
          this.init();
        }, 50);
    }
  };
  const productStickySection = {
      onLoad() {
        sections$6[this.id] = new ProductSticky(this);
      },
      onUnload() {
        sections$6[this.id].onUnload();
      },
    },
    selectors$a = {
      elements: {
        accordionHolder: "[data-accordion-holder]",
        accordion: "[data-accordion]",
        accordionToggle: "[data-accordion-toggle]",
        accordionBody: "[data-accordion-body]",
        accordionExpandValue: "data-accordion-expand",
        accordionBlockValue: "data-block-id",
      },
      classes: {
        open: "is-open",
      },
    },
    sections$5 = {};
  let GlobalAccordions = class {
    accordionEvents() {
      this.accordionToggles.forEach((e) => {
        e.addEventListener(
          "click",
          throttle((t) => {
            t.preventDefault();
            const s = e.parentElement.querySelector(
              selectors$a.elements.accordionBody
            );
            s && this.onAccordionToggle(e, s);
          }, 800)
        );
      }),
        "true" ===
          this.accordion.getAttribute(
            selectors$a.elements.accordionExpandValue
          ) &&
          (this.accordionToggles[0].classList.add(selectors$a.classes.open),
          showElement(
            this.accordionToggles[0].parentElement.querySelector(
              selectors$a.elements.accordionBody
            )
          ));
    }
    closeOtherAccordions(e, t = !0) {
      let s = [...this.accordionToggles];
      const i = this.container.closest(selectors$a.elements.accordionHolder);
      i && (s = [...i.querySelectorAll(selectors$a.elements.accordionToggle)]),
        s.filter((s) => {
          const i = s.parentElement.querySelector(
            selectors$a.elements.accordionBody
          );
          s !== e &&
            s.classList.contains(selectors$a.classes.open) &&
            i &&
            this.onAccordionClose(s, i, t);
        });
    }
    onAccordionOpen(e, t, s = !0) {
      e.classList.add(selectors$a.classes.open),
        slideDown(t),
        this.closeOtherAccordions(e, s);
    }
    onAccordionClose(e, t, s = !0) {
      e.classList.remove(selectors$a.classes.open),
        s ? slideUp(t) : hideElement(t);
    }
    onAccordionToggle(e, t) {
      e.classList.toggle(selectors$a.classes.open),
        slideToggle(t),
        this.closeOtherAccordions(e),
        e.dispatchEvent(
          new CustomEvent("theme:form:sticky", {
            bubbles: !0,
            detail: {
              element: "accordion",
            },
          })
        );
    }
    onBlockToggle(e, t = !0) {
      const s = this.container.querySelector(
        `${selectors$a.elements.accordionToggle}[${selectors$a.elements.accordionBlockValue}="${e.detail.blockId}"]`
      );
      if (!s) return;
      const i = s.parentElement.querySelector(
        selectors$a.elements.accordionBody
      );
      i && (t ? this.onAccordionOpen(s, i, !1) : this.onAccordionClose(s, i));
    }
    onSelectToggle(e = !0) {
      this.accordionBody &&
        this.accordionTogglesLength &&
        this.accordionTogglesLength < 2 &&
        (e
          ? this.onAccordionOpen(
              this.accordionToggles[0],
              this.accordionBody,
              !1
            )
          : this.onAccordionClose(
              this.accordionToggles[0],
              this.accordionBody
            ));
    }
    onSelect() {
      this.onSelectToggle(!0);
    }
    onDeselect() {
      this.onSelectToggle(!1);
    }
    onBlockSelect(e) {
      this.onBlockToggle(e, !0);
    }
    onBlockDeselect(e) {
      this.onBlockToggle(e, !1);
    }
    constructor(e) {
      (this.container = e.container),
        (this.accordion = this.container.querySelector(
          selectors$a.elements.accordion
        )),
        (this.accordionToggles = this.container.querySelectorAll(
          selectors$a.elements.accordionToggle
        )),
        (this.accordionTogglesLength = this.accordionToggles.length),
        (this.accordionBody = this.container.querySelector(
          selectors$a.elements.accordionBody
        )),
        this.accordionTogglesLength &&
          this.accordionBody &&
          this.accordionEvents();
    }
  };
  const accordions = {
      onLoad() {
        sections$5[this.id] = new GlobalAccordions(this);
      },
      onSelect() {
        sections$5[this.id].onSelect();
      },
      onDeselect() {
        sections$5[this.id].onDeselect();
      },
      onBlockSelect(e) {
        sections$5[this.id].onBlockSelect(e);
      },
      onBlockDeselect(e) {
        sections$5[this.id].onBlockDeselect(e);
      },
    },
    selectors$9 = {
      section: "data-section-type",
      shareButton: "[data-share-button]",
      shareMessage: "[data-share-message]",
    },
    classes$7 = {
      visible: "is-visible",
    };
  let ShareButton = class extends HTMLElement {
    init() {
      navigator.share
        ? this.shareButton.addEventListener("click", () => {
            navigator.share({
              url: this.urlToShare,
              title: document.title,
            });
          })
        : this.shareButton.addEventListener(
            "click",
            this.copyToClipboard.bind(this)
          );
    }
    updateShareLink() {
      "product" == this.container.getAttribute(selectors$9.section) &&
        this.container.addEventListener("theme:variant:change", (e) => {
          e.detail.variant &&
            (this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${
              e.detail.variant.id
            }`);
        });
    }
    copyToClipboard() {
      navigator.clipboard.writeText(this.urlToShare).then(() => {
        this.shareMessage.classList.add(classes$7.visible);
        const e = () => {
          this.shareMessage.classList.remove(classes$7.visible),
            this.shareMessage.removeEventListener("animationend", e);
        };
        this.shareMessage.addEventListener("animationend", e);
      });
    }
    constructor() {
      super(),
        (this.container = this.closest(`[${selectors$9.section}]`)),
        (this.shareButton = this.querySelector(selectors$9.shareButton)),
        (this.shareMessage = this.querySelector(selectors$9.shareMessage)),
        (this.urlToShare = this.shareButton.dataset.shareUrl
          ? this.shareButton.dataset.shareUrl
          : document.location.href),
        this.init(),
        this.updateShareLink();
    }
  };
  const selectors$8 = {
      addToCart: "[data-add-to-cart]",
      priceWrapper: "[data-price-wrapper]",
      productImage: "[data-product-image]",
      productJson: "[data-product-json]",
      form: "[data-product-form]",
      thumbs: "[data-product-thumbs]",
      dataSectionId: "data-section-id",
      dataCartBar: "data-cart-bar",
      cartBar: "#cart-bar",
      cartBarAdd: "data-add-to-cart-bar",
      cartBarScroll: "data-cart-bar-scroll",
      productSubmitAdd: ".product__submit__add",
      templateProduct: "#template-product",
      siteFooterWrapper: ".site-footer-wrapper",
      toggleTruncateHolder: "[data-truncated-holder]",
      toggleTruncateButton: "[data-truncated-button]",
      toggleTruncateContent: "[data-truncated-content]",
      toggleTruncateContentAttr: "data-truncated-content",
      productPopupButton: "data-product-popup",
      modalScrollContainer: "[data-tabs-holder]",
      formWrapper: "[data-form-wrapper]",
      slider: "[data-slider]",
      sliderIndex: "data-slider-index",
    },
    classes$6 = {
      expanded: "is-expanded",
      visible: "is-visible",
      loading: "is-loading",
      added: "is-added",
      siteFooterPush: "site-footer--push",
      hasPopup: "has-popup",
    },
    sections$4 = {};
  let Product = class {
    init() {
      (theme.mediaInstances[this.id] = new Media(this.section)),
        theme.mediaInstances[this.id].init();
    }
    scrollEvents(e) {
      this.cartBarExist && this.cartBarScroll();
    }
    resizeEvents(e) {
      this.truncateText();
    }
    productPopup() {
      this.productPopupButton.forEach((e) => {
        e.addEventListener("click", (t) => {
          t.preventDefault();
          const s = document.querySelector(
              `#${e.getAttribute(selectors$8.productPopupButton)}`
            ),
            i = s.querySelector(selectors$8.modalScrollContainer);
          "none" !== window.getComputedStyle(s).display &&
            (fadeOut(s),
            this.formWrapper.classList.remove(classes$6.hasPopup),
            this.accessibility.removeTrapFocus(),
            this.unlockTimer && clearTimeout(this.unlockTimer),
            (this.unlockTimer = setTimeout(() => {
              document.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", {
                  bubbles: !0,
                })
              );
            }, 300))),
            "none" === window.getComputedStyle(s).display &&
              (fadeIn(s),
              this.formWrapper.classList.add(classes$6.hasPopup),
              document.dispatchEvent(
                new CustomEvent("theme:scroll:lock", {
                  bubbles: !0,
                  detail: i,
                })
              ),
              this.accessibility.trapFocus(s));
        });
      });
    }
    truncateText() {
      if (this.truncateElementHolder.classList.contains(classes$6.visible))
        return;
      const e = this.truncateElement.querySelectorAll("style");
      e.length &&
        e.forEach((e) => {
          this.truncateElementHolder.prepend(e);
        });
      const t = this.truncateElement.cloneNode(!0),
        s = this.truncateElement.getAttribute(
          selectors$8.toggleTruncateContentAttr
        ),
        i = this.truncateElement.nextElementSibling;
      i && i.remove(), this.truncateElement.parentElement.append(t);
      const o = this.truncateElement.nextElementSibling;
      o.classList.add(s),
        o.removeAttribute(selectors$8.toggleTruncateContentAttr),
        showElement(o),
        ellipsis(o, 5, {
          replaceStr: "",
          delimiter: " ",
        }),
        hideElement(o),
        this.truncateElement.innerHTML !== o.innerHTML
          ? this.truncateElementHolder.classList.add(classes$6.expanded)
          : (o.remove(),
            this.truncateElementHolder.classList.remove(classes$6.expanded)),
        this.toggleTruncatedContent(this.truncateElementHolder);
    }
    toggleTruncatedContent(e) {
      const t = e.querySelector(selectors$8.toggleTruncateButton);
      t &&
        t.addEventListener("click", (t) => {
          t.preventDefault(),
            e.classList.remove(classes$6.expanded),
            e.classList.add(classes$6.visible);
        });
    }
    initCartBar() {
      (this.cartBarBtn = this.cartBar.querySelector(
        selectors$8.productSubmitAdd
      )),
        this.cartBarBtn &&
          (this.cartBarBtn.addEventListener("click", (e) => {
            e.preventDefault(),
              e.currentTarget.hasAttribute(selectors$8.cartBarAdd)
                ? (theme.settings.cartDrawerEnabled &&
                    (e.currentTarget.classList.add(classes$6.loading),
                    e.currentTarget.setAttribute("disabled", "disabled")),
                  this.form.querySelector(selectors$8.addToCart).dispatchEvent(
                    new Event("click", {
                      bubbles: !0,
                    })
                  ))
                : e.currentTarget.hasAttribute(selectors$8.cartBarScroll) &&
                  this.scrollToTop();
          }),
          this.cartBarBtn.hasAttribute(selectors$8.cartBarAdd) &&
            document.addEventListener(
              "theme:product:add-error",
              this.scrollToTop
            ));
    }
    scrollToTop() {
      const e =
        (window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth) >= window.theme.sizes.small
          ? this.container
          : this.form;
      scrollTo(e.getBoundingClientRect().top);
    }
    cartBarScroll() {
      const e = window.pageYOffset,
        t =
          theme.variables.productPageSticky && this.formWrapper
            ? this.formWrapper
            : this.form;
      if (t && this.cartBar) {
        const s = document.querySelector(selectors$8.siteFooterWrapper),
          i = e > t.offsetTop + t.offsetHeight;
        this.cartBar.classList.toggle(classes$6.visible, i),
          s &&
            (s.classList.toggle(classes$6.siteFooterPush, i),
            (s.style.marginBottom = s.classList.contains(
              classes$6.siteFooterPush
            )
              ? `${this.cartBar.offsetHeight}px`
              : "0"));
      }
    }
    onUnload() {
      document.removeEventListener("theme:product:add-error", this.scrollToTop),
        this.truncateElementHolder &&
          this.truncateElement &&
          document.removeEventListener("theme:resize", this.resizeEvent),
        this.cartBarExist &&
          document.removeEventListener("theme:scroll", this.scrollEvent);
    }
    onBlockSelect(e) {
      const t = e.srcElement.closest(selectors$8.slider);
      if (t && this.slider.length) {
        const s = t.hasAttribute(selectors$8.sliderIndex)
          ? t.getAttribute(selectors$8.sliderIndex)
          : 0;
        if (!this.slider[s]) return;
        this.slider[s].onBlockSelect(e);
      }
    }
    onBlockDeselect(e) {
      const t = e.srcElement.closest(selectors$8.slider);
      if (t && this.slider.length) {
        const s = t.hasAttribute(selectors$8.sliderIndex)
          ? t.getAttribute(selectors$8.sliderIndex)
          : 0;
        if (!this.slider[s]) return;
        this.slider[s].onBlockDeselect(e);
      }
    }
    constructor(e) {
      (this.section = e),
        (this.container = e.container),
        (this.id = this.container.getAttribute(selectors$8.dataSectionId)),
        (this.sliders = this.container.querySelectorAll(selectors$8.slider)),
        (this.slider = []),
        (this.truncateElementHolder = this.container.querySelector(
          selectors$8.toggleTruncateHolder
        )),
        (this.truncateElement = this.container.querySelector(
          selectors$8.toggleTruncateContent
        )),
        (this.productPopupButton = this.container.querySelectorAll(
          `[${selectors$8.productPopupButton}]`
        )),
        (this.formWrapper = this.container.querySelector(
          selectors$8.formWrapper
        )),
        (this.cartBarExist =
          "true" === this.container.getAttribute(selectors$8.dataCartBar)),
        (this.cartBar = this.container.querySelector(selectors$8.cartBar)),
        (this.scrollToTop = this.scrollToTop.bind(this)),
        (this.scrollEvent = (e) => this.scrollEvents(e)),
        (this.resizeEvent = (e) => this.resizeEvents(e)),
        (this.unlockTimer = 0),
        (this.accessibility = a11y),
        this.truncateElementHolder &&
          this.truncateElement &&
          (setTimeout(() => this.truncateText(), 50),
          document.addEventListener("theme:resize", this.resizeEvent));
      const t = this.container.querySelector(selectors$8.productJson);
      if ((t && !t.innerHTML) || !t) {
        return void new QuantityCounter(this.container).init();
      }
      const s = JSON.parse(t.innerHTML).handle;
      let i = {};
      s &&
        (i = {
          handle: s,
        }),
        Shopify.Products.recordRecentlyViewed(i),
        (this.form = this.container.querySelector(selectors$8.form)),
        this.init(),
        this.sliders.length &&
          this.sliders.forEach((e, t) => {
            e.setAttribute(selectors$8.sliderIndex, t),
              this.slider.push(new Slider(this.container, e));
          }),
        this.cartBarExist &&
          (this.initCartBar(),
          document.addEventListener("theme:scroll", this.scrollEvent)),
        this.productPopupButton.length > 0 && this.productPopup();
    }
  };
  const productSection = {
    onLoad() {
      sections$4[this.id] = new Product(this);
    },
    onUnload(e) {
      sections$4[this.id].onUnload(e);
    },
    onBlockSelect(e) {
      sections$4[this.id].onBlockSelect(e);
    },
    onBlockDeselect(e) {
      sections$4[this.id].onBlockDeselect(e);
    },
  };
  register("product", [
    productSection,
    pickupAvailability,
    productFormSection,
    swatchSection,
    tooltipSection,
    popoutSection,
    tabs,
    accordions,
    productStickySection,
    initSlider,
  ]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", QuickAddProduct),
    customElements.get("complementary-products") ||
      customElements.define("complementary-products", ComplementaryProducts),
    customElements.get("share-button") ||
      customElements.define("share-button", ShareButton);
  const selectors$7 = {
      relatedSectionElem: "[data-related-section]",
      relatedProduct: "[data-product-grid-item]",
      recentlyViewed: "[data-recent-wrapper]",
      recentlyViewedWrapper: "[data-recently-viewed-wrapper]",
      recentlyProduct: "#recently-viewed-products",
      productItem: ".product-item",
      slider: "[data-slider]",
    },
    attributes$2 = {
      limit: "data-limit",
      minimum: "data-minimum",
      productId: "data-product-id",
    },
    classes$5 = {
      isHidden: "is-hidden",
    };
  let Related = class {
    init() {
      const e = this.container.querySelector(selectors$7.relatedSectionElem);
      if (!e) return;
      const t = this,
        s = e.getAttribute(attributes$2.productId),
        i = e.getAttribute(attributes$2.limit),
        o = `${window.theme.routes.product_recommendations_url}?section_id=related&limit=${i}&product_id=${s}`;
      fetch(o)
        .then(function (e) {
          return e.text();
        })
        .then(function (s) {
          const i = document.createElement("div");
          i.innerHTML = s;
          const o = i.querySelector(selectors$7.relatedSectionElem);
          if (o.querySelector(selectors$7.relatedProduct)) {
            const s = o.innerHTML;
            hideElement(e), (e.innerHTML = s), slideDown(e);
            const i = e.querySelectorAll(selectors$7.relatedProduct);
            makeGridSwatches(t.section),
              new Siblings(t.section),
              i.length > 4 &&
                e.querySelector(selectors$7.slider) &&
                new Slider(e);
          } else
            e.dispatchEvent(
              new CustomEvent("theme:tab:hide", {
                bubbles: !0,
              })
            );
        })
        .catch(function () {
          e.dispatchEvent(
            new CustomEvent("theme:tab:hide", {
              bubbles: !0,
            })
          );
        });
    }
    recent() {
      const e = this.container.querySelector(selectors$7.recentlyViewed),
        t = e ? parseInt(e.getAttribute(attributes$2.limit)) : 4;
      Shopify.Products.showRecentlyViewed({
        howManyToShow: t,
        wrapperId: `recently-viewed-products-${this.sectionId}`,
        section: this.section,
        onComplete: (e, t) => {
          const s = t.container,
            i = s.querySelector(selectors$7.recentlyViewed),
            o = s.querySelector(selectors$7.recentlyViewedWrapper),
            r = e.querySelectorAll(selectors$7.productItem),
            n = i.hasAttribute(attributes$2.minimum)
              ? parseInt(i.getAttribute(attributes$2.minimum))
              : 4,
            a = !o && r.length > 0,
            l = o && r.length >= n;
          (a || l) &&
            (l && o.classList.remove(classes$5.isHidden),
            fadeIn(i),
            i.dispatchEvent(
              new CustomEvent("theme:tab:check", {
                bubbles: !0,
              })
            ),
            makeGridSwatches(t),
            new Siblings(t),
            r.length > 4 &&
              i.querySelector(selectors$7.slider) &&
              new Slider(i));
        },
      });
    }
    constructor(e) {
      (this.section = e),
        (this.sectionId = e.id),
        (this.container = e.container),
        this.init(),
        this.recent();
    }
  };
  const relatedSection = {
    onLoad() {
      this.section = new Related(this);
    },
  };
  register("related", [relatedSection, popoutSection, tabs]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", QuickAddProduct),
    register("reviews", [accordions, slider, blockScroll]);
  const sections$3 = {},
    selectors$6 = {
      sliderLogos: "[data-slider-logos]",
      sliderText: "[data-slider-text]",
      slide: "[data-slide]",
      slideIndex: "[data-slide-index]",
    },
    classes$4 = {
      isSelected: "is-selected",
      flickityEnabled: "flickity-enabled",
    },
    attributes$1 = {
      slideData: "data-slide",
      slideIndex: "data-slide-index",
    };
  let LogoList = class {
    initSlideshowText() {
      if (!this.slideshowText) return;
      this.flkty = new FlickityFade(this.slideshowText, {
        fade: !0,
        autoPlay: !1,
        prevNextButtons: !1,
        cellAlign: "left",
        contain: !0,
        pageDots: !1,
        wrapAround: !1,
        selectedAttraction: 0.2,
        friction: 0.6,
        draggable: !1,
        accessibility: !1,
        on: {
          ready: () => this.sliderAccessibility(),
          change: () => this.sliderAccessibility(),
        },
      });
      const e = this.slideshowText.querySelectorAll(selectors$6.slide);
      if (e.length) {
        let t = -1;
        e.forEach((e) => {
          const s = parseFloat(
            getComputedStyle(e, null).height.replace("px", "")
          );
          s > t && (t = s);
        }),
          e.forEach((e) => {
            const s = parseFloat(
              getComputedStyle(e, null).height.replace("px", "")
            );
            if (s < t) {
              const i = Math.ceil((t - s) / 2);
              e.style.margin = `${i}px 0`;
            }
          });
      }
    }
    sliderAccessibility() {
      const e = this.slideshowText.querySelectorAll(
        `${selectors$6.slide} a, ${selectors$6.slide} button`
      );
      e.length &&
        e.forEach((e) => {
          const t = e.closest(selectors$6.slide);
          if (t) {
            const s = t.classList.contains(classes$4.isSelected) ? 0 : -1;
            e.setAttribute("tabindex", s);
          }
        });
    }
    initSlideshowNav() {
      this.slideshowNav &&
        ((this.logoSlides = this.slideshowNav.querySelectorAll(
          selectors$6.slideIndex
        )),
        this.logoSlides.length &&
          this.logoSlides.forEach((e) => {
            e.addEventListener("click", (t) => {
              t.preventDefault();
              const s = parseInt(e.getAttribute(attributes$1.slideIndex)),
                i = this.slideshowNav.classList.contains(
                  classes$4.flickityEnabled
                );
              if ((this.flkty && this.flkty.select(s), i))
                this.flktyNav.select(s),
                  this.slideshowNav.classList.contains(classes$4.isSelected) ||
                    this.flktyNav.playPlayer();
              else {
                const t = this.slideshowNav.querySelector(
                  `.${classes$4.isSelected}`
                );
                t && t.classList.remove(classes$4.isSelected),
                  e.classList.add(classes$4.isSelected);
              }
            });
          }),
        this.setSlideshowNavState(),
        document.addEventListener(
          "theme:resize",
          this.setSlideshowNavStateOnResize
        ));
    }
    setSlideshowNavState() {
      const e = this.slideshowNav.querySelectorAll(selectors$6.slide),
        t = e.length,
        s =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth,
        i = 200 * t,
        o = this.slideshowNav.classList.contains(classes$4.flickityEnabled);
      if (i > s) {
        if (!o) {
          const t = this.slideshowNav.querySelector(`.${classes$4.isSelected}`);
          t && t.classList.remove(classes$4.isSelected),
            e[0].classList.add(classes$4.isSelected),
            (this.flktyNav = new Flickity(this.slideshowNav, {
              autoPlay: 4e3,
              prevNextButtons: !1,
              contain: !1,
              pageDots: !1,
              wrapAround: !0,
              watchCSS: !0,
              selectedAttraction: 0.05,
              friction: 0.8,
              initialIndex: 0,
            })),
            this.flkty &&
              (this.flkty.select(0),
              this.flktyNav.on("change", (e) => this.flkty.select(e)));
        }
      } else
        o &&
          (this.flktyNav.destroy(),
          e[0].classList.add(classes$4.isSelected),
          this.flkty && this.flkty.select(0));
    }
    onBlockSelect(e) {
      if (!this.slideshowNav) return;
      const t = this.slideshowNav.querySelector(
          `[${attributes$1.slideData}="${e.detail.blockId}"]`
        ),
        s = parseInt(t.getAttribute(attributes$1.slideIndex));
      this.slideshowNav.classList.contains(classes$4.flickityEnabled)
        ? (this.flktyNav.select(s),
          this.flktyNav.stopPlayer(),
          this.slideshowNav.classList.add(classes$4.isSelected))
        : t.dispatchEvent(new Event("click"));
    }
    onBlockDeselect() {
      this.slideshowNav &&
        this.slideshowNav.classList.contains(classes$4.flickityEnabled) &&
        (this.flktyNav.playPlayer(),
        this.slideshowNav.classList.remove(classes$4.isSelected));
    }
    onUnload() {
      if (!this.slideshowNav) return;
      this.slideshowNav.classList.contains(classes$4.flickityEnabled) &&
        this.flktyNav.destroy(),
        this.flkty && this.flkty.destroy(),
        document.removeEventListener(
          "theme:resize",
          this.setSlideshowNavStateOnResize
        );
    }
    constructor(e) {
      (this.container = e.container),
        (this.slideshowNav = this.container.querySelector(
          selectors$6.sliderLogos
        )),
        (this.slideshowText = this.container.querySelector(
          selectors$6.sliderText
        )),
        (this.setSlideshowNavStateOnResize = () => this.setSlideshowNavState()),
        (this.flkty = null),
        (this.flktyNav = null),
        this.initSlideshowText(),
        this.initSlideshowNav();
    }
  };
  const LogoListSection = {
    onLoad() {
      sections$3[this.id] = new LogoList(this);
    },
    onUnload(e) {
      sections$3[this.id].onUnload(e);
    },
    onBlockSelect(e) {
      sections$3[this.id].onBlockSelect(e);
    },
    onBlockDeselect(e) {
      sections$3[this.id].onBlockDeselect(e);
    },
  };
  register("logos", [LogoListSection, blockScroll]);
  const selectors$5 = {
    videoPlay: "[data-video-play]",
    videoPlayValue: "data-video-play",
  };
  let VideoPlay = class {
    constructor(e, t = selectors$5.videoPlay, s = selectors$5.videoPlayValue) {
      (this.container = e),
        (this.videoPlay = this.container.querySelectorAll(t)),
        this.videoPlay.length &&
          this.videoPlay.forEach((e) => {
            e.addEventListener("click", (e) => {
              const t = e.currentTarget;
              if (t.hasAttribute(s) && "" !== t.getAttribute(s).trim()) {
                e.preventDefault();
                const i = [
                  {
                    html: t.getAttribute(s),
                  },
                ];
                new LoadPhotoswipe(i), (window.accessibility.lastElement = t);
              }
            });
          });
    }
  };
  const videoPlay = {
      onLoad() {
        new VideoPlay(this.container);
      },
    },
    selectors$4 = {
      videoId: "[data-video-id]",
      videoPlayer: "[data-video-player]",
      videoTemplate: "[data-video-template]",
    },
    classes$3 = {
      loading: "is-loading",
    };
  let VideoBackground = class {
    init() {
      if (this.videoId) {
        this.container.addEventListener(
          "touchstart",
          () => {
            this.video.play();
          },
          {
            passive: !0,
          }
        );
        new IntersectionObserver(
          (e, t) => {
            e.forEach((e) => {
              if (e.isIntersecting) {
                const s = this.videoTemplate.content;
                this.videoTemplate.replaceWith(s),
                  this.videoPlayer.classList.remove(classes$3.loading),
                  t.unobserve(e.target);
              }
            });
          },
          {
            root: null,
            rootMargin: "300px",
            threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
          }
        ).observe(this.videoPlayer);
      }
    }
    constructor(e) {
      (this.container = e),
        (this.videoId = this.container.querySelector(selectors$4.videoId)),
        (this.videoPlayer = this.container.querySelector(
          selectors$4.videoPlayer
        )),
        (this.videoTemplate = this.container.querySelector(
          selectors$4.videoTemplate
        )),
        this.init();
    }
  };
  const videoBackground = {
    onLoad() {
      new VideoBackground(this.container);
    },
  };
  register("featured-video", [videoPlay, videoBackground, parallaxHero]),
    register("slideshow", [slider, parallaxHero]);
  const selectors$3 = {
      imagesHolder: "[data-images-holder]",
      imageHolder: "[data-image-holder]",
      imageElement: "[data-image-element]",
      imagesButton: "[data-images-button]",
      dataStartPosition: "data-start-position",
    },
    sections$2 = {};
  let CompareImages = class {
    init() {
      this.changeValues(),
        this.imagesButton.addEventListener("mousedown", this.onStartEvent),
        this.imagesButton.addEventListener("touchstart", this.onStartEvent);
    }
    changeValues(e) {
      const t = this.imagesHolder.offsetWidth,
        s = this.imagesButton.offsetWidth;
      if (
        (!e || (e && "touchmove" !== e.type && "mousemove" !== e.type)) &&
        ((this.imageElement.style.width = `${t}px`),
        (this.imageHolder.style.width =
          100 - parseInt(this.startPosition) + "%"),
        0 !== this.startPosition)
      ) {
        const e = (t * parseInt(this.startPosition)) / 100;
        this.x = e - s / 2;
      }
      this.x > t - s ? (this.x = t - s) : this.x < 0 && (this.x = 0),
        (this.imagesButton.style.left = (this.x / t) * 100 + "%"),
        (this.imageHolder.style.width =
          100 - ((this.x + s / 2) / t) * 100 + "%");
    }
    onStart(e) {
      e.preventDefault();
      let t = e;
      e.touches && (t = e.touches[0]),
        (this.x = this.imagesButton.offsetLeft),
        (this.startX = t.pageX - this.x),
        this.imagesHolder.addEventListener("mousemove", this.onMoveEvent),
        this.imagesHolder.addEventListener("mouseup", this.onStopEvent),
        this.imagesHolder.addEventListener("touchmove", this.onMoveEvent),
        this.imagesHolder.addEventListener("touchend", this.onStopEvent);
    }
    onMove(e) {
      let t = e;
      e.touches && (t = e.touches[0]),
        (this.x = t.pageX - this.startX),
        this.changeValues(e);
    }
    onStop(e) {
      this.imagesHolder.removeEventListener("mousemove", this.onMoveEvent),
        this.imagesHolder.removeEventListener("mouseup", this.onStopEvent),
        this.imagesHolder.removeEventListener("touchmove", this.onMoveEvent),
        this.imagesHolder.removeEventListener("touchend", this.onStopEvent);
    }
    onUnload() {
      this.changeValuesEvent &&
        document.removeEventListener("theme:resize", this.changeValuesEvent);
    }
    constructor(e) {
      (this.imagesHolder = e),
        this.imagesHolder &&
          ((this.imageHolder = this.imagesHolder.querySelector(
            selectors$3.imageHolder
          )),
          (this.imageElement = this.imagesHolder.querySelector(
            selectors$3.imageElement
          )),
          (this.imagesButton = this.imagesHolder.querySelector(
            selectors$3.imagesButton
          )),
          (this.startPosition = this.imagesHolder.hasAttribute(
            selectors$3.dataStartPosition
          )
            ? this.imagesHolder.getAttribute(selectors$3.dataStartPosition)
            : 0),
          (this.startX = 0),
          (this.x = 0),
          (this.changeValuesEvent = (e) => this.changeValues(e)),
          (this.onMoveEvent = (e) => this.onMove(e)),
          (this.onStopEvent = (e) => this.onStop(e)),
          (this.onStartEvent = (e) => this.onStart(e)),
          this.init(),
          document.addEventListener("theme:resize", this.changeValuesEvent));
    }
  };
  const compareImages = {
    onLoad() {
      sections$2[this.id] = [];
      this.container.querySelectorAll(selectors$3.imagesHolder).forEach((e) => {
        sections$2[this.id].push(new CompareImages(e));
      });
    },
    onUnload() {
      sections$2[this.id].forEach((e) => {
        "function" == typeof e.onUnload && e.onUnload();
      });
    },
  };
  register("custom-content", [
    slider,
    videoPlay,
    videoBackground,
    parallaxHero,
    swatchGridSection,
    compareImages,
    newsletterCheckForResultSection,
    siblings,
  ]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", QuickAddProduct);
  var styles = {};

  function mapStyle(e) {
    return styles[e];
  }
  (styles.basic = []),
    (styles.light = [
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          {
            visibility: "simplified",
          },
          {
            lightness: "64",
          },
          {
            hue: "#ff0000",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#bdbdbd",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [
          {
            color: "#f0f0f0",
          },
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [
          {
            lightness: "100",
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "all",
        stylers: [
          {
            visibility: "on",
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [
          {
            saturation: "-41",
          },
          {
            color: "#e8ede7",
          },
        ],
      },
      {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [
          {
            saturation: "-100",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          {
            lightness: "25",
          },
          {
            gamma: "1.06",
          },
          {
            saturation: "-100",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
          {
            gamma: "10.00",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
          {
            weight: "0.01",
          },
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [
          {
            weight: "0.8",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [
          {
            gamma: "10.00",
          },
          {
            lightness: "100",
          },
          {
            weight: "0.4",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          {
            visibility: "simplified",
          },
          {
            weight: "0.01",
          },
          {
            lightness: "39",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [
          {
            weight: "0.50",
          },
          {
            gamma: "10.00",
          },
          {
            lightness: "100",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [
          {
            color: "#cfe5ee",
          },
          {
            visibility: "on",
          },
        ],
      },
    ]),
    (styles.white_label = [
      {
        featureType: "all",
        elementType: "all",
        stylers: [
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "all",
        elementType: "labels",
        stylers: [
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          {
            gamma: "3.86",
          },
          {
            lightness: "100",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#cccccc",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [
          {
            color: "#f2f2f2",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [
          {
            saturation: -100,
          },
          {
            lightness: 45,
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
          {
            weight: "0.8",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
          {
            weight: "0.8",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [
          {
            weight: "0.8",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [
          {
            weight: "0",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [
          {
            color: "#e4e4e4",
          },
          {
            visibility: "on",
          },
        ],
      },
    ]),
    (styles.dark_label = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [
          {
            saturation: 36,
          },
          {
            color: "#000000",
          },
          {
            lightness: 40,
          },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#000000",
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 17,
          },
          {
            weight: 1.2,
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          {
            visibility: "simplified",
          },
          {
            lightness: "-82",
          },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [
          {
            invert_lightness: !0,
          },
          {
            weight: "7.15",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 20,
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 21,
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 17,
          },
          {
            weight: "0.8",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 29,
          },
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 18,
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 16,
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [
          {
            weight: "0.01",
          },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 19,
          },
        ],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [
          {
            color: "#000000",
          },
          {
            lightness: 17,
          },
        ],
      },
    ]),
    (window.theme.allMaps = window.theme.allMaps || {});
  let allMaps = window.theme.allMaps;
  window.theme.mapAPI = window.theme.mapAPI || null;
  let Map = class {
    initMaps() {
      loadAPI(this.key)
        .then(() =>
          "true" === this.enableCorrection &&
          "" !== this.lat &&
          "" !== this.long
            ? new google.maps.LatLng(this.lat, this.long)
            : geocodeAddressPromise(this.address)
        )
        .then((e) => {
          const t = {
            zoom: parseInt(this.zoomString, 10),
            styles: mapStyle(this.styleString),
            center: e,
            draggable: !0,
            clickableIcons: !1,
            scrollwheel: !1,
            zoomControl: !1,
            disableDefaultUI: !0,
          };
          return createMap(this.mapContainer, t);
        })
        .then((e) => {
          (this.map = e), (allMaps[this.id] = e);
        })
        .catch((e) => {
          console.log("Failed to load Google Map"), console.log(e);
        });
    }
    unload() {
      void 0 !== window.google &&
        google.maps.event.clearListeners(this.map, "resize");
    }
    constructor(e) {
      (this.container = e.container),
        (this.mapContainer = this.container.querySelector(
          "[data-map-container]"
        )),
        (this.key = this.container.getAttribute("data-api-key")),
        (this.styleString = this.container.getAttribute("data-style") || ""),
        (this.zoomString = this.container.getAttribute("data-zoom") || 14),
        (this.address = this.container.getAttribute("data-address")),
        (this.enableCorrection = this.container.getAttribute(
          "data-latlong-correction"
        )),
        (this.lat = this.container.getAttribute("data-lat")),
        (this.long = this.container.getAttribute("data-long")),
        this.key && this.initMaps();
    }
  };
  const mapSection = {
    onLoad() {
      allMaps[this.id] = new Map(this);
    },
    onUnload() {
      "function" == typeof allMaps[this.id].unload && allMaps[this.id].unload();
    },
  };

  function loadAPI(e) {
    if (null === window.theme.mapAPI) {
      const t = `https://maps.googleapis.com/maps/api/js?key=${e}`;
      window.theme.mapAPI = loadScript({
        url: t,
      });
    }
    return window.theme.mapAPI;
  }

  function createMap(e, t) {
    var s = new google.maps.Map(e, t),
      i = s.getCenter();
    return (
      new google.maps.Marker({
        map: s,
        position: i,
      }),
      google.maps.event.addDomListener(window, "resize", function () {
        google.maps.event.trigger(s, "resize"), s.setCenter(i);
      }),
      s
    );
  }

  function geocodeAddressPromise(e) {
    return new Promise((t, s) => {
      new google.maps.Geocoder().geocode(
        {
          address: e,
        },
        function (e, i) {
          if ("OK" == i) {
            var o = {
              lat: e[0].geometry.location.lat(),
              lng: e[0].geometry.location.lng(),
            };
            t(o);
          } else s(i);
        }
      );
    });
  }
  register("map", mapSection),
    register("search", [swatchGridSection, siblings]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", QuickAddProduct);
  const selectors$2 = {
      largePromo: "[data-large-promo]",
      largePromoInner: "[data-large-promo-inner]",
      trackingInner: "[data-tracking-consent-inner]",
      tracking: "[data-tracking-consent]",
      trackingAccept: "[data-confirm-cookies]",
      close: "[data-close-modal]",
      modalUnderlay: "[data-modal-underlay]",
      modalBody: "[data-modal-body]",
      newsletterPopup: "[data-newsletter]",
      newsletterPopupHolder: "[data-newsletter-holder]",
      newsletterClose: "[data-newsletter-close]",
      newsletterHeading: "[data-newsletter-heading]",
      newsletterField: "[data-newsletter-field]",
      promoPopup: "[data-promo-text]",
      newsletterForm: "[data-newsletter-form]",
      delayAttribite: "data-popup-delay",
      cookieNameAttribute: "data-cookie-name",
      dataTargetReferrer: "data-target-referrer",
    },
    classes$2 = {
      hide: "hide",
      hasValue: "has-value",
      success: "has-success",
      selected: "selected",
      hasBlockSelected: "has-block-selected",
      mobile: "mobile",
      desktop: "desktop",
    },
    attributes = {
      enable: "data-enable",
    };
  let sections$1 = {},
    DelayShow = class {
      always() {
        fadeIn(this.element, null, this.callback);
      }
      delayed(e = 10) {
        setTimeout(() => {
          fadeIn(this.element, null, this.callback);
        }, 1e3 * e);
      }
      idle() {
        let e = 0;
        const t = [
            "mousemove",
            "mousedown",
            "click",
            "touchmove",
            "touchstart",
            "touchend",
            "keydown",
            "keypress",
          ],
          s = ["load", "resize", "scroll"],
          i = () => {
            (e = setTimeout(() => {
              (e = 0), fadeIn(this.element, null, this.callback);
            }, 6e4)),
              t.forEach((e) => {
                document.addEventListener(e, o);
              }),
              s.forEach((e) => {
                window.addEventListener(e, o);
              });
          },
          o = () => {
            e && clearTimeout(e),
              t.forEach((e) => {
                document.removeEventListener(e, o);
              }),
              s.forEach((e) => {
                window.removeEventListener(e, o);
              }),
              i();
          };
        i();
      }
      bottom() {
        document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
      }
      showPopupOnScroll() {
        window.scrollY + window.innerHeight >= document.body.clientHeight &&
          (fadeIn(this.element, null, this.callback),
          document.removeEventListener(
            "theme:scroll",
            this.showPopupOnScrollEvent
          ));
      }
      onUnload() {
        document.removeEventListener(
          "theme:scroll",
          this.showPopupOnScrollEvent
        );
      }
      constructor(e, t, s = null) {
        if (
          ((this.element = t),
          (this.delay = e.getAttribute(selectors$2.delayAttribite)),
          (this.isSubmitted =
            -1 !== window.location.href.indexOf("accepts_marketing") ||
            -1 !== window.location.href.indexOf("customer_posted=true")),
          (this.callback = s),
          (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
          ("always" === this.delay || this.isSubmitted) && this.always(),
          this.delay && this.delay.includes("delayed") && !this.isSubmitted)
        ) {
          const e = this.delay.includes("_")
            ? parseInt(this.delay.split("_")[1])
            : 10;
          this.delayed(e);
        }
        "bottom" !== this.delay || this.isSubmitted || this.bottom(),
          "idle" !== this.delay || this.isSubmitted || this.idle();
      }
    },
    TargetReferrer = class {
      init() {
        -1 !==
          this.locationPath.indexOf(
            this.el.getAttribute(selectors$2.dataTargetReferrer)
          ) ||
          window.Shopify.designMode ||
          this.el.parentNode.removeChild(this.el);
      }
      constructor(e) {
        if (
          ((this.el = e),
          (this.locationPath = location.href),
          !this.el.hasAttribute(selectors$2.dataTargetReferrer))
        )
          return !1;
        this.init();
      }
    },
    LargePopup = class {
      init() {
        const e = !1 !== this.cookie.read(),
          t = this.popup.classList.contains(classes$2.mobile),
          s = this.popup.classList.contains(classes$2.desktop);
        let i = !0;
        ((t && window.innerWidth >= theme.sizes.small) ||
          (s && window.innerWidth < theme.sizes.small)) &&
          (i = !1),
          i
            ? (e && !window.Shopify.designMode) ||
              (window.Shopify.designMode ||
                new DelayShow(this.popup, this.modal, () => this.scrollLock()),
              this.form &&
                this.form.classList.contains(classes$2.success) &&
                this.checkForSuccess(),
              this.initClosers())
            : this.scrollUnlock();
      }
      checkForSuccess() {
        fadeIn(this.modal, null, () => this.scrollLock()), this.cookie.write();
      }
      initClosers() {
        this.close.addEventListener("click", this.closeModal.bind(this)),
          this.underlay.addEventListener("click", this.closeModal.bind(this));
      }
      closeModal(e) {
        e.preventDefault(),
          fadeOut(this.modal),
          this.cookie.write(),
          this.scrollUnlock();
      }
      scrollLock() {
        "none" !== window.getComputedStyle(this.popup).display &&
          (this.a11y.trapFocus(this.modal),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", {
              bubbles: !0,
              detail: this.modalBody,
            })
          ));
      }
      scrollUnlock() {
        this.a11y.removeTrapFocus(),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", {
              bubbles: !0,
            })
          );
      }
      onBlockSelect(e) {
        this.popup.contains(e.target) &&
          (fadeIn(this.modal, null, () => this.scrollLock()),
          this.popup.classList.add(classes$2.selected),
          this.popup.parentNode.classList.add(classes$2.hasBlockSelected));
      }
      onBlockDeselect(e) {
        this.popup.contains(e.target) &&
          (fadeOut(this.modal),
          this.scrollUnlock(),
          this.popup.classList.remove(classes$2.selected),
          this.popup.parentNode.classList.remove(classes$2.hasBlockSelected));
      }
      constructor(e) {
        (this.popup = e),
          (this.modal = this.popup.querySelector(selectors$2.largePromoInner)),
          (this.modalBody = this.popup.querySelector(selectors$2.modalBody)),
          (this.close = this.popup.querySelector(selectors$2.close)),
          (this.underlay = this.popup.querySelector(selectors$2.modalUnderlay)),
          (this.form = this.popup.querySelector(selectors$2.newsletterForm)),
          (this.cookie = new PopupCookie(
            this.popup.getAttribute(selectors$2.cookieNameAttribute),
            "user_has_closed"
          )),
          (this.isTargeted = new TargetReferrer(this.popup)),
          (this.a11y = a11y),
          this.init();
      }
    },
    Tracking = class {
      init() {
        this.showPopup && fadeIn(this.modal), this.clickEvents();
      }
      clickEvents() {
        this.acceptButton.addEventListener("click", (e) => {
          e.preventDefault(),
            window.Shopify.customerPrivacy.setTrackingConsent(!0, () =>
              fadeOut(this.modal)
            ),
            document.documentElement.style.setProperty(
              "--cookie-bar-height",
              "0px"
            );
        }),
          document.addEventListener("trackingConsentAccepted", () => {});
      }
      onBlockSelect(e) {
        this.popup.contains(e.target) &&
          this.showPopup &&
          (fadeIn(this.modal),
          this.popup.classList.add(classes$2.selected),
          this.popup.parentNode.classList.add(classes$2.hasBlockSelected));
      }
      onBlockDeselect(e) {
        this.popup.contains(e.target) &&
          (fadeOut(this.modal),
          this.popup.classList.remove(classes$2.selected),
          this.popup.parentNode.classList.remove(classes$2.hasBlockSelected));
      }
      constructor(e) {
        (this.popup = e),
          (this.modal = document.querySelector(selectors$2.tracking)),
          (this.acceptButton = this.modal.querySelector(
            selectors$2.trackingAccept
          )),
          (this.enable = "true" === this.modal.getAttribute(attributes.enable)),
          (this.showPopup = !1),
          window.Shopify.loadFeatures(
            [
              {
                name: "consent-tracking-api",
                version: "0.1",
              },
            ],
            (e) => {
              if (e) throw e;
              const t = window.Shopify.customerPrivacy.userCanBeTracked(),
                s = window.Shopify.customerPrivacy.getTrackingConsent();
              (this.showPopup = !t && "no_interaction" === s && this.enable),
                window.Shopify.designMode && (this.showPopup = !0),
                this.init();
            }
          );
      }
    },
    PromoText = class {
      init() {
        (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
          (window.Shopify.designMode
            ? fadeIn(this.popup)
            : new DelayShow(this.popup, this.popup),
          this.clickEvents());
      }
      clickEvents() {
        this.close.addEventListener("click", (e) => {
          e.preventDefault(), fadeOut(this.popup), this.cookie.write();
        });
      }
      onBlockSelect(e) {
        this.popup.contains(e.target) &&
          (fadeIn(this.popup),
          this.popup.classList.add(classes$2.selected),
          this.popup.parentNode.classList.add(classes$2.hasBlockSelected));
      }
      onBlockDeselect(e) {
        this.popup.contains(e.target) &&
          (fadeOut(this.popup),
          this.popup.classList.remove(classes$2.selected),
          this.popup.parentNode.classList.remove(classes$2.hasBlockSelected));
      }
      constructor(e) {
        (this.popup = e),
          (this.close = this.popup.querySelector(selectors$2.close)),
          (this.cookie = new PopupCookie(
            this.popup.getAttribute(selectors$2.cookieNameAttribute),
            "user_has_closed"
          )),
          (this.isTargeted = new TargetReferrer(this.popup)),
          this.init();
      }
    },
    NewsletterPopup = class {
      init() {
        const e = !1 !== this.cookie.read();
        -1 !== window.location.search.indexOf("?customer_posted=true") &&
          (this.delay = 0),
          (e && !window.Shopify.designMode) ||
            (this.show(),
            this.form.classList.contains(classes$2.success) &&
              this.checkForSuccess());
      }
      show() {
        window.Shopify.designMode
          ? fadeIn(this.holder)
          : new DelayShow(this.popup, this.holder),
          this.showForm(),
          this.inputField(),
          this.closePopup();
      }
      checkForSuccess() {
        fadeIn(this.holder), this.cookie.write();
      }
      showForm() {
        this.heading.addEventListener("click", (e) => {
          e.preventDefault(),
            this.heading.classList.add(classes$2.hide),
            this.form.classList.remove(classes$2.hide),
            this.newsletterField.focus();
        }),
          this.heading.addEventListener("keyup", (e) => {
            e.code === window.theme.keyboardKeys.ENTER &&
              this.heading.dispatchEvent(new Event("click"));
          });
      }
      closePopup() {
        this.close.addEventListener("click", (e) => {
          e.preventDefault(), fadeOut(this.holder), this.cookie.write();
        });
      }
      inputField() {
        const e = () => {
          this.resetClassTimer && clearTimeout(this.resetClassTimer),
            "" !== this.newsletterField.value &&
              this.holder.classList.add(classes$2.hasValue);
        };
        this.newsletterField.addEventListener("input", e),
          this.newsletterField.addEventListener("focus", e),
          this.newsletterField.addEventListener("focusout", () => {
            this.resetClassTimer && clearTimeout(this.resetClassTimer),
              (this.resetClassTimer = setTimeout(() => {
                this.holder.classList.remove(classes$2.hasValue);
              }, 2e3));
          });
      }
      onBlockSelect(e) {
        this.popup.contains(e.target) &&
          (fadeIn(this.holder),
          this.popup.classList.add(classes$2.selected),
          this.popup.parentNode.classList.add(classes$2.hasBlockSelected));
      }
      onBlockDeselect(e) {
        this.popup.contains(e.target) &&
          (fadeOut(this.holder),
          this.popup.classList.remove(classes$2.selected),
          this.popup.parentNode.classList.remove(classes$2.hasBlockSelected));
      }
      constructor(e) {
        (this.popup = e),
          (this.holder = this.popup.querySelector(
            selectors$2.newsletterPopupHolder
          )),
          (this.close = this.popup.querySelector(selectors$2.newsletterClose)),
          (this.heading = this.popup.querySelector(
            selectors$2.newsletterHeading
          )),
          (this.newsletterField = this.popup.querySelector(
            selectors$2.newsletterField
          )),
          (this.cookie = new PopupCookie(
            this.popup.getAttribute(selectors$2.cookieNameAttribute),
            "newsletter_is_closed"
          )),
          (this.form = this.popup.querySelector(selectors$2.newsletterForm)),
          (this.isTargeted = new TargetReferrer(this.popup)),
          (this.resetClassTimer = 0),
          this.init();
      }
    };
  const popupSection = {
    onLoad() {
      sections$1[this.id] = [];
      this.container.querySelectorAll(selectors$2.largePromo).forEach((e) => {
        sections$1[this.id].push(new LargePopup(e));
      });
      this.container.querySelectorAll(selectors$2.tracking).forEach((e) => {
        sections$1[this.id].push(new Tracking(e));
      });
      this.container
        .querySelectorAll(selectors$2.newsletterPopup)
        .forEach((e) => {
          sections$1[this.id].push(new NewsletterPopup(e));
        });
      this.container.querySelectorAll(selectors$2.promoPopup).forEach((e) => {
        sections$1[this.id].push(new PromoText(e));
      });
    },
    onBlockSelect(e) {
      sections$1[this.id].forEach((t) => {
        "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
      });
    },
    onBlockDeselect(e) {
      sections$1[this.id].forEach((t) => {
        "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
      });
    },
  };
  register("popups", [popupSection, newsletterCheckForResultSection]);
  const selectors$1 = {
      passwordLogin: "[data-password-login]",
      passwordModal: "[data-password-modal]",
      modalBody: "[data-modal-body]",
      close: "[data-modal-close]",
      loginErrors: "#login_form .errors",
    },
    classes$1 = {
      open: "is-open",
    };
  let Password = class {
    init() {
      this.passwordLogin.length &&
        this.modal &&
        this.modalBody &&
        (this.passwordLogin.forEach((e) => {
          e.addEventListener("click", (e) => {
            e.preventDefault(), this.openModal();
          });
        }),
        this.closeButtons.length &&
          this.closeButtons.forEach((e) => {
            e.addEventListener("click", (e) => {
              e.preventDefault(), this.closeModal();
            });
          }),
        this.loginErrors && this.openModal());
    }
    openModal() {
      fadeIn(this.modal, "block", () => {
        this.modal.classList.add(classes$1.open);
      }),
        this.scrollLock();
    }
    closeModal() {
      fadeOut(this.modal),
        this.modal.classList.remove(classes$1.open),
        this.scrollUnlock();
    }
    scrollLock() {
      "none" !== window.getComputedStyle(this.modal).display &&
        (this.a11y.trapFocus(this.modal),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.modalBody,
          })
        ));
    }
    scrollUnlock() {
      this.a11y.removeTrapFocus(),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", {
            bubbles: !0,
          })
        );
    }
    constructor(e) {
      (this.container = e.container),
        (this.passwordLogin = this.container.querySelectorAll(
          selectors$1.passwordLogin
        )),
        (this.modal = this.container.querySelector(selectors$1.passwordModal)),
        (this.modalBody = this.container.querySelector(selectors$1.modalBody)),
        (this.closeButtons = this.container.querySelectorAll(
          selectors$1.close
        )),
        (this.a11y = a11y),
        (this.loginErrors = this.container.querySelector(
          selectors$1.loginErrors
        )),
        this.init();
    }
  };
  const passwordSection = {
    onLoad() {
      new Password(this);
    },
  };
  register("password-template", passwordSection),
    register("faq", accordions),
    register("list-collections", [
      slider,
      swatchGridSection,
      blockScroll,
      siblings,
    ]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", QuickAddProduct),
    register("columns", [blockScroll]),
    register("newsletter", newsletterCheckForResultSection),
    register("before-after", [compareImages]);
  const selectors = {
      headerSticky: "[data-header-sticky]",
      headerHeight: "[data-header-height]",
      scrollToElement: "[data-scroll-to]",
      scrollToElementValue: "data-scroll-to",
      scrollToLinks: "[data-scroll-to-links]",
      scrollSpy: "[data-scroll-spy]",
      accordionHolder: "[data-accordion-holder]",
      accordionToggle: "[data-accordion-toggle]",
      tooltip: "[data-tooltip]",
      tooltipStopMousenterValue: "data-tooltip-stop-mouseenter",
    },
    classes = {
      open: "is-open",
      selected: "is-selected",
    },
    sections = {};
  let ScrollToElement = class {
    init() {
      this.scrollToButtons.forEach((e) => {
        e.addEventListener("click", (t) => {
          t.preventDefault();
          const s = document.querySelector(
            e.getAttribute(selectors.scrollToElementValue)
          );
          if (!s) return;
          const i = s.querySelector(selectors.accordionToggle);
          let o = !1;
          const r = e.closest(selectors.scrollToLinks);
          if (r && !e.closest(selectors.scrollSpy)) {
            const t = r.querySelectorAll(`.${classes.selected}`);
            t.length &&
              t.forEach((e) => {
                e.classList.remove(classes.selected);
              }),
              e.classList.add(classes.selected);
          }
          if (i) {
            const e = i.closest(selectors.accordionHolder);
            !i.classList.contains(classes.open) &&
              e &&
              e.querySelector(`${selectors.accordionToggle}.${classes.open}`) &&
              (o = !0),
              i.classList.contains(classes.open) ||
                i.dispatchEvent(new Event("click"));
          }
          o
            ? setTimeout(() => this.scrollToElement(s), 500)
            : this.scrollToElement(s);
        });
      });
    }
    scrollToElement(e) {
      scrollTo(e.getBoundingClientRect().top);
      const t = document.querySelectorAll(
        `${selectors.tooltip}:not([${selectors.tooltipStopMousenterValue}])`
      );
      t.length &&
        t.forEach((e) => {
          e.setAttribute(selectors.tooltipStopMousenterValue, ""),
            setTimeout(() => {
              e.removeAttribute(selectors.tooltipStopMousenterValue);
            }, 1e3);
        });
    }
    scrollSpy() {
      const e = this.scrollSpyElement.querySelectorAll(
        selectors.scrollToElement
      );
      if (!e) return;
      const t =
        document.querySelector(selectors.headerSticky) &&
        document.querySelector(selectors.headerHeight)
          ? document
              .querySelector(selectors.headerHeight)
              .getBoundingClientRect().height
          : 0;
      window.addEventListener("scroll", () => {
        const s = Math.ceil(
          document.documentElement.scrollTop || document.body.scrollTop
        );
        e.forEach((e) => {
          const i = document.querySelector(
            e.getAttribute(selectors.scrollToElementValue)
          );
          i.offsetTop - t <= s &&
            (this.scrollSpyElement
              .querySelector(`.${classes.selected}`)
              .classList.remove(classes.selected),
            this.scrollSpyElement
              .querySelector(`[${selectors.scrollToElementValue}="#${i.id}"]`)
              .classList.add(classes.selected));
        });
      });
    }
    constructor(e) {
      (this.section = e),
        (this.container = e.container),
        (this.scrollToButtons = this.container.querySelectorAll(
          selectors.scrollToElement
        )),
        (this.scrollSpyElement = this.container.querySelector(
          selectors.scrollSpy
        )),
        this.scrollToButtons.length && this.init(),
        this.scrollSpyElement && this.scrollSpy();
    }
  };
  const scrollToElement = {
    onLoad() {
      sections[this.id] = new ScrollToElement(this);
    },
  };
  register("sidebar", [accordions, scrollToElement]),
    document.addEventListener("DOMContentLoaded", function () {
      load("*");
      const e = document.querySelector("[data-scroll-top-button]");
      e &&
        (e.addEventListener("click", () => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
          });
        }),
        document.addEventListener("theme:scroll", () => {
          e.classList.toggle(
            "is-visible",
            window.pageYOffset > window.innerHeight
          );
        })),
        window.self !== window.top &&
          document.querySelector("html").classList.add("iframe"),
        "scrollBehavior" in document.documentElement.style ||
          loadScript({
            url: window.theme.assets.smoothscroll,
          });
    }),
    window.navigator.cookieEnabled &&
      (document.documentElement.className =
        document.documentElement.className.replace(
          "supports-no-cookies",
          "supports-cookies"
        ));
})(
  themeVendor.BodyScrollLock,
  themeVendor.themeAddresses,
  themeVendor.themeCurrency,
  themeVendor.Flickity,
  themeVendor.FlickityFade,
  themeVendor.Rellax,
  themeVendor.MicroModal,
  themeVendor.themeImages
);
//# sourceMappingURL=theme.js.map

$(document).on(
  "click",
  "input#click-here-and-well-send-the-card-blank-and-outside-the-boxfox-for-you-to-write-yourself",
  function () {
    const blankCard = $(this).prop("checked");
    console.log(blankCard);
    if (blankCard) {
      $('input[name="properties[To]"]').val("");
      $('input[name="properties[From]"]').val("");
      $('textarea[name="properties[Message]"]').val("");
    }
  }
);

document.addEventListener('change', e => e.target.matches('.as_url') && e.target.value && (window.location.href = e.target.value));

document.querySelectorAll('.accordion_button').forEach((button) => {
  button.addEventListener('click', () => {
    const content = button.nextElementSibling;
    const icon = button.querySelector('.accordion_icon');

    button.classList.toggle('active');
    if (button.classList.contains('active')) {
      content.style.maxHeight = content.scrollHeight + 'px';
      icon.textContent = '-';
    } else {
      content.style.maxHeight = null;
      icon.textContent = '+';
    }
  });
});